
import React, { useEffect, useState, useCallback,useRef, useMemo  } from "react";
import { useNavigate } from "react-router-dom";
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';


import {
  getAuth,
  onAuthStateChanged,
  signOut,
  updatePassword,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import {
  doc,
  getDoc,
  addDocs,
  setDoc,
  getFirestore,
  updateDoc,
  collection,
  addDoc,
  onSnapshot,
  getDocs,
  Timestamp,
  deleteDoc,
  query,
  where,
  orderBy,
} from "firebase/firestore";
import { db, secondaryAuth } from "../components/firebase-config.js";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import cld from "../components/cloudinary-config.js";
import AffiliationRequestsManager from "./AffiliationRequestsManager.js";
import { getMedecinsAffiliesToStructure } from '../utils/affiliationUtils.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  faHome,
  faUserMd,
  faUser,
  faCalendarAlt,
  faArchive,
  faLink,
  faKey,
  faBars,
  faPlus,
  faClinicMedical,
  faArrowLeft,
  faArrowRight,
  faUserPlus,
  faCalendarPlus,
  faSignOutAlt,
  faPlusCircle,
  faFilter,
  faEdit,
  faTrash,
  faClock,
  faCheck,
  faTimes,
  faExclamationTriangle,
  faFile,
  faSearch,
  faChevronLeft,
  faSort,
  faChevronRight,
  faPhone,
  faEnvelope,
  faCalendarDay,
  faCalendarWeek,
  faCalendarCheck,
  faExchangeAlt,
  faEye,
  faBolt,
  faInfoCircle,
  faSpinner,
  faSync,
  faFileAlt,
  faDownload,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faFilePdf,
  faVideo,
  faMusic,
  faList,
  faPaperclip,
  faFileImage,
  faBell,
  faEllipsisH ,
  faInbox,
  faComment,
  faReply,
  faUserNurse,
  faLock
} from "@fortawesome/free-solid-svg-icons";
import { 
  FaEnvelope, 
  FaPhone, 
  FaUser, 
  FaBuilding, 
  FaCheck, 
  FaEdit ,
  FaTimes, 
  FaEllipsisH,
  FaSearch,
  FaFilter,
  FaCalendarAlt,
  FaArrowLeft,   
   FaReply, FaPaperPlane
} from 'react-icons/fa';
import "bootstrap/dist/css/bootstrap.min.css";
import "./StructureDashboard.css";
import MobileStructuredashboard from "./MobileStructuredashboard.js"
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

import { 
  Container, 
  Row, 
  Col, 
  Card, 
  Button, 
  Modal, 
  Form, 
  Badge, 
  Offcanvas,
  ListGroup,
  Navbar,
  Nav,
  InputGroup,
  Alert,
  Tabs, Tab, 
  Spinner ,Carousel,
  Accordion
} from 'react-bootstrap';

// Ajouter la configuration Maytapi après les imports existants
const MAYTAPI_CONFIG = {
  PRODUCT_ID: "5e994f76-4f49-4057-aca4-6bef3b1de795", // À remplacer par votre Product ID Maytapi
  API_TOKEN: "a0b5ba45-b4da-429e-ba5b-127851d9b92e", // À remplacer par votre token API Maytapi
  PHONE_ID: "77695", // À remplacer par votre Phone ID Maytapi
};
// Fonction utilitaire pour envoyer des messages WhatsApp via Maytapi
const sendWhatsAppMessage = async (phoneNumber, message) => {
  try {
    console.log("⏳ Préparation de l'envoi WhatsApp...");
    console.log("📱 Numéro de téléphone:", phoneNumber);

    // Formater le numéro de téléphone pour WhatsApp si nécessaire
    if (!phoneNumber) {
      console.error("❌ Numéro de téléphone manquant!");
      return { success: false, error: "Numéro de téléphone manquant" };
    }

    let formattedNumber = phoneNumber;
    // Retirer tous les espaces, tirets et parenthèses
    formattedNumber = formattedNumber.replace(/[\s\-()]/g, "");

    // S'assurer que le numéro commence par +
    if (!formattedNumber.startsWith("+")) {
      // Si le numéro commence par un 0, le remplacer par le code pays
      if (formattedNumber.startsWith("0")) {
        formattedNumber = "+221" + formattedNumber.substring(1);
      } else {
        // Sinon, simplement ajouter le code pays
        formattedNumber = "+221" + formattedNumber;
      }
    }

    console.log("📞 Numéro formaté:", formattedNumber);
    console.log("💬 Message à envoyer:", message);

    // Vérifier la configuration Maytapi
    if (
      !MAYTAPI_CONFIG.PRODUCT_ID ||
      !MAYTAPI_CONFIG.PHONE_ID ||
      !MAYTAPI_CONFIG.API_TOKEN
    ) {
      console.error("❌ Configuration Maytapi incomplète:", MAYTAPI_CONFIG);
      return { success: false, error: "Configuration Maytapi incomplète" };
    }

    // Configurer la requête pour l'API Maytapi
    console.log("🔄 Envoi de la requête à Maytapi...");
    console.log("📊 Configuration API:", {
      productId: MAYTAPI_CONFIG.PRODUCT_ID,
      phoneId: MAYTAPI_CONFIG.PHONE_ID,
      // Ne pas logger le token API pour des raisons de sécurité
    });

    const response = await axios.post(
      `https://api.maytapi.com/api/${MAYTAPI_CONFIG.PRODUCT_ID}/${MAYTAPI_CONFIG.PHONE_ID}/sendMessage`,
      {
        to_number: formattedNumber,
        type: "text",
        message: message,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "x-maytapi-key": MAYTAPI_CONFIG.API_TOKEN,
        },
      }
    );

    console.log("✅ Réponse reçue de Maytapi:", response.data);

    if (response.status === 200 && response.data.success) {
      console.log("🎉 Message WhatsApp envoyé avec succès!");
      return { success: true, data: response.data };
    } else {
      console.error(
        "❌ Échec de l'envoi du message. Réponse API:",
        response.data
      );
      throw new Error(response.data.message || "Échec de l'envoi du message");
    }
  } catch (error) {
    console.error("❌ Erreur lors de l'envoi du message WhatsApp:", error);
    // Afficher plus de détails sur l'erreur
    if (error.response) {
      console.error("📡 Détails de la réponse d'erreur:", {
        status: error.response.status,
        data: error.response.data,
      });
    }
    return { success: false, error: error.message };
  }
};

// Fonction pour envoyer une notification de rendez-vous
const sendAppointmentNotification = async (
  appointment,
  notificationType = "confirmation"
) => {
  try {
    const { patientNom, patientTelephone, date, heure, medecinNom, motif } =
      appointment;

    // Formater la date pour une meilleure lisibilité
    const formattedDate = new Date(date).toLocaleDateString("fr-FR", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });

    let message = "";

    switch (notificationType) {
      case "confirmation":
        message = `Bonjour ${patientNom},\n\nVotre ${appointment.typeConsultation === "teleconsultation" ? "téléconsultation" : "rendez-vous"} a été confirmé pour le ${formattedDate} à ${heure} avec ${medecinNom}.\n\nMotif: ${
            motif || "Consultation"
          }${appointment.typeConsultation === "teleconsultation" ? "\n\nVous recevrez un lien pour rejoindre la consultation vidéo avant le rendez-vous." : ""}\n\nMerci de votre confiance.`;
        break;
      case "reminder":
        message = `Bonjour ${patientNom},\n\nNous vous rappelons votre rendez-vous demain ${formattedDate} à ${heure} avec ${medecinNom}.\n\nMerci de confirmer votre présence.`;
        break;
      case "cancellation":
        message = `Bonjour ${patientNom},\n\nNous vous informons que votre rendez-vous du ${formattedDate} à ${heure} avec ${medecinNom} a été annulé.\n\nVeuillez nous contacter pour plus d'informations ou pour reprogrammer.`;
        break;
      case "rescheduled":
        message = `Bonjour ${patientNom},\n\nVotre rendez-vous a été reprogrammé pour le ${formattedDate} à ${heure} avec ${medecinNom}.\n\nMotif: ${
          motif || "Consultation"
        }\n\nMerci de votre compréhension.`;
        break;
      default:
        message = `Bonjour ${patientNom},\n\nInformation concernant votre rendez-vous du ${formattedDate} à ${heure} avec ${medecinNom}.\n\nMerci de nous contacter pour plus de détails.`;
    }

    // Envoyer le message WhatsApp
    return await sendWhatsAppMessage(patientTelephone, message);
  } catch (error) {
    console.error(
      "Erreur lors de l'envoi de la notification de rendez-vous:",
      error
    );
    return { success: false, error: error.message };
  }
};

const StructureDashboard = () => {
  const [structureData, setStructureData] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [form, setForm] = useState({});
  const [activeTab, setActiveTab] = useState("rendezvous");
  const [medecins, setMedecins] = useState([]);
  const [patients, setPatients] = useState([]);
  const [rendezvous, setRendezvous] = useState([]);
  const [showMedecinForm, setShowMedecinForm] = useState(false);
  const [showPatientForm, setShowPatientForm] = useState(false);
  const [showRendezvousForm, setShowRendezvousForm] = useState(false);
  const [currentMedecin, setCurrentMedecin] = useState(null);
  const [structureInfo , setStructureInfo] = useState(null);
  const [currentPatient, setCurrentPatient] = useState(null);
const [currentView, setCurrentView] = useState(null);
  const [currentRendezvous, setCurrentRendezvous] = useState(null);
    // Ajouter ces états au début du composant
// Ajouter ces états au début du composant
const [medecinSearchQuery, setMedecinSearchQuery] = useState("");
const [patientSearchQuery, setPatientSearchQuery] = useState("");

// Ajouter ces fonctions de filtrage
const filtreMedecins = useMemo(() => {
  if (!medecinSearchQuery) return medecins;
  
  const query = medecinSearchQuery.toLowerCase();
  return medecins.filter(
    medecin => 
      medecin.nom?.toLowerCase().includes(query) ||
      medecin.specialite?.toLowerCase().includes(query)
  );
}, [medecins, medecinSearchQuery]);

const filtrePatients = useMemo(() => {
  if (!patientSearchQuery) return patients;
  
  const query = patientSearchQuery.toLowerCase();
  return patients.filter(
    patient => 
      patient.nom?.toLowerCase().includes(query)   );
}, [patients, patientSearchQuery]);




  const [filtreDate, setFiltreDate] = useState(() => {
    const today = new Date();
    return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(today.getDate()).padStart(2, "0")}`;
  });
// État à ajouter à votre composant StructureDashboard
const [auxiliaires, setAuxiliaires] = useState([]);
const [showAuxiliaireModal, setShowAuxiliaireModal] = useState(false);
const [currentAuxiliaire, setCurrentAuxiliaire] = useState(null);
const [auxiliaireForm, setAuxiliaireForm] = useState({
  nom: "",
  email: "",
  telephone: "",
  role: "assistant", // assistant, secrétaire, etc.
  medecinIds: [], // IDs des médecins auxquels l'auxiliaire est assigné
  permissions: {
    ajouterPatients: false,
    ajouterRendezVous: false,
    voirTousLesRendezVous: false
  },
  horaires: {
    lundi: { actif: false, debut: "08:00", fin: "18:00" },
    mardi: { actif: false, debut: "08:00", fin: "18:00" },
    mercredi: { actif: false, debut: "08:00", fin: "18:00" },
    jeudi: { actif: false, debut: "08:00", fin: "18:00" },
    vendredi: { actif: false, debut: "08:00", fin: "18:00" },
    samedi: { actif: false, debut: "08:00", fin: "18:00" },
    dimanche: { actif: false, debut: "08:00", fin: "18:00" }
  }
});

  const [filtreMedecin, setFiltreMedecin] = useState("");
  const [archives, setArchives] = useState([]);
  const [showArchiveForm, setShowArchiveForm] = useState(false);
  const [currentArchive, setCurrentArchive] = useState(null);
  const [archiveFiles, setArchiveFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [filtreArchivePatient, setFiltreArchivePatient] = useState("");
  const [pendingRequests, setPendingRequests] = useState([]);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 999);

  // Ajout d'un état pour suivre les nouvelles demandes
  const [newDemandesCount, setNewDemandesCount] = useState(0);

  // Fonction pour générer un mot de passe aléatoire
  const generateRandomPassword = (length = 6) => {
    const charset =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";
    let password = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset[randomIndex];
    }

    return password;
  };

  // État du formulaire d'archive
  const [archiveForm, setArchiveForm] = useState({
    patientId: "",
    titre: "",
    description: "",
    notes: "",
    date: new Date().toISOString().split("T")[0],
    tags: [],
    files: [],
  });

  // Constantes
  const tagsList = [
    "Consultation",
    "Examen",
    "Ordonnance",
    "Analyse",
    "Radiologie",
    "Hospitalisation",
    "Chirurgie",
    "Suivi",
    "Autre",
  ];
  const storage = getStorage();

  const [medecinForm, setMedecinForm] = useState({
    nom: "",
    specialite: "",
    telephone: "",
    email: "",
    disponibilites: {
      lundi: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
      mardi: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
      mercredi: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
      jeudi: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
      vendredi: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
      samedi: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
      dimanche: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
    },
    assurances: [],
  });

  // État du formulaire patient
  const [patientForm, setPatientForm] = useState({
    nom: "",
    dateNaissance: "",
    email: "",
    password: "",
    telephone: "",
    assurances: [],
    diagnostics: "", // Ajout du champ diagnostics
  });

  // État du formulaire rendez-vous
  const [rdvForm, setRdvForm] = useState({
    medecinId: "",
    patientId: "",
    date: new Date().toISOString().split("T")[0],
    heure: "08:00",
    duree: 5,
    motif: "",
    statut: "confirmé",
    typeConsultation: "presentiel", // Valeur par défaut pour le type de consultation
  });

  // Constantes
  const specialites = [
    "Généraliste",
    "Cardiologie",
    "Réadaptation Cardiovasculaire",
    "Chirurgie Cardio-Vasculaire",
    "Pneumologie - Spirométrie",
    "Gastro-Entérologie & Endoscopie Digestive",
    "Pédiatrie - Endocrinologie",
    "Nutrition - Nutrithérapie",
    "Diabétologie",
    "Gynécologie",
    "Anesthésie & Réanimation",
    "Dermatologie",
    "Rhumatologie",
    "Cancérologie",
    "Hématologie",
    "Urologie",
    "Orthopédie",
    "Gériatrie",
    "Médecine Physique & Rééducation",
    "Ostéopathie",
    "Laboratoire d'Analyses Médicales",
    "Échographie",
    "Psychiatrie & Addictologie",
    "Psychologie Clinique",
    "Thérapie Capillaire et Cognitivo-Comportementale",
    "Kinésithérapie",
    "Sport de Remise en Forme / Yoga",
    "Ophtalmologie générale",
    "Chirurgie réfractive",
    "Chirurgie de la cataracte",
    "Rétinologie",
    "Glaucome",
    "Ophtalmologie pédiatrique",
    "Neuro-ophtalmologie",
    "Cornée et surface oculaire",
    "Contactologie",
    "Autre",
  ];

  const assurancesList = [
    "CNAM",
    "CNSS",
    "CNRPS",
    "Assurance privée",
    "Autre",
    "Sanlam",
    "AXA",
    "NSIA",
    "Saham Assurance",
    "Leadway Assurance",
    "Mutuelle des Fonctionnaires",
    "SONAM",
    "Allianz",
    "Liberty Mutual",
    "Activa Assurance",
    "SUNU Assurances",
    "GA Insurance",
    "MUA Insurance",
    "Fidelity Insurance",
    "Old Mutual",
    "Hollard Insurance",
    "Ecobank Assurances",
    "Prudential",
    "Afric Assistance",
    "ASKIA Assurances",
    "BICIS Assurances",
    "UGB Assurance",
    "AMO Assurance",
  ];

  const joursSemaine = [
    "lundi",
    "mardi",
    "mercredi",
    "jeudi",
    "vendredi",
    "samedi",
    "dimanche",
  ];
  const statutsRdv = ["confirmé", "terminé", "annulé"];
  const dureesRdv = [15, 30, 45, 60, 90, 120];

  // États pour la vue calendrier
  const [calendarView, setCalendarView] = useState("month");
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const [showDateModal, setShowDateModal] = useState(false);
  const [showMedecinRdvModal, setShowMedecinRdvModal] = useState(false);
  const [selectedMedecinId, setSelectedMedecinId] = useState(null);
  const [showRdvDetailsModal, setShowRdvDetailsModal] = useState(false);
  const [selectedRdv, setSelectedRdv] = useState(null);
  const [draggedRdv, setDraggedRdv] = useState(null);
  const [allStructures, setAllStructures] = useState([]);
  const fetchAllStructures = async () => {
    try {
      const structuresSnapshot = await getDocs(collection(db, "structures"));
      const structuresList = structuresSnapshot.docs.map(doc => ({
        id: doc.id,
        nom: doc.data().nom || doc.data().name || "Structure sans nom",
        ...doc.data()
      }));
      setAllStructures(structuresList);
    } catch (error) {
      console.error("Erreur lors du chargement des structures:", error);
      setMessage(`Erreur: ${error.message}`);
    }
  };

  // Variables d'état pour l'interface mobile
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showMobileActionMenu, setShowMobileActionMenu] = useState(false);
  const [mobileDetailView, setMobileDetailView] = useState(null);
  const [mobileSearchActive, setMobileSearchActive] = useState(false);
  const [mobileSearchQuery, setMobileSearchQuery] = useState("");
  const [showAddForm, setShowAddForm] = useState(false);
  const [showMedecinRdvs, setShowMedecinRdvs] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const [quickRequests, setQuickRequests] = useState([]);
  const [showQuickRequestsModal, setShowQuickRequestsModal] = useState(false);
  const [selectedQuickRequest, setSelectedQuickRequest] = useState(null);
  const [assignMedecinModal, setAssignMedecinModal] = useState(false);
  const [selectedMedecinForQuick, setSelectedMedecinForQuick] = useState("");
  const [quickRequestsCount, setQuickRequestsCount] = useState(0);

  const [selectedFile, setSelectedFile] = useState(null);
  const [showFilePreview, setShowFilePreview] = useState(false);
  const [loading, setLoading] = useState(false);

  const [demandesRapides, setDemandesRapides] = useState([]);
  const [activeTabRdv, setActiveTabRdv] = useState("attente");
  const [demandesAcceptees, setDemandesAcceptees] = useState([]);
  const [loadingAcceptees, setLoadingAcceptees] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [pendingDoctorRequests, setPendingDoctorRequests] = useState([]);
  const [affiliationRequests, setAffiliationRequests] = useState([]);
  const [contactRequests, setContactRequests] = useState([]);
  const [realtimeStatus, setRealtimeStatus] = useState({
    connected: false,
    lastUpdate: null,
    activeListeners: 0
  });

  const navigate = useNavigate();
  const auth = getAuth();

  // Écouteur pour les nouvelles demandes
  const unsubscribeDemandes = onSnapshot(
    query(collection(db, "contacts"), where("status", "==", "pending")),
    (snapshot) => {
      // Mettre à jour le compteur des nouvelles demandes
      setNewDemandesCount(snapshot.size);
    },
    (error) => {
      console.error("Erreur lors de l'écoute des nouvelles demandes:", error);
    }
  );

  // Gestion de la taille de l'écran
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 999);
      if (window.innerWidth < 999) {
        setSidebarCollapsed(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Remplacer les fonctions fetch par des écouteurs temps réel
  const setupRealtimeListeners = (structureId) => {
    const unsubscribeFunctions = [];
    
    // Fonction pour mettre à jour le statut de connexion temps réel
    const updateRealtimeStatus = (type, count = null) => {
      setRealtimeStatus(prev => ({
        ...prev,
        connected: true,
        lastUpdate: new Date(),
        activeListeners: unsubscribeFunctions.length + 1 // +1 car ce listener n'est pas encore ajouté au tableau
      }));
    };

    // Écouteur pour les médecins
    const unsubscribeMedecins = onSnapshot(
      query(
        collection(db, "medecins"),
        where("structureId", "==", structureId)
      ),
      (snapshot) => {
        const medecinsData = [];
        snapshot.forEach((doc) => {
          medecinsData.push({ id: doc.id, ...doc.data() });
        });
        setMedecins(medecinsData);
        updateRealtimeStatus('medecins', medecinsData.length);
        console.log("📋 Médecins mis à jour en temps réel:", medecinsData.length);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des médecins:", error);
        setMessage(`Erreur: ${error.message}`);
      }
    );
    unsubscribeFunctions.push(unsubscribeMedecins);

    // Écouteur pour les patients
    const unsubscribePatients = onSnapshot(
      query(
        collection(db, "patients"),
        where("structureId", "==", structureId)
      ),
      (snapshot) => {
        const patientsData = [];
        snapshot.forEach((doc) => {
          patientsData.push({ id: doc.id, ...doc.data() });
        });
        setPatients(patientsData);
        updateRealtimeStatus('patients', patientsData.length);
        console.log("👥 Patients mis à jour en temps réel:", patientsData.length);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des patients:", error);
        setMessage(`Erreur: ${error.message}`);
      }
    );
    unsubscribeFunctions.push(unsubscribePatients);

    // Écouteur pour les rendez-vous
    const unsubscribeRendezvous = onSnapshot(
      query(
        collection(db, "rendezvous"),
        where("structureId", "==", structureId)
      ),
      (snapshot) => {
        const rdvData = [];
        snapshot.forEach((doc) => {
          const rdv = doc.data();
          if (rdv.date) {
            const dateObj = new Date(rdv.date);
            if (!isNaN(dateObj.getTime())) {
              rdv.date = formatDateString(dateObj);
            }
          }
          rdvData.push({ id: doc.id, ...rdv });
        });
        setRendezvous(rdvData);
        updateRealtimeStatus('rendezvous', rdvData.length);
        console.log("📅 Rendez-vous mis à jour en temps réel:", rdvData.length);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des rendez-vous:", error);
        setMessage(`Erreur: ${error.message}`);
      }
    );
    unsubscribeFunctions.push(unsubscribeRendezvous);

    // Écouteur pour les demandes rapides
    const unsubscribeQuickRequests = onSnapshot(
      query(
        collection(db, "quickAppointments"),
        where("structureId", "==", structureId),
        where("status", "==", "pending")
      ),
      (snapshot) => {
        const requests = [];
        snapshot.forEach((doc) => {
          requests.push({ id: doc.id, ...doc.data() });
        });
        setQuickRequests(requests);
        setQuickRequestsCount(requests.length);
        console.log("⚡ Demandes rapides mises à jour en temps réel:", requests.length);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des demandes rapides:", error);
      }
    );
    unsubscribeFunctions.push(unsubscribeQuickRequests);

    // Écouteur pour les demandes d'affiliation des médecins
    const unsubscribeAffiliationRequests = onSnapshot(
      query(
        collection(db, "affiliationRequests"),
        where("structureId", "==", structureId),
        where("status", "==", "pending")
      ),
      (snapshot) => {
        const requests = [];
        snapshot.forEach((doc) => {
          requests.push({ id: doc.id, ...doc.data() });
        });
        setPendingDoctorRequests(requests);
        console.log("🔗 Demandes d'affiliation médecins mises à jour:", requests.length);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des demandes d'affiliation:", error);
      }
    );
    unsubscribeFunctions.push(unsubscribeAffiliationRequests);

    // Écouteur pour les demandes d'affiliation des patients
    const unsubscribePatientAffiliations = onSnapshot(
      query(
        collection(db, "affiliations"),
        where("structureId", "==", structureId),
        where("statut", "==", "en attente")
      ),
      (snapshot) => {
        const requests = [];
        snapshot.forEach((doc) => {
          requests.push({ id: doc.id, ...doc.data() });
        });
        setAffiliationRequests(requests);
        console.log("👤 Demandes d'affiliation patients mises à jour:", requests.length);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des affiliations patients:", error);
      }
    );
    unsubscribeFunctions.push(unsubscribePatientAffiliations);

    // Écouteur pour les archives
    const unsubscribeArchives = onSnapshot(
      query(
        collection(db, "archives"),
        where("structureId", "==", structureId)
      ),
      (snapshot) => {
        const archivesData = [];
        snapshot.forEach((doc) => {
          archivesData.push({ id: doc.id, ...doc.data() });
        });
        setArchives(archivesData);
        console.log("📚 Archives mises à jour en temps réel:", archivesData.length);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des archives:", error);
        setMessage(`Erreur: ${error.message}`);
      }
    );
    unsubscribeFunctions.push(unsubscribeArchives);

    // Écouteur pour les auxiliaires
    const unsubscribeAuxiliaires = onSnapshot(
      query(
        collection(db, "auxiliaires"),
        where("structureId", "==", structureId)
      ),
      (snapshot) => {
        const auxiliairesData = [];
        snapshot.forEach((doc) => {
          auxiliairesData.push({ id: doc.id, ...doc.data() });
        });
        setAuxiliaires(auxiliairesData);
        console.log("🏥 Auxiliaires mis à jour en temps réel:", auxiliairesData.length);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des auxiliaires:", error);
        setMessage(`Erreur: ${error.message}`);
      }
    );
    unsubscribeFunctions.push(unsubscribeAuxiliaires);

    // Écouteur pour les demandes de contact
    const unsubscribeContactRequests = onSnapshot(
      query(
        collection(db, "contactRequests"),
        where("structureId", "==", structureId),
        orderBy("createdAt", "desc")
      ),
      (snapshot) => {
        const requests = [];
        snapshot.forEach((doc) => {
          requests.push({ id: doc.id, ...doc.data() });
        });
        setContactRequests(requests);
        console.log("📞 Demandes de contact mises à jour:", requests.length);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des demandes de contact:", error);
      }
    );
    unsubscribeFunctions.push(unsubscribeContactRequests);

    // Écouteur pour les rendez-vous du jour (notifications)
    const today = new Date();
    const todayString = today.toISOString().split('T')[0];
    const unsubscribeTodayAppointments = onSnapshot(
      query(
        collection(db, "rendezvous"),
        where("structureId", "==", structureId),
        where("date", "==", todayString),
        where("statut", "in", ["confirmé", "en attente"])
      ),
      (snapshot) => {
        const todayRdvs = [];
        snapshot.forEach((doc) => {
          todayRdvs.push({ id: doc.id, ...doc.data() });
        });
        
        // Calculer les statistiques en temps réel
        const confirmés = todayRdvs.filter(rdv => rdv.statut === "confirmé").length;
        const enAttente = todayRdvs.filter(rdv => rdv.statut === "en attente").length;
        
        console.log(`📊 Rendez-vous aujourd'hui - Confirmés: ${confirmés}, En attente: ${enAttente}`);
        
        // Notification pour les rendez-vous approchant (dans 1 heure)
        const upcomingRdvs = todayRdvs.filter(rdv => {
          const rdvTime = new Date(`${rdv.date}T${rdv.heure}`);
          const now = new Date();
          const diffMs = rdvTime.getTime() - now.getTime();
          const diffHours = diffMs / (1000 * 60 * 60);
          return diffHours > 0 && diffHours <= 1;
        });
        
        if (upcomingRdvs.length > 0) {
          console.log(`⏰ ${upcomingRdvs.length} rendez-vous dans l'heure qui vient`);
        }
      },
      (error) => {
        console.error("Erreur lors de l'écoute des RDV du jour:", error);
      }
    );
    unsubscribeFunctions.push(unsubscribeTodayAppointments);

    // Écouteur pour les nouvelles demandes (notifications)
    const unsubscribeNewRequests = onSnapshot(
      query(
        collection(db, "quickAppointments"),
        where("structureId", "==", structureId),
        where("status", "==", "pending"),
        where("createdAt", ">=", Timestamp.fromDate(new Date(Date.now() - 24 * 60 * 60 * 1000))) // Dernières 24h
      ),
      (snapshot) => {
        const newRequests = [];
        snapshot.forEach((doc) => {
          const data = doc.data();
          if (data.createdAt && data.createdAt.toDate() > new Date(Date.now() - 5 * 60 * 1000)) {
            // Nouvelles demandes dans les 5 dernières minutes
            newRequests.push({ id: doc.id, ...data });
          }
        });
        
        if (newRequests.length > 0) {
          console.log(`🔔 ${newRequests.length} nouvelle(s) demande(s) de rendez-vous`);
          showNotification(
            `${newRequests.length} nouvelle(s) demande(s) de rendez-vous reçue(s)`,
            "info"
          );
        }
      },
      (error) => {
        console.error("Erreur lors de l'écoute des nouvelles demandes:", error);
      }
    );
    unsubscribeFunctions.push(unsubscribeNewRequests);

    // Retourner une fonction de nettoyage pour tous les écouteurs
    return () => {
      console.log("🧹 Nettoyage des écouteurs temps réel...");
      setRealtimeStatus(prev => ({
        ...prev,
        connected: false,
        activeListeners: 0
      }));
      
      unsubscribeFunctions.forEach((unsubscribe, index) => {
        try {
          unsubscribe();
        } catch (error) {
          console.error(`Erreur lors du nettoyage de l'écouteur ${index}:`, error);
        }
      });
    };
  };

  // Modifier le useEffect principal pour utiliser les écouteurs temps réel
  useEffect(() => {
    let unsubscribeListeners = null;
    let unsubscribeStructure = null;

    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUser(user);
        
        // Écouteur en temps réel pour les données de la structure
        unsubscribeStructure = onSnapshot(
          doc(db, "structures", user.uid),
          (docSnap) => {
            if (docSnap.exists()) {
              const structureData = docSnap.data();
              setStructureData(structureData);
              setForm(structureData);
              console.log("🏢 Données de structure mises à jour en temps réel");
              
              // Mettre en place les écouteurs temps réel pour les autres collections
              if (!unsubscribeListeners) {
                unsubscribeListeners = setupRealtimeListeners(user.uid);
                // Initialiser le statut comme connecté après configuration
                setTimeout(() => {
                  setRealtimeStatus(prev => ({
                    ...prev,
                    connected: true,
                    lastUpdate: new Date(),
                    activeListeners: 9 // Nombre d'écouteurs configurés
                  }));
                }, 1000);
              }
            } else {
              console.error("Document de structure non trouvé");
              navigate("/auth");
            }
          },
          (error) => {
            console.error("Erreur lors de l'écoute de la structure:", error);
            navigate("/auth");
          }
        );
      } else {
        navigate("/auth");
      }
    });

    // Nettoyer tous les écouteurs lors du démontage
    return () => {
      console.log("🧹 Nettoyage complet des listeners du dashboard...");
      if (unsubscribeAuth) unsubscribeAuth();
      if (unsubscribeStructure) unsubscribeStructure();
      if (unsubscribeListeners) unsubscribeListeners();
    };
  }, [auth, navigate]);

  // Fonction pour déterminer le type de contenu d'un fichier
  const getFileType = (file) => {
    if (!file || !file.url) return "unknown";

    const url = file.url.toLowerCase();
    if (url.match(/\.(jpeg|jpg|png|gif|webp)$/)) return "image";
    if (url.match(/\.(pdf)$/)) return "pdf";
    if (url.match(/\.(mp4|webm|mov)$/)) return "video";
    if (url.match(/\.(mp3|wav|ogg)$/)) return "audio";
    if (url.match(/\.(doc|docx)$/)) return "word";
    if (url.match(/\.(xls|xlsx)$/)) return "excel";
    if (url.match(/\.(ppt|pptx)$/)) return "powerpoint";
    if (url.match(/\.(txt)$/)) return "text";
    return "other";
  };

  // Fonction pour l'aperçu des fichiers
  const renderFilePreview = (file) => {
    const fileType = getFileType(file);

    switch (fileType) {
      case "image":
        return (
          <img
            src={file.url}
            alt={file.name}
            className="img-fluid mx-auto d-block"
            style={{ maxHeight: "70vh" }}
          />
        );
      case "pdf":
        return (
          <div className="text-center">
            <iframe
              src={file.url}
              width="100%"
              height="500"
              className="border-0"
              title={file.name}
            ></iframe>
          </div>
        );
      case "video":
        return (
          <div className="text-center">
            <video
              src={file.url}
              controls
              className="img-fluid"
              style={{ maxHeight: "70vh" }}
            />
          </div>
        );
      case "audio":
        return (
          <div className="text-center mt-4">
            <audio src={file.url} controls className="w-100" />
          </div>
        );
      default:
        return (
          <div className="text-center p-5">
            <div className="display-1 mb-3">
              <FontAwesomeIcon
                icon={
                  fileType === "word"
                    ? faFileWord
                    : fileType === "excel"
                    ? faFileExcel
                    : fileType === "powerpoint"
                    ? faFilePowerpoint
                    : faFile
                }
              />
            </div>
            <h4>{file.name}</h4>
            <p className="text-muted mb-4">
              Ce type de fichier ne peut pas être prévisualisé
            </p>
            <Button
              variant="primary"
              href={file.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faDownload} className="me-2" />
              Télécharger
            </Button>
          </div>
        );
    }
  };
  // Récupérer les demandes d'affiliation en attente
  const fetchPendingRequests = async (structureId) => {
    try {
      // Récupérer les demandes d'affiliation des médecins
      const medecinRequestsQuery = query(
        collection(db, "affiliationRequests"),
        where("structureId", "==", structureId),
        where("status", "==", "pending")
      );
      const medecinSnapshot = await getDocs(medecinRequestsQuery);
      const medecinRequests = [];
      medecinSnapshot.forEach((doc) => {
        medecinRequests.push({ id: doc.id, ...doc.data() });
      });
      setPendingDoctorRequests(medecinRequests);
  
      // Récupérer les demandes d'affiliation des patients
      const patientRequestsQuery = query(
        collection(db, "affiliations"),
        where("structureId", "==", structureId),
        where("statut", "==", "en attente")
      );
      const patientSnapshot = await getDocs(patientRequestsQuery);
      const patientRequests = [];
      patientSnapshot.forEach((doc) => {
        patientRequests.push({ id: doc.id, ...doc.data() });
      });
      setAffiliationRequests(patientRequests);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des demandes d'affiliation:",
        error
      );
      setMessage(`Erreur: ${error.message}`);
    }
  };
  

  const fetchArchives = async (structureId) => {
    try {
      const q = query(
        collection(db, "archives"),
        where("structureId", "==", structureId)
      );
      const querySnapshot = await getDocs(q);
      const archivesData = [];
      querySnapshot.forEach((doc) => {
        archivesData.push({ id: doc.id, ...doc.data() });
      });
      setArchives(archivesData);
    } catch (error) {
      setMessage(`Erreur lors du chargement des archives: ${error.message}`);
    }
  };

  const getFirstDayOfMonth = (year, month) => {
    return new Date(year, month, 1).getDay();
  };

  const getMonthData = useCallback(() => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();

    const daysInMonth = getDaysInMonth(year, month);
    const firstDayOfMonth = getFirstDayOfMonth(year, month);

    const days = [];

    // Ajouter les jours du mois précédent pour compléter la première semaine
    const prevMonthDays = getDaysInMonth(year, month - 1);
    for (let i = firstDayOfMonth - 1; i >= 0; i--) {
      const date = new Date(year, month - 1, prevMonthDays - i);
      const dateString = formatDateString(date);
      days.push({
        date: date,
        isCurrentMonth: false,
        hasEvents: false,
        events: [],
        dateString: dateString,
      });
    }

    // Ajouter les jours du mois courant
    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(year, month, i);
      const dateString = formatDateString(date);

      // Vérifier les rendez-vous pour cette date
      const dayEvents = rendezvous.filter((rdv) => {
        // S'assurer que les dates sont comparées dans le même format
        return rdv.date === dateString;
      });

      // Obtenir les médecins uniques qui ont des rendez-vous ce jour
      const uniqueMedecins = [
        ...new Set(dayEvents.map((rdv) => rdv.medecinId)),
      ];

      days.push({
        date: date,
        isCurrentMonth: true,
        hasEvents: dayEvents.length > 0,
        events: dayEvents,
        medecinCount: uniqueMedecins.length,
        dateString: dateString,
      });
    }

    // Ajouter les jours du mois suivant pour compléter la dernière semaine
    const totalDaysToShow = 42; // 6 semaines
    const remainingDays = totalDaysToShow - days.length;
    for (let i = 1; i <= remainingDays; i++) {
      const date = new Date(year, month + 1, i);
      const dateString = formatDateString(date);
      days.push({
        date: date,
        isCurrentMonth: false,
        hasEvents: false,
        events: [],
        dateString: dateString,
      });
    }

    return days;
  }, [currentMonth, rendezvous]);

  const formatDateString = (date) => {
    if (!date) return "";

    // S'assurer que date est un objet Date
    const dateObj = date instanceof Date ? date : new Date(date);

    // Vérifier si la date est valide
    if (isNaN(dateObj.getTime())) {
      console.error("Date invalide:", date);
      return "";
    }

    // Format YYYY-MM-DD
    return `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(dateObj.getDate()).padStart(2, "0")}`;
  };

  // Fonction pour afficher la date en format lisible (DD/MM/YYYY)
  const formatDate = (date) => {
    if (!date) return "";

    // S'assurer que date est un objet Date
    const dateObj = date instanceof Date ? date : new Date(date);

    // Vérifier si la date est valide
    if (isNaN(dateObj.getTime())) {
      console.error("Date invalide:", date);
      return "";
    }

    // Format DD/MM/YYYY
    return `${String(dateObj.getDate()).padStart(2, "0")}/${String(
      dateObj.getMonth() + 1
    ).padStart(2, "0")}/${dateObj.getFullYear()}`;
  };

  // Récupération des données
  const fetchMedecins = async (structureId) => {
    try {
      const medecinsAffilies = await getMedecinsAffiliesToStructure(structureId);
      setMedecins(medecinsAffilies);
    } catch (error) {
      setMessage(`Erreur lors du chargement des médecins: ${error.message}`);
    }
  };

  const fetchPatients = async (structureId) => {
    try {
      const q = query(
        collection(db, "patients"),
        where("structureId", "==", structureId)
      );
      const querySnapshot = await getDocs(q);
      const patientsData = [];
      querySnapshot.forEach((doc) => {
        patientsData.push({ id: doc.id, ...doc.data() });
      });
      setPatients(patientsData);
    } catch (error) {
      setMessage(`Erreur lors du chargement des patients: ${error.message}`);
    }
  };

  const fetchRendezvous = async (structureId) => {
    try {
      const q = query(
        collection(db, "rendezvous"),
        where("structureId", "==", structureId)
      );
      const querySnapshot = await getDocs(q);
      const rdvData = [];

      for (const doc of querySnapshot.docs) {
        const rdv = doc.data();
        const formattedRdv = {
          id: doc.id,
          ...rdv,
          // Formater la date si elle existe
          date: rdv.date ? formatDateString(new Date(rdv.date)) : "",
          // S'assurer que les noms sont correctement formatés
          medecinNom: rdv.medecinNom || "Non assigné",
          patientNom: rdv.patientNom || "Patient inconnu",
          // Ajouter des champs par défaut si manquants
          duree: rdv.duree || "30",
          motif: rdv.motif || "Consultation",
          statut: rdv.statut || "en attente",
          // Formater les timestamps
          createdAt: rdv.createdAt
            ? new Date(rdv.createdAt.toDate()).toLocaleString()
            : "",
          updatedAt: rdv.updatedAt
            ? new Date(rdv.updatedAt.toDate()).toLocaleString()
            : "",
        };

        // Si le rendez-vous provient d'une demande rapide, s'assurer que toutes les informations sont présentes
        if (rdv.source === "quick") {
          formattedRdv.patientEmail = rdv.patientEmail || rdv.email || "";
          formattedRdv.patientTelephone =
            rdv.patientTelephone || rdv.telephone || "";
          formattedRdv.verificationCode = rdv.verificationCode || "";
        }

        rdvData.push(formattedRdv);
      }

      setRendezvous(rdvData);
    } catch (error) {
      setMessage(
        `Erreur lors de la récupération des rendez-vous: ${error.message}`
      );
    }
  };






  // Fonctions générales
  const handleLogout = async () => {
    await signOut(auth);
    navigate("/auth");
  };

  const handleUpdate = async () => {
    try {
      const user = auth.currentUser;
      await updateDoc(doc(db, "structures", user.uid), form);
      setMessage("Informations mises à jour avec succès.");

      // Afficher le message puis le faire disparaître après 3 secondes
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      setMessage(error.message);
    }
  };

  const handlePasswordChange = async () => {
    try {
      const user = auth.currentUser;
      await updatePassword(user, newPassword);
      setMessage("Mot de passe mis à jour avec succès.");
      setNewPassword("");

      // Afficher le message puis le faire disparaître après 3 secondes
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      setMessage(error.message);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Gestion des formulaires d'archive
  const handleArchiveChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "tags") {
      const updatedArray = [...archiveForm.tags];
      if (checked) {
        updatedArray.push(value);
      } else {
        const index = updatedArray.indexOf(value);
        if (index > -1) {
          updatedArray.splice(index, 1);
        }
      }
      setArchiveForm({ ...archiveForm, [name]: updatedArray });
    } else {
      setArchiveForm({ ...archiveForm, [name]: value });
    }
  };

  const resetArchiveForm = () => {
    setArchiveForm({
      patientId: "",
      titre: "",
      description: "",
      notes: "",
      date: new Date().toISOString().split("T")[0],
      tags: [],
      files: [],
    });
    setSelectedFiles([]);
    setCurrentArchive(null);
  };

  const handleFileChange = (e) => {
    if (e.target.files) {
      setSelectedFiles(Array.from(e.target.files));
    }
  };

  const handleAddArchive = async (e) => {
    e.preventDefault();
    try {
      const user = auth.currentUser;
      const fileUrls = [];

      // Uploader les fichiers sélectionnés avec Cloudinary
      if (selectedFiles.length > 0) {
        for (const file of selectedFiles) {
          // Créer un FormData pour l'upload vers Cloudinary
          const formData = new FormData();
          formData.append("file", file);
          formData.append("upload_preset", "fichiers");
          formData.append("folder", `archives/${user.uid}`);

          // Envoyer le fichier à Cloudinary
          const response = await fetch(
            `https://api.cloudinary.com/v1_1/dodsr1s0d/upload`,
            {
              method: "POST",
              body: formData,
            }
          );

          const data = await response.json();

          if (response.ok) {
            fileUrls.push({
              id: data.public_id,
              name: file.name,
              type: file.type,
              size: file.size,
              url: data.secure_url,
              public_id: data.public_id,
              uploadedAt: new Date(),
            });
          } else {
            throw new Error(
              `Erreur lors du téléversement: ${
                data.error?.message || "Erreur inconnue"
              }`
            );
          }
        }
      }

      // Récupérer les informations du patient
      const patient = patients.find((p) => p.id === archiveForm.patientId);

      const archiveData = {
        ...archiveForm,
        patientNom: patient ? `$ ${patient.nom}` : "",
        files: currentArchive ? [...archiveForm.files, ...fileUrls] : fileUrls,
        structureId: user.uid,
        createdAt: new Date(),
      };

      if (currentArchive) {
        // Mise à jour d'une archive existante
        await updateDoc(doc(db, "archives", currentArchive.id), {
          ...archiveData,
          updatedAt: new Date(),
        });
      } else {
        // Création d'une nouvelle archive
        await addDoc(collection(db, "archives"), archiveData);
      }

      resetArchiveForm();
      setShowArchiveForm(false);
      setMessage(
        "Archive " +
          (currentArchive ? "mise à jour" : "ajoutée") +
          " avec succès."
      );

      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };

  const handleEditArchive = (archive) => {
    setCurrentArchive(archive);
    setArchiveForm({
      patientId: archive.patientId || "",
      titre: archive.titre || "",
      description: archive.description || "",
      notes: archive.notes || "",
      date: archive.date || new Date().toISOString().split("T")[0],
      tags: archive.tags || [],
      files: archive.files || [],
    });
    setShowArchiveForm(true);
  };

  const handleDeleteArchive = async (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cette archive ?")) {
      try {
        // Récupérer l'archive pour obtenir les chemins des fichiers
        const archiveDoc = await getDoc(doc(db, "archives", id));
        const archiveData = archiveDoc.data();

        // Supprimer les fichiers du stockage
        if (archiveData.files && archiveData.files.length > 0) {
          for (const file of archiveData.files) {
            if (file.path) {
              const fileRef = ref(storage, file.path);
              await deleteObject(fileRef);
            }
          }
        }

        // Supprimer le document de l'archive
        await deleteDoc(doc(db, "archives", id));
        setMessage("Archive supprimée avec succès.");

        setTimeout(() => setMessage(""), 3000);
      } catch (error) {
        setMessage(`Erreur: ${error.message}`);
      }
    }
  };

  const handleDeleteFile = async (archiveId, file, fileIndex) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce fichier ?")) {
      try {
        setLoading(true);

        // Si le fichier est sur Cloudinary (a un public_id)
        if (file.public_id) {
          // Utiliser l'API de destruction sécurisée de Cloudinary
          const timestamp = Math.round(new Date().getTime() / 1000);
          const apiKey = "328927441826894";

          // Note: Ceci est une requête de suppression simplifiée, en production utilisez
          // un backend pour générer la signature et effectuer l'appel de manière sécurisée
          const response = await fetch("/api/cloudinary/delete", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              public_id: file.public_id,
            }),
          });

          // Si nous n'avons pas d'API backend, nous mettons à jour quand même Firestore
          if (!response.ok) {
            console.warn(
              "Impossible de supprimer le fichier de Cloudinary directement, mise à jour de la base de données uniquement"
            );
          }
        }
        // Si le fichier est sur Firebase Storage (a un path)
        else if (file.path) {
          try {
            // Supprimer le fichier du stockage Firebase
            const fileRef = ref(storage, file.path);
            await deleteObject(fileRef);
          } catch (storageError) {
            console.error(
              "Erreur lors de la suppression du fichier dans Firebase Storage:",
              storageError
            );
            // Continuer quand même avec la mise à jour de Firestore
          }
        }

        // Mettre à jour le document de l'archive dans Firestore
        const archiveRef = doc(db, "archives", archiveId);
        const archiveDoc = await getDoc(archiveRef);

        if (archiveDoc.exists()) {
          const archiveData = archiveDoc.data();
          const updatedFiles = [...archiveData.files];

          // Supprimer le fichier de la liste
          updatedFiles.splice(fileIndex, 1);

          // Mettre à jour le document
          await updateDoc(archiveRef, {
            files: updatedFiles,
            updatedAt: new Date(),
          });

          // Si on est en train d'éditer cette archive, mettre à jour le formulaire
          if (currentArchive && currentArchive.id === archiveId) {
            setArchiveForm({
              ...archiveForm,
              files: updatedFiles,
            });
          }

          // Rafraîchir les archives
          const user = auth.currentUser;
          if (user) {
            fetchArchives(user.uid);
          }

          setMessage("Fichier supprimé avec succès.");
          setTimeout(() => setMessage(""), 3000);
        } else {
          throw new Error("L'archive n'existe pas");
        }
      } catch (error) {
        console.error("Erreur lors de la suppression du fichier:", error);
        setMessage(`Erreur: ${error.message}`);
      } finally {
        setLoading(false);
      }
    }
  };

  const fetchStructureInfo = async () => {
    if (!currentUser) return;

    try {
      setLoading(true);
      const docRef = doc(db, "structures", currentUser.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const structureData = docSnap.data();
        // S'assurer que les tableaux specialites et assurances existent
        if (!structureData.specialites) structureData.specialites = [];
        if (!structureData.assurances) structureData.assurances = [];

        setStructureInfo(structureData);
        setForm(structureData);
      } else {
        console.error("Aucune information trouvée pour cette structure");
      }
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des informations de la structure:",
        error
      );
      toast.error("Impossible de charger les informations de la structure");
    } finally {
      setLoading(false);
    }
  };

  // Gestion des formulaires médecin
  const handleMedecinChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "assurances") {
      // Pour les checkboxes d'assurances
      const updatedArray = [...medecinForm.assurances];
      if (checked) {
        updatedArray.push(value);
      } else {
        const index = updatedArray.indexOf(value);
        if (index > -1) {
          updatedArray.splice(index, 1);
        }
      }
      setMedecinForm({ ...medecinForm, [name]: updatedArray });
    } else {
      setMedecinForm({ ...medecinForm, [name]: value });
    }
  };

  const handleDisponibiliteChange = (jour, field, value, index = 0) => {
    if (field === "actif") {
      setMedecinForm({
        ...medecinForm,
        disponibilites: {
          ...medecinForm.disponibilites,
          [jour]: {
            ...medecinForm.disponibilites[jour],
            actif: !medecinForm.disponibilites[jour].actif,
          },
        },
      });
    } else {
      const updatedCreneaux = [...medecinForm.disponibilites[jour].creneaux];
      updatedCreneaux[index] = {
        ...updatedCreneaux[index],
        [field]: value,
      };
      
      setMedecinForm({
        ...medecinForm,
        disponibilites: {
          ...medecinForm.disponibilites,
          [jour]: {
            ...medecinForm.disponibilites[jour],
            creneaux: updatedCreneaux,
          },
        },
      });
    }
  };
  
  // Fonction pour ajouter un nouveau créneau à un jour
  const addCreneau = (jour) => {
    const updatedCreneaux = [
      ...medecinForm.disponibilites[jour].creneaux,
      { debut: "08:00", fin: "18:00", structureId: "" }
    ];
    
    setMedecinForm({
      ...medecinForm,
      disponibilites: {
        ...medecinForm.disponibilites,
        [jour]: {
          ...medecinForm.disponibilites[jour],
          creneaux: updatedCreneaux,
        },
      },
    });
  };
  
  // Fonction pour supprimer un créneau
  const removeCreneau = (jour, index) => {
    if (medecinForm.disponibilites[jour].creneaux.length <= 1) {
      return; // Garder au moins un créneau
    }
    
    const updatedCreneaux = medecinForm.disponibilites[jour].creneaux.filter((_, i) => i !== index);
    
    setMedecinForm({
      ...medecinForm,
      disponibilites: {
        ...medecinForm.disponibilites,
        [jour]: {
          ...medecinForm.disponibilites[jour],
          creneaux: updatedCreneaux,
        },
      },
    });
  };
  
  

  const resetMedecinForm = () => {
    setMedecinForm({
      nom: "",
      titre: "Dr", 
      specialite: "",
      telephone: "",
      email: "",
      consultationDomicile: false, 
      disponibilites: {
        lundi: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
        mardi: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
        mercredi: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
        jeudi: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
        vendredi: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
        samedi: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
        dimanche: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
      },
      assurances: [],
    });
    setCurrentMedecin(null);
  };

  const handleAddMedecin = async (e) => {
    e.preventDefault();
    try {
      const user = auth.currentUser;
      let medecinAuthId;
      let generatedPassword = "";

      if (!currentMedecin) {
        console.log("🔄 Création d'un nouveau médecin...");
        generatedPassword = generateRandomPassword(6);
        console.log("🔑 Mot de passe généré");

        try {
          // Utiliser la seconde instance d'authentification
          console.log("👤 Création du compte utilisateur...");
          const userCredential = await createUserWithEmailAndPassword(
            secondaryAuth,
            medecinForm.email,
            generatedPassword
          );
          medecinAuthId = userCredential.user.uid;
          console.log(
            "✅ Compte utilisateur créé avec succès, UID:",
            medecinAuthId
          );

          // Déconnecter immédiatement l'utilisateur de la seconde instance
          await signOut(secondaryAuth);
          console.log(
            "👋 Utilisateur déconnecté de l'authentification secondaire"
          );

          // Préparer et envoyer le message de bienvenue
          console.log("📱 Préparation du message WhatsApp pour le médecin...");
          const welcomeMessage =
          `Bonjour ${medecinForm.titre || "Dr"} ${medecinForm.nom},\n\n` +
          `Bienvenue sur notre plateforme de gestion médicale!\n\n` +
            `Voici vos informations de connexion:\n` +
            `Email: ${medecinForm.email}\n` +
            `Mot de passe: ${generatedPassword}\n\n` +
            `Nous vous recommandons de changer votre mot de passe après votre première connexion.`;

          console.log(
            "📞 Numéro de téléphone du médecin:",
            medecinForm.telephone
          );

          // Envoyer le message WhatsApp
          console.log("🚀 Envoi du message WhatsApp au médecin...");
          const messageResult = await sendWhatsAppMessage(
            medecinForm.telephone,
            welcomeMessage
          );

          if (messageResult.success) {
            console.log("✅ Message WhatsApp envoyé avec succès au médecin!");
            toast.success(
              "Message de bienvenue envoyé au médecin par WhatsApp"
            );
          } else {
            console.warn(
              "⚠️ Impossible d'envoyer le message WhatsApp:",
              messageResult.error
            );
            toast.warning(
              "Impossible d'envoyer le message WhatsApp au médecin. Vérifiez la configuration Maytapi."
            );
          }
        } catch (authError) {
          console.error("❌ Erreur lors de la création du compte:", authError);
          throw new Error(`Erreur d'authentification: ${authError.message}`);
        }
      } else {
        console.log("🔄 Mise à jour d'un médecin existant...");
        medecinAuthId = currentMedecin.id;
      }

      const disponibilitesAEnregistrer = [];
      Object.entries(medecinForm.disponibilites).forEach(([jour, valeur]) => {
        if (valeur.actif) {
          valeur.creneaux.forEach(creneau => {
            if (creneau.debut && creneau.fin) {
              disponibilitesAEnregistrer.push({
                jour: jour.charAt(0).toUpperCase() + jour.slice(1),
                heureDebut: creneau.debut,
                heureFin: creneau.fin,
                structureId: creneau.structureId || user.uid
              });
            }
          });
        }
      });

      const medecinData = {
        ...medecinForm,
        disponibilites: disponibilitesAEnregistrer,
        structureId: user.uid,
      };

      console.log("💾 Enregistrement des données du médecin...");

      if (currentMedecin) {
        await updateDoc(doc(db, "medecins", currentMedecin.id), {
          ...medecinData,
          updatedAt: new Date(),
        });
        console.log("✅ Médecin mis à jour avec succès");
        setMessage("Médecin mis à jour avec succès.");
      } else {
        await setDoc(doc(db, "medecins", medecinAuthId), {
          ...medecinData,
          createdAt: new Date(),
        });
        console.log("✅ Médecin ajouté avec succès");
        setMessage("Médecin ajouté avec succès.");
      }

      resetMedecinForm();
      setShowMedecinForm(false);
      fetchMedecins(user.uid);
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      console.error(
        "❌ Erreur lors de l'ajout/modification du médecin:",
        error
      );
      setMessage(`Erreur: ${error.message}`);
    }
  };

  const handleEditMedecin = (medecin) => {
    setCurrentMedecin(medecin);
  
    // Conversion des disponibilités du format stocké vers le format du formulaire
    let disponibilitesFormattees = {
      lundi: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
      mardi: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
      mercredi: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
      jeudi: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
      vendredi: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
      samedi: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
      dimanche: { actif: false, creneaux: [{ debut: "08:00", fin: "18:00", structureId: "" }] },
    };
  
    // Si le médecin a des disponibilités existantes, les convertir
    if (medecin.disponibilites && Array.isArray(medecin.disponibilites)) {
      // Regrouper les disponibilités par jour
      const dispoParJour = {};
      
      medecin.disponibilites.forEach((dispo) => {
        const jour = dispo.jour.toLowerCase();
        if (!dispoParJour[jour]) {
          dispoParJour[jour] = [];
        }
        dispoParJour[jour].push({
          debut: dispo.heureDebut || "08:00",
          fin: dispo.heureFin || "18:00",
          structureId: dispo.structureId || "",
        });
      });
      
      // Mettre à jour les disponibilités formatées
      Object.entries(dispoParJour).forEach(([jour, creneaux]) => {
        if (disponibilitesFormattees[jour]) {
          disponibilitesFormattees[jour] = {
            actif: true,
            creneaux: creneaux,
          };
        }
      });
    } else if (medecin.disponibilites && typeof medecin.disponibilites === "object") {
      // Si les disponibilités sont déjà au bon format mais dans l'ancien modèle
      Object.entries(medecin.disponibilites).forEach(([jour, dispo]) => {
        if (disponibilitesFormattees[jour] && dispo.actif) {
          disponibilitesFormattees[jour] = {
            actif: true,
            creneaux: [{
              debut: dispo.debut || "08:00",
              fin: dispo.fin || "18:00",
              structureId: dispo.structureId || "",
            }]
          };
        }
      });
    }
  
    setMedecinForm({
      nom: medecin.nom || "",
      titre: medecin.titre || "Dr", 
      specialite: medecin.specialite || "",
      telephone: medecin.telephone || "",
      email: medecin.email || "",
      consultationDomicile: medecin.consultationDomicile || false, 
      password: "", // Ne pas afficher le mot de passe existant
      disponibilites: disponibilitesFormattees,
      assurances: medecin.assurances || [],
    });
    
    setShowMedecinForm(true);
    setTimeout(() => {
      // Trouvez l'élément du formulaire et faites défiler jusqu'à lui
      const formElement = document.getElementById('medecin-form');
      if (formElement) {
        formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };
  

  const handleDeleteMedecin = async (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce médecin ?")) {
      try {
        await deleteDoc(doc(db, "medecins", id));
        setMessage("Médecin supprimé avec succès.");
        const user = auth.currentUser;
        fetchMedecins(user.uid);

        // Faire disparaître le message après 3 secondes
        setTimeout(() => setMessage(""), 3000);
      } catch (error) {
        setMessage(`Erreur lors de la suppression: ${error.message}`);
      }
    }
  };

  // Gestion des formulaires patient
  const handlePatientChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "assurances") {
      // Pour les checkboxes d'assurances
      const updatedArray = [...patientForm.assurances];
      if (checked) {
        updatedArray.push(value);
      } else {
        const index = updatedArray.indexOf(value);
        if (index > -1) {
          updatedArray.splice(index, 1);
        }
      }
      setPatientForm({ ...patientForm, [name]: updatedArray });
    } else {
      setPatientForm({ ...patientForm, [name]: value });
    }
  };

  const resetPatientForm = () => {
    setPatientForm({
      nom: "",
      dateNaissance: "",
      email: "",
      telephone: "",
      assurances: [],
      diagnostics: "", // Réinitialisation du champ diagnostics
    });
    setCurrentPatient(null);
  };

  const fetchQuickRequests = async (structureId) => {
    try {
      const q = query(
        collection(db, "quickAppointments"),
        where("structureId", "==", structureId),
        where("status", "==", "pending")
      );
      const querySnapshot = await getDocs(q);
      const requests = [];
      querySnapshot.forEach((doc) => {
        requests.push({ id: doc.id, ...doc.data() });
      });
      setQuickRequests(requests);
      setQuickRequestsCount(requests.length);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des demandes rapides:",
        error
      );
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const docRef = doc(db, "structures", user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setStructureData(docSnap.data());
          setForm(docSnap.data());
          fetchMedecins(user.uid);
          fetchPatients(user.uid);
          fetchRendezvous(user.uid);
          fetchArchives(user.uid);
          fetchPendingRequests(user.uid);
          fetchQuickRequests(user.uid); // Ajout de la récupération des demandes rapides
          fetchAllStructures(); // Add this line to fetch structures
        }
      } else {
        navigate("/auth");
      }
    });
    return () => unsubscribe();
  }, [auth, navigate]);

  // Fonction pour accepter une demande de rendez-vous rapide
  const handleAcceptQuickRequest = async () => {
    try {
      if (!selectedQuickRequest || !selectedMedecinForQuick) {
        setMessage("Veuillez sélectionner un médecin pour ce rendez-vous.");
        return;
      }

      const user = auth.currentUser;
      const medecin = medecins.find((m) => m.id === selectedMedecinForQuick);

      // Créer un nouveau rendez-vous à partir de la demande rapide
      const rdvData = {
        medecinId: selectedMedecinForQuick,
        medecinNom: `Dr. ${medecin.nom}`,
        medecinSpecialite: medecin.specialite,
        patientId: selectedQuickRequest.patientId || null,
        patientNom: ` ${selectedQuickRequest.nom}`,
        patientEmail: selectedQuickRequest.email,
        patientTelephone: selectedQuickRequest.telephone,
        date: selectedQuickRequest.dateFormatted,
        heure: selectedQuickRequest.heureRdv,
        duree: selectedQuickRequest.duree || "30",
        motif: selectedQuickRequest.motif || "Consultation",
        statut: "confirmé",
        structureId: user.uid,
        structureNom: selectedQuickRequest.structureNom || "",
        createdAt: new Date(),
        updatedAt: new Date(),
        source: "quick",
        verificationCode: selectedQuickRequest.verificationCode,
      };

      // Ajouter le rendez-vous à la collection rendezvous
      const rdvRef = await addDoc(collection(db, "rendezvous"), rdvData);

      // Mettre à jour le statut de la demande rapide
      await updateDoc(doc(db, "quickAppointments", selectedQuickRequest.id), {
        status: "accepted",
        medecinId: selectedMedecinForQuick,
        medecinNom: `Dr.  ${medecin.nom}`,
        rdvId: rdvRef.id,
        updatedAt: new Date(),
      });

      setMessage("Demande de rendez-vous acceptée avec succès.");
      fetchQuickRequests(user.uid);
      fetchRendezvous(user.uid);
      setAssignMedecinModal(false);

      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };

  // Fonction pour refuser une demande de rendez-vous rapide
  const handleRejectQuickRequest = async (requestId) => {
    if (
      window.confirm(
        "Êtes-vous sûr de vouloir refuser cette demande de rendez-vous ?"
      )
    ) {
      try {
        const user = auth.currentUser;

        // Mettre à jour le statut de la demande rapide
        await updateDoc(doc(db, "quickAppointments", requestId), {
          status: "rejected",
          updatedAt: new Date(),
        });

        setMessage("Demande de rendez-vous refusée.");
        fetchQuickRequests(user.uid);

        // Faire disparaître le message après 3 secondes
        setTimeout(() => setMessage(""), 3000);
      } catch (error) {
        setMessage(`Erreur: ${error.message}`);
      }
    }
  };

  // Ajouter un nouveau composant pour la section des demandes rapides
  const renderQuickRequestsSection = () => {
    return (
      <div className="card shadow-sm mb-4">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5>
            <FontAwesomeIcon icon={faCalendarPlus} className="me-2" />
            Demandes de rendez-vous rapides
            {quickRequestsCount > 0 && (
              <span className="badge bg-danger ms-2">{quickRequestsCount}</span>
            )}
          </h5>
          <Button
            variant="primary"
            size="sm"
            onClick={() => setShowQuickRequestsModal(true)}
          >
            Voir toutes les demandes
          </Button>
        </div>
        <div className="card-body">
          {quickRequests.length > 0 ? (
            <div className="quick-requests-preview">
              {quickRequests.slice(0, 3).map((request) => (
                <div key={request.id} className="quick-request-item">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="mb-0">
                       {request.nom}
                    </h6>
                    <span className="badge bg-warning">En attente</span>
                  </div>
                  <div className="quick-request-details">
                    <p>
                      <strong>Contact:</strong> {request.telephone}
                    </p>
                    {request.email && (
                      <p>
                        <strong>Email:</strong> {request.email}
                      </p>
                    )}
                    <p>
                      <strong>Date souhaitée:</strong> {request.dateFormatted}
                    </p>
                    <p>
                      <strong>Heure:</strong> {request.heureRdv}
                    </p>
                    {request.motif && (
                      <p>
                        <strong>Motif:</strong> {request.motif}
                      </p>
                    )}
                  </div>
                  <div className="d-flex justify-content-end mt-2">
                    <Button
                      variant="outline-danger"
                      size="sm"
                      className="me-2"
                      onClick={() => handleRejectQuickRequest(request.id)}
                    >
                      <FontAwesomeIcon icon={faTimes} className="me-1" />
                      Refuser
                    </Button>
                    <Button
                      variant="outline-success"
                      size="sm"
                      onClick={() => {
                        setSelectedQuickRequest(request);
                        setAssignMedecinModal(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faCheck} className="me-1" />
                      Accepter
                    </Button>
                  </div>
                </div>
              ))}

              {quickRequests.length > 3 && (
                <div className="text-center mt-3">
                  <Button
                    variant="link"
                    onClick={() => setShowQuickRequestsModal(true)}
                  >
                    Voir {quickRequests.length - 3} demandes supplémentaires
                  </Button>
                </div>
              )}
            </div>
          ) : (
            <p className="text-center py-3 text-muted">
              Aucune demande de rendez-vous rapide en attente
            </p>
          )}
        </div>
      </div>
    );
  };

  // Fonction pour afficher une notification plus détaillée
  const showNotification = (message, type = "success", duration = 5000) => {
    setMessage({
      text: message,
      type: type,
    });

    setTimeout(() => setMessage(""), duration);
  };

  const handleAddPatient = async (e) => {
    e.preventDefault();
    try {
      const user = auth.currentUser;
      let patientAuthId;
      let generatedPassword = "";

      if (!currentPatient) {
        console.log("🔄 Création d'un nouveau patient...");
        generatedPassword = generateRandomPassword(6);
        console.log("🔑 Mot de passe généré");

        try {
          // Utiliser la seconde instance d'authentification
          console.log("👤 Création du compte utilisateur pour le patient...");
          const userCredential = await createUserWithEmailAndPassword(
            secondaryAuth,
            patientForm.email,
            generatedPassword
          );
          patientAuthId = userCredential.user.uid;
          console.log(
            "✅ Compte utilisateur créé avec succès pour le patient, UID:",
            patientAuthId
          );

          // Déconnecter immédiatement l'utilisateur de la seconde instance
          await signOut(secondaryAuth);
          console.log(
            "👋 Utilisateur déconnecté de l'authentification secondaire"
          );

          // Formater le numéro de téléphone pour WhatsApp
          let phoneNumber = patientForm.telephone;
          console.log("📞 Numéro de téléphone du patient:", phoneNumber);

          // Préparer et envoyer le message de bienvenue
          console.log("📱 Préparation du message WhatsApp pour le patient...");
          const welcomeMessage =
            `Bonjour  ${patientForm.nom},\n\n` +
            `Bienvenue sur notre plateforme de gestion médicale!\n\n` +
            `Voici vos informations de connexion:\n` +
            `Email: ${patientForm.email}\n` +
            `Mot de passe: ${generatedPassword}\n\n` +
            `Nous vous recommandons de changer votre mot de passe après votre première connexion.`;

          // Envoyer le message WhatsApp
          console.log("🚀 Envoi du message WhatsApp au patient...");
          const messageResult = await sendWhatsAppMessage(
            phoneNumber,
            welcomeMessage
          );

          if (messageResult.success) {
            console.log("✅ Message WhatsApp envoyé avec succès au patient!");
            toast.success(
              "Message de bienvenue envoyé au patient par WhatsApp"
            );
          } else {
            console.warn(
              "⚠️ Impossible d'envoyer le message WhatsApp au patient:",
              messageResult.error
            );
            toast.warning(
              "Impossible d'envoyer le message WhatsApp au patient. Vérifiez la configuration Maytapi."
            );
          }
        } catch (authError) {
          console.error(
            "❌ Erreur lors de la création du compte patient:",
            authError
          );
          throw new Error(`Erreur d'authentification: ${authError.message}`);
        }
      } else {
        console.log("🔄 Mise à jour d'un patient existant...");
        patientAuthId = currentPatient.id;
      }

      const patientData = {
        ...patientForm,
        structureId: user.uid,
      };

      console.log("💾 Enregistrement des données du patient...");

      if (currentPatient) {
        await updateDoc(doc(db, "patients", currentPatient.id), {
          ...patientData,
          updatedAt: new Date(),
        });
        console.log("✅ Patient mis à jour avec succès");
        setMessage("Patient mis à jour avec succès.");
      } else {
        await setDoc(doc(db, "patients", patientAuthId), {
          ...patientData,
          createdAt: new Date(),
        });
        console.log("✅ Patient ajouté avec succès");
        setMessage("Patient ajouté avec succès.");
      }

      resetPatientForm();
      setShowPatientForm(false);
      fetchPatients(user.uid);
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      console.error(
        "❌ Erreur lors de l'ajout/modification du patient:",
        error
      );
      setMessage(`Erreur: ${error.message}`);
    }
  };

  const handleEditPatient = (patient) => {
    setCurrentPatient(patient);
    setPatientForm({
      nom: patient.nom || "",
      dateNaissance: patient.dateNaissance || "",
      email: patient.email || "",
      password: "", // Ne pas afficher le mot de passe existant
      telephone: patient.telephone || "",
      assurances: patient.assurances || [],
      diagnostics: patient.diagnostics || "", // Ajout du champ diagnostics
    });
    setShowPatientForm(true);
    // Après un court délai pour s'assurer que le formulaire est rendu
    setTimeout(() => {
      // Trouvez l'élément du formulaire et faites défiler jusqu'à lui
      const formElement = document.getElementById('patient-form');
      if (formElement) {
        formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const handleDeletePatient = async (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce patient ?")) {
      try {
        await deleteDoc(doc(db, "patients", id));
        setMessage("Patient supprimé avec succès.");
        const user = auth.currentUser;
        fetchPatients(user.uid);

        // Faire disparaître le message après 3 secondes
        setTimeout(() => setMessage(""), 3000);
      } catch (error) {
        setMessage(`Erreur lors de la suppression: ${error.message}`);
      }
    }
  };

  // Gestion des formulaires rendez-vous
  const handleRdvChange = (e) => {
    const { name, value } = e.target;
    setRdvForm({ ...rdvForm, [name]: value });
  };

  const resetRdvForm = () => {
    setRdvForm({
      medecinId: "",
      patientId: "",
      date: new Date().toISOString().split("T")[0],
      heure: "08:00",
      duree: 15,
      motif: "",
      statut: "confirmé",
      typeConsultation: "presentiel", // Valeur par défaut pour le type de consultation
    });
    setCurrentRendezvous(null);
  };

  // Vérifier si l'heure de rendez-vous est disponible
  const verifierDisponibilite = (
    medecinId,
    date,
    heure,
    duree,
    rdvIdAExclure = null
  ) => {
    // Trouver le médecin
    const medecin = medecins.find((m) => m.id === medecinId);
    if (!medecin) return false;

    // Vérifier le jour de la semaine
    const jourDate = new Date(date);
    const joursMap = [
      "dimanche",
      "lundi",
      "mardi",
      "mercredi",
      "jeudi",
      "vendredi",
      "samedi",
    ];
    const jourSemaine = joursMap[jourDate.getDay()];

    // Vérifier si le médecin travaille ce jour-là
    let disponibiliteJour = null;
    if (Array.isArray(medecin.disponibilites)) {
      disponibiliteJour = medecin.disponibilites.find(
        (d) => d.jour.toLowerCase() === jourSemaine.toLowerCase()
      );
    } else if (medecin.disponibilites && medecin.disponibilites[jourSemaine]) {
      disponibiliteJour = medecin.disponibilites[jourSemaine].actif
        ? {
            heureDebut: medecin.disponibilites[jourSemaine].debut,
            heureFin: medecin.disponibilites[jourSemaine].fin,
          }
        : null;
    }

    if (!disponibiliteJour) return false;

    // Vérifier si l'heure est dans la plage de disponibilité
    const heureDebut = disponibiliteJour.heureDebut || disponibiliteJour.debut;
    const heureFin = disponibiliteJour.heureFin || disponibiliteJour.fin;

    if (heure < heureDebut || heure > heureFin) return false;

    // Calculer l'heure de fin du rendez-vous
    const [heureH, heureM] = heure.split(":").map(Number);
    const heureFinRdv = new Date();
    heureFinRdv.setHours(heureH, heureM + parseInt(duree), 0, 0);
    const heureFinStr = `${heureFinRdv
      .getHours()
      .toString()
      .padStart(2, "0")}:${heureFinRdv
      .getMinutes()
      .toString()
      .padStart(2, "0")}`;

    if (heureFinStr > heureFin) return false;

    // Vérifier les chevauchements avec d'autres rendez-vous
    const rdvDuJour = rendezvous.filter(
      (rdv) =>
        rdv.medecinId === medecinId &&
        rdv.date === date &&
        rdv.statut !== "annulé" &&
        rdv.id !== rdvIdAExclure
    );

    // Compter les rendez-vous à cette heure précise
    const rdvAuCreneau = rdvDuJour.filter((rdv) => rdv.heure === heure);

    // Nombre maximum de rendez-vous simultanés autorisés
    const MAX_RDV_SIMULTANES = 3;

    // Si nous avons déjà atteint le nombre maximum de rendez-vous à cette heure
    if (rdvAuCreneau.length >= MAX_RDV_SIMULTANES) {
      return false;
    }

    return true;
  };

  const handleAddRendezvous = async (e) => {
    e.preventDefault();
    try {
      const user = auth.currentUser;
  
      // Vérifier la disponibilité
      const estDisponible = verifierDisponibilite(
        rdvForm.medecinId,
        rdvForm.date,
        rdvForm.heure,
        rdvForm.duree,
        currentRendezvous?.id
      );
  
      if (!estDisponible) {
        setMessage(
          "Erreur: Le médecin n'est pas disponible à cette heure ou il y a un conflit d'horaire."
        );
        return;
      }
  
      // Normaliser la date
      const dateObj = new Date(rdvForm.date);
      const normalizedDate = formatDateString(dateObj);
  
      const rdvData = {
        ...rdvForm,
        date: normalizedDate,
        structureId: user.uid,
      };
  
      // Récupérer les informations du médecin et du patient pour les stocker dans le rendez-vous
      const medecin = medecins.find((m) => m.id === rdvForm.medecinId);
      const patient = patients.find((p) => p.id === rdvForm.patientId);
  
      if (medecin) {
        rdvData.medecinNom = `${medecin.titre || "Dr"} ${medecin.nom}`;
        rdvData.medecinSpecialite = medecin.specialite;
        
        // Déterminer la structure pour ce rendez-vous en fonction du jour et de l'heure
        const jourDate = new Date(rdvForm.date);
        const joursMap = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
        const jourSemaine = joursMap[jourDate.getDay()];
        
        // Chercher la structure dans les disponibilités du médecin
        if (Array.isArray(medecin.disponibilites)) {
          const disponibiliteJour = medecin.disponibilites.find(
            (d) => d.jour.toLowerCase() === jourSemaine.toLowerCase()
          );
          if (disponibiliteJour && disponibiliteJour.structureId) {
            rdvData.lieuStructureId = disponibiliteJour.structureId;
            // Trouver le nom de la structure
            const structure = allStructures.find(s => s.id === disponibiliteJour.structureId);
            if (structure) {
              rdvData.lieuStructureNom = structure.nom;
            }
          }
        } else if (medecin.disponibilites && medecin.disponibilites[jourSemaine] && medecin.disponibilites[jourSemaine].creneaux) {
          // Pour le nouveau format avec créneaux multiples
          const creneauCorrespondant = medecin.disponibilites[jourSemaine].creneaux.find(
            creneau => rdvForm.heure >= creneau.debut && rdvForm.heure <= creneau.fin
          );
          
          if (creneauCorrespondant && creneauCorrespondant.structureId) {
            rdvData.lieuStructureId = creneauCorrespondant.structureId;
            // Trouver le nom de la structure
            const structure = allStructures.find(s => s.id === creneauCorrespondant.structureId);
            if (structure) {
              rdvData.lieuStructureNom = structure.nom;
            }
          }
        }
      }
  
      if (patient) {
        rdvData.patientNom = `$ ${patient.nom}`;
        rdvData.patientTelephone = patient.telephone;
        rdvData.patientEmail = patient.email;
      }
  
      let rdvId;
  
      if (currentRendezvous) {
        // Modification d'un rendez-vous existant
        rdvId = currentRendezvous.id;
        await updateDoc(doc(db, "rendezvous", rdvId), {
          ...rdvData,
          updatedAt: new Date(),
        });
  
        // Envoyer une notification de rendez-vous reprogrammé
        if (patient) {
          const notificationResult = await sendAppointmentNotification(
            {
              ...rdvData,
              id: rdvId,
            },
            "rescheduled"
          );
  
          if (!notificationResult.success) {
            console.warn(
              "Impossible d'envoyer la notification WhatsApp:",
              notificationResult.error
            );
          }
        }
  
        setMessage("Rendez-vous mis à jour avec succès.");
      } else {
        // Création d'un nouveau rendez-vous
        const docRef = await addDoc(collection(db, "rendezvous"), {
          ...rdvData,
          createdAt: new Date(),
        });
        rdvId = docRef.id;
  
        // Envoyer une notification de confirmation de rendez-vous
        if (patient) {
          const notificationResult = await sendAppointmentNotification(
            {
              ...rdvData,
              id: rdvId,
            },
            "confirmation"
          );
  
          if (!notificationResult.success) {
            console.warn(
              "Impossible d'envoyer la notification WhatsApp:",
              notificationResult.error
            );
          }
        }
  
        setMessage("Rendez-vous ajouté avec succès.");
      }
  
      resetRdvForm();
      setShowRendezvousForm(false);
      fetchRendezvous(user.uid);
  
      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };

  

  const handleEditRendezvous = (rdv) => {
    setCurrentRendezvous(rdv);
    setRdvForm({
      medecinId: rdv.medecinId || "",
      patientId: rdv.patientId || "",
      date: rdv.date || new Date().toISOString().split("T")[0],
      heure: rdv.heure || "08:00",
      duree: rdv.duree || "",
      motif: rdv.motif || "",
      statut: rdv.statut || "confirmé",
      typeConsultation: rdv.typeConsultation || "presentiel", // Reprendre la valeur existante ou définir par défaut
    });
    setShowRendezvousForm(true);
  };

  const handleDeleteRendezvous = async (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce rendez-vous ?")) {
      try {
        await deleteDoc(doc(db, "rendezvous", id));
        setMessage("Rendez-vous supprimé avec succès.");
        const user = auth.currentUser;
        fetchRendezvous(user.uid);

        // Faire disparaître le message après 3 secondes
        setTimeout(() => setMessage(""), 3000);
      } catch (error) {
        setMessage(`Erreur lors de la suppression: ${error.message}`);
      }
    }
  };

  const handleChangeStatutRendezvous = async (id, nouveauStatut) => {
    try {
      // Récupérer les données du rendez-vous
      const rdvDoc = await getDoc(doc(db, "rendezvous", id));
      if (!rdvDoc.exists()) {
        throw new Error("Le rendez-vous n'existe pas");
      }

      const rdvData = rdvDoc.data();

      await updateDoc(doc(db, "rendezvous", id), {
        statut: nouveauStatut,
        updatedAt: new Date(),
      });

      // Envoyer une notification selon le nouveau statut
      if (rdvData.patientTelephone) {
        let notificationType;

        if (nouveauStatut === "annulé") {
          notificationType = "cancellation";
        } else if (nouveauStatut === "confirmé") {
          notificationType = "confirmation";
        }

        if (notificationType) {
          const notificationResult = await sendAppointmentNotification(
            {
              ...rdvData,
              id: id,
            },
            notificationType
          );

          if (!notificationResult.success) {
            console.warn(
              "Impossible d'envoyer la notification WhatsApp:",
              notificationResult.error
            );
          }
        }
      }

      setMessage("Statut du rendez-vous mis à jour avec succès.");
      const user = auth.currentUser;
      fetchRendezvous(user.uid);

      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      setMessage(`Erreur lors de la mise à jour du statut: ${error.message}`);
    }
  };

  // Fonction pour envoyer des rappels de rendez-vous pour le lendemain
  const sendAppointmentReminders = async () => {
    try {
      setLoading(true);
      const user = auth.currentUser;

      if (!user) {
        throw new Error("Utilisateur non authentifié");
      }

      // Obtenir la date de demain
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      const tomorrowStr = formatDateString(tomorrow);

      // Récupérer tous les rendez-vous de demain qui sont confirmés
      const rdvsSnapshot = await getDocs(
        query(
          collection(db, "rendezvous"),
          where("structureId", "==", user.uid),
          where("date", "==", tomorrowStr),
          where("statut", "==", "confirmé")
        )
      );

      let remindersSent = 0;
      let remindersTotal = rdvsSnapshot.size;

      // Si aucun rendez-vous demain
      if (remindersTotal === 0) {
        setMessage(`Aucun rendez-vous prévu pour demain.`);
        setTimeout(() => setMessage(""), 3000);
        return;
      }

      for (const doc of rdvsSnapshot.docs) {
        const rdv = doc.data();

        // Vérifier si le rendez-vous a un numéro de téléphone patient
        if (rdv.patientTelephone) {
          const result = await sendAppointmentNotification(
            {
              ...rdv,
              id: doc.id,
            },
            "reminder"
          );

          if (result.success) {
            remindersSent++;
          }
        }
      }

      setMessage(
        `${remindersSent} rappels de rendez-vous envoyés sur ${remindersTotal} prévus pour demain.`
      );
      setTimeout(() => setMessage(""), 5000);
    } catch (error) {
      console.error("Erreur lors de l'envoi des rappels:", error);
      setMessage(`Erreur lors de l'envoi des rappels: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Filtrer les rendez-vous par date et médecin
  const rendezVousFiltres = rendezvous.filter((rdv) => {
    let correspondDate = true;
    let correspondMedecin = true;

    if (filtreDate) {
      correspondDate = rdv.date === filtreDate;
    }

    if (filtreMedecin) {
      correspondMedecin = rdv.medecinId === filtreMedecin;
    }

    return correspondDate && correspondMedecin;
  });

  // Trier les rendez-vous par heure
  rendezVousFiltres.sort((a, b) => {
    if (a.date !== b.date) {
      return a.date.localeCompare(b.date);
    }
    return a.heure.localeCompare(b.heure);
  });

  // Fonction pour obtenir les créneaux disponibles
  const getCreneauxDisponibles = () => {
    if (!rdvForm.medecinId || !rdvForm.date) return [];

    const medecin = medecins.find((m) => m.id === rdvForm.medecinId);
    if (!medecin) return [];

    // Déterminer le jour de la semaine
    const jourDate = new Date(rdvForm.date);
    const joursMap = [
      "dimanche",
      "lundi",
      "mardi",
      "mercredi",
      "jeudi",
      "vendredi",
      "samedi",
    ];
    const jourSemaine = joursMap[jourDate.getDay()];

    // Obtenir les horaires du médecin pour ce jour
    let heureDebut = "08:00";
    let heureFin = "18:00";

    if (Array.isArray(medecin.disponibilites)) {
      const disponibiliteJour = medecin.disponibilites.find(
        (d) => d.jour.toLowerCase() === jourSemaine.toLowerCase()
      );

      if (disponibiliteJour) {
        heureDebut = disponibiliteJour.heureDebut;
        heureFin = disponibiliteJour.heureFin;
      } else {
        return []; // Le médecin ne travaille pas ce jour
      }
    } else if (medecin.disponibilites && medecin.disponibilites[jourSemaine]) {
      if (!medecin.disponibilites[jourSemaine].actif) {
        return []; // Le médecin ne travaille pas ce jour
      }
      heureDebut = medecin.disponibilites[jourSemaine].debut;
      heureFin = medecin.disponibilites[jourSemaine].fin;
    } else {
      return []; // Pas de disponibilités pour ce jour
    }

    // Générer des créneaux de 15 minutes
    const creneaux = [];
    let heure = heureDebut;

    while (heure < heureFin) {
      const [h, m] = heure.split(":").map(Number);
      const heureFinCreneau = new Date();
      heureFinCreneau.setHours(h, m + parseInt(rdvForm.duree), 0, 0);
      const heureFinStr = `${heureFinCreneau
        .getHours()
        .toString()
        .padStart(2, "0")}:${heureFinCreneau
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;

      if (heureFinStr <= heureFin) {
        // Vérifier si le créneau est disponible (pas de chevauchement avec d'autres RDV)
        const estDisponible = verifierDisponibilite(
          rdvForm.medecinId,
          rdvForm.date,
          heure,
          rdvForm.duree,
          currentRendezvous?.id
        );

        if (estDisponible) {
          creneaux.push(heure);
        }
      }

      // Passer au créneau suivant (par tranches de 15 minutes)
      const nextHeure = new Date();
      nextHeure.setHours(h, m + 15, 0, 0);
      heure = `${nextHeure.getHours().toString().padStart(2, "0")}:${nextHeure
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;
    }

    return creneaux;
  };

  // Fonction pour basculer l'état du menu latéral
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  // Fonctions pour la vue calendrier
  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const handleDateClick = (day) => {
    if (day.hasEvents) {
      setSelectedDate(day);
      setShowDateModal(true);
    }
  };

  const handleMedecinClick = (medecinId) => {
    setSelectedMedecinId(medecinId);
    setShowMedecinRdvModal(true);
    setShowDateModal(false);
  };

  const handleRdvClick = (rdv) => {
    setSelectedRdv(rdv);
    
    // Récupérer le nom de la structure si disponible
    if (rdv.lieuStructureId) {
      const structure = allStructures.find(s => s.id === rdv.lieuStructureId);
      if (structure) {
        rdv.lieuStructureNom = structure.nom;
      }
    } else if (rdv.structureId) {
      // Utiliser la structure principale si aucune structure spécifique n'est définie
      const structure = allStructures.find(s => s.id === rdv.structureId);
      if (structure) {
        rdv.lieuStructureNom = structure.nom;
      }
    }
    
    setShowRdvDetailsModal(true);
  };
  
  

  const handleDragStart = (rdv) => {
    setDraggedRdv(rdv);
  };

  const handleDrop = async (targetRdv) => {
    if (!draggedRdv || draggedRdv.id === targetRdv.id) return;

    try {
      // Échanger les heures des rendez-vous
      const draggedHeure = draggedRdv.heure;
      const targetHeure = targetRdv.heure;

      await updateDoc(doc(db, "rendezvous", draggedRdv.id), {
        heure: targetHeure,
        updatedAt: new Date(),
      });

      await updateDoc(doc(db, "rendezvous", targetRdv.id), {
        heure: draggedHeure,
        updatedAt: new Date(),
      });

      setMessage("Rendez-vous échangés avec succès.");
      const user = auth.currentUser;
      fetchRendezvous(user.uid);

      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      setMessage(`Erreur lors de l'échange: ${error.message}`);
    }

    setDraggedRdv(null);
  };

  const handlePrevMonth = () => {
    setCurrentMonth(
      new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1)
    );
  };

  const handleNextMonth = () => {
    setCurrentMonth(
      new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1)
    );
  };
  const getMedecinsByDate = (date) => {
    const dateString = date.dateString || formatDateString(date.date);
    const rdvs = rendezvous.filter((rdv) => rdv.date === dateString);
    const uniqueMedecinIds = [...new Set(rdvs.map((rdv) => rdv.medecinId))];

    return uniqueMedecinIds.map((id) => {
      const medecin = medecins.find((m) => m.id === id);
      const medecinRdvs = rdvs.filter((rdv) => rdv.medecinId === id);

      return {
        medecin: medecin,
        rdvCount: medecinRdvs.length,
      };
    });
  };

  const getMedecinRdvs = (medecinId, date) => {
    // Utiliser la date normalisée stockée dans l'objet day
    const dateString = date.dateString || formatDateString(date.date);

    return rendezvous
      .filter((rdv) => rdv.medecinId === medecinId && rdv.date === dateString)
      .sort((a, b) => a.heure.localeCompare(b.heure));
  };


  
  const getCreneauxAvecStatut = () => {
    if (!rdvForm.medecinId || !rdvForm.date) return [];
  
    const medecin = medecins.find((m) => m.id === rdvForm.medecinId);
    if (!medecin) return [];
  
    // Déterminer le jour de la semaine
    const jourDate = new Date(rdvForm.date);
    const joursMap = [
      "dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"
    ];
    const jourSemaine = joursMap[jourDate.getDay()];
  
    // Récupérer les rendez-vous existants pour ce médecin et cette date
    const rdvDuJour = rendezvous.filter(
      (rdv) =>
        rdv.medecinId === rdvForm.medecinId &&
        rdv.date === rdvForm.date &&
        rdv.statut !== "annulé" &&
        rdv.id !== currentRendezvous?.id
    );
  
    // Nombre maximum de rendez-vous simultanés autorisés
    const MAX_RDV_SIMULTANES = 3;
    
    // Tableau pour stocker tous les créneaux disponibles
    let tousLesCreneaux = [];
  
    // Vérifier le format des disponibilités et traiter en conséquence
    if (Array.isArray(medecin.disponibilites)) {
      // Format ancien - tableau de disponibilités
      const disponibilitesJour = medecin.disponibilites.filter(
        (d) => d.jour.toLowerCase() === jourSemaine.toLowerCase()
      );
      
      // Parcourir chaque disponibilité pour ce jour
      disponibilitesJour.forEach(disponibilite => {
        const heureDebut = disponibilite.heureDebut;
        const heureFin = disponibilite.heureFin;
        
        // Générer les créneaux pour cette plage horaire
        let heure = heureDebut;
        while (heure < heureFin) {
          const [h, m] = heure.split(":").map(Number);
          const heureFinCreneau = new Date();
          heureFinCreneau.setHours(h, m + parseInt(rdvForm.duree), 0, 0);
          const heureFinStr = `${heureFinCreneau.getHours().toString().padStart(2, "0")}:${heureFinCreneau.getMinutes().toString().padStart(2, "0")}`;
  
          if (heureFinStr <= heureFin) {
            // Compter le nombre de rendez-vous à cette heure
            const rdvAuCreneau = rdvDuJour.filter((rdv) => rdv.heure === heure);
            const nombreRdvAuCreneau = rdvAuCreneau.length;
  
            // Déterminer le statut du créneau
            let statut = "disponible";
            if (nombreRdvAuCreneau >= MAX_RDV_SIMULTANES) {
              statut = "complet";
            } else if (nombreRdvAuCreneau > 0) {
              statut = "partiel";
            }
  
            tousLesCreneaux.push({
              heure: heure,
              statut: statut,
              nombreRdv: nombreRdvAuCreneau,
              estDisponible: statut !== "complet",
              structureId: disponibilite.structureId || "",
            });
          }
  
          // Passer au créneau suivant (par tranches de 15 minutes)
          const nextHeure = new Date();
          nextHeure.setHours(h, m + 15, 0, 0);
          heure = `${nextHeure.getHours().toString().padStart(2, "0")}:${nextHeure.getMinutes().toString().padStart(2, "0")}`;
        }
      });
    } else if (medecin.disponibilites && medecin.disponibilites[jourSemaine]) {
      // Format nouveau - objet avec jours et créneaux
      const jourConfig = medecin.disponibilites[jourSemaine];
      
      if (jourConfig.actif && jourConfig.creneaux && Array.isArray(jourConfig.creneaux)) {
        // Parcourir chaque créneau pour ce jour
        jourConfig.creneaux.forEach(creneau => {
          const heureDebut = creneau.debut;
          const heureFin = creneau.fin;
          const structureId = creneau.structureId || "";
          
          // Générer les créneaux pour cette plage horaire
          let heure = heureDebut;
          while (heure < heureFin) {
            const [h, m] = heure.split(":").map(Number);
            const heureFinCreneau = new Date();
            heureFinCreneau.setHours(h, m + parseInt(rdvForm.duree), 0, 0);
            const heureFinStr = `${heureFinCreneau.getHours().toString().padStart(2, "0")}:${heureFinCreneau.getMinutes().toString().padStart(2, "0")}`;
  
            if (heureFinStr <= heureFin) {
              // Compter le nombre de rendez-vous à cette heure
              const rdvAuCreneau = rdvDuJour.filter((rdv) => rdv.heure === heure);
              const nombreRdvAuCreneau = rdvAuCreneau.length;
  
              // Déterminer le statut du créneau
              let statut = "disponible";
              if (nombreRdvAuCreneau >= MAX_RDV_SIMULTANES) {
                statut = "complet";
              } else if (nombreRdvAuCreneau > 0) {
                statut = "partiel";
              }
  
              tousLesCreneaux.push({
                heure: heure,
                statut: statut,
                nombreRdv: nombreRdvAuCreneau,
                estDisponible: statut !== "complet",
                structureId: structureId,
              });
            }
  
            // Passer au créneau suivant (par tranches de 15 minutes)
            const nextHeure = new Date();
            nextHeure.setHours(h, m + 15, 0, 0);
            heure = `${nextHeure.getHours().toString().padStart(2, "0")}:${nextHeure.getMinutes().toString().padStart(2, "0")}`;
          }
        });
      }
    }
  
    // Trier les créneaux par heure
    tousLesCreneaux.sort((a, b) => a.heure.localeCompare(b.heure));
    
    return tousLesCreneaux;
  };

  // Fonction pour calculer l'âge précis
const calculateAge = (dateNaissance) => {
  if (!dateNaissance) return 0;
  
  const today = new Date();
  const birthDate = new Date(dateNaissance);
  
  // Vérifier si la date de naissance est valide
  if (isNaN(birthDate.getTime())) return 0;
  
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  
  // Si l'anniversaire n'a pas encore eu lieu cette année, soustraire 1
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  
  return age;
};

// Fonction pour formater l'âge avec unités appropriées
const formatAge = (dateNaissance) => {
  if (!dateNaissance) return "Âge inconnu";
  
  const today = new Date();
  const birthDate = new Date(dateNaissance);
  
  // Vérifier si la date de naissance est valide
  if (isNaN(birthDate.getTime())) return "Date invalide";
  
  const diffTime = Math.abs(today - birthDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  // Si moins d'un mois (30 jours)
  if (diffDays < 30) {
    if (diffDays === 1) return "1 jour";
    if (diffDays < 7) return `${diffDays} jours`;
    const weeks = Math.floor(diffDays / 7);
    return weeks === 1 ? "1 semaine" : `${weeks} semaines`;
  }
  
  // Si moins d'un an (365 jours)
  if (diffDays < 365) {
    const months = Math.floor(diffDays / 30);
    return months === 1 ? "1 mois" : `${months} mois`;
  }
  
  // Si plus d'un an
  const age = calculateAge(dateNaissance);
  return age === 1 ? "1 an" : `${age} ans`;
};


  
  const handleMobileTabChange = (tab) => {
    setActiveTab(tab);
    setShowMobileMenu(false);
    setMobileDetailView(null);
  };

  const handleMobileDetailView = (type, item) => {
    setMobileDetailView({ type, item });
  };

  const handleBackToList = () => {
    setMobileDetailView(null);
  };

  const handleMobileSearch = (e) => {
    setMobileSearchQuery(e.target.value);
  };

  const filteredMedecins =
    mobileSearchActive && mobileSearchQuery
      ? medecins.filter(
          (m) =>
            `${m.nom} `
              .toLowerCase()
              .includes(mobileSearchQuery.toLowerCase()) ||
            m.specialite.toLowerCase().includes(mobileSearchQuery.toLowerCase())
        )
      : medecins;

  const filteredPatients =
    mobileSearchActive && mobileSearchQuery
      ? patients.filter((p) =>
          `${p.nom}`
            .toLowerCase()
            .includes(mobileSearchQuery.toLowerCase())
        )
      : patients;

  const filteredRendezvous =
    mobileSearchActive && mobileSearchQuery
      ? rendezvous.filter(
          (r) =>
            r.patientNom
              ?.toLowerCase()
              .includes(mobileSearchQuery.toLowerCase()) ||
            r.medecinNom
              ?.toLowerCase()
              .includes(mobileSearchQuery.toLowerCase())
        )
      : rendezvous;

  // Fonction pour accepter une demande de rendez-vous
  const handleAccepterDemandeRapide = async (demande) => {
    if (!currentUser) return;

    try {
      setLoading(true);

      // Chercher si le patient existe déjà
      const patientQuery = query(
        collection(db, "patients"),
        where("structureId", "==", demande.structureId),
        where("telephone", "==", demande.telephone)
      );
      const patientSnapshot = await getDocs(patientQuery);

      let patientId = null;

      // Si le patient n'existe pas encore, le créer
      if (patientSnapshot.empty) {
        const patientData = {
          nom: demande.nom,
          dateNaissance: demande.dateNaissance || "",
          email: demande.email || "",
          telephone: demande.telephone,
          structureId: demande.structureId,
          createdAt: new Date(),
          assurances: [],
          diagnostics: "", // Ajout du champ diagnostics
        };

        const docRef = await addDoc(collection(db, "patients"), patientData);
        patientId = docRef.id;
      } else {
        patientId = patientSnapshot.docs[0].id;
      }

      // Mettre à jour le rendez-vous
      await updateDoc(doc(db, "rendezvous", demande.id), {
        statut: "confirmé",
        patientId: patientId,
      });

      // Rafraîchir les données
      fetchDemandesRapides();
      fetchRendezvous(currentUser.uid);

      toast.success("La demande a été acceptée avec succès !");
    } catch (error) {
      console.error("Erreur lors de l'acceptation de la demande:", error);
      toast.error(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Fonction pour récupérer les demandes rapides
  const fetchDemandesRapides = async () => {
    if (!currentUser) return;

    try {
      setLoading(true);
      const q = query(
        collection(db, "rendezvous"),
        where("structureId", "==", currentUser.uid),
        where("statut", "==", "confirmé"),
        where("source", "==", "quick")
      );

      const querySnapshot = await getDocs(q);
      const demandes = [];

      querySnapshot.forEach((doc) => {
        demandes.push({ id: doc.id, ...doc.data() });
      });

      setDemandesRapides(demandes);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des demandes rapides:",
        error
      );
      toast.error("Impossible de charger les demandes rapides");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
    });

    // Nettoyer l'abonnement lors du démontage du composant
    return () => unsubscribe();
  }, []);

  // Modifier useEffect pour charger les demandes rapides
  useEffect(() => {
    if (currentUser) {
      fetchStructureInfo();
      fetchRendezvous(currentUser.uid);
      fetchDemandesRapides();
      fetchPatients(currentUser.uid);
      fetchMedecins(currentUser.uid);
    }
  }, [currentUser]);

  // Fonction pour refuser une demande rapide
  const handleRefuserDemandeRapide = async (demandeId) => {
    try {
      setLoading(true);

      // Mettre à jour le statut du rendez-vous à "refusé"
      await updateDoc(doc(db, "rendezvous", demandeId), {
        statut: "refusé",
      });

      // Rafraîchir les données
      fetchDemandesRapides();

      toast.success("La demande rapide a été refusée.");
    } catch (error) {
      console.error("Erreur lors du refus de la demande rapide:", error);
      toast.error(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const AppointmentDetailsViewer = ({ structureId }) => {
    const [appointments, setAppointments] = useState([]);
    const [filteredAppointments, setFilteredAppointments] = useState([]);
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterStatus, setFilterStatus] = useState('all');
    const [filterDate, setFilterDate] = useState('');
    const [medecins, setMedecins] = useState([]);
    const [activeTab, setActiveTab] = useState('pending');
    const [showModifyModal, setShowModifyModal] = useState(false);
    const [modifiedAppointment, setModifiedAppointment] = useState(null);
    const [availableTimes, setAvailableTimes] = useState([]);
    const [processingAction, setProcessingAction] = useState(false);
    const [codeCopied, setCodeCopied] = useState(false);
  
    // Récupérer les rendez-vous de la structure
    useEffect(() => {
      const fetchAppointments = async () => {
        if (!structureId) return;
        
        try {
          setLoading(true);
          
          // Récupérer les médecins pour les afficher dans les détails
          const medecinsQuery = query(
            collection(db, 'medecins'),
            where('structureId', '==', structureId)
          );
          const medecinsSnapshot = await getDocs(medecinsQuery);
          const medecinsData = medecinsSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          setMedecins(medecinsData);
          
          // Récupérer tous les rendez-vous
          const appointmentsQuery = query(
            collection(db, 'rendezvous'),
            where('structureId', '==', structureId)
          );
          const appointmentsSnapshot = await getDocs(appointmentsQuery);
          const appointmentsData = appointmentsSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
            createdAt: doc.data().createdAt?.toDate() || new Date(),
            updatedAt: doc.data().updatedAt?.toDate() || new Date()
          }));
          
          setAppointments(appointmentsData);
          setFilteredAppointments(appointmentsData);
          setLoading(false);
        } catch (err) {
          console.error('Erreur lors du chargement des rendez-vous:', err);
          setError('Impossible de charger les rendez-vous. Veuillez réessayer.');
          setLoading(false);
        }
      };
  
      fetchAppointments();
    }, [structureId]);
  
    // Filtrer les rendez-vous en fonction des critères
    useEffect(() => {
      if (!appointments.length) return;
      
      let filtered = [...appointments];
      
      // Filtrer par statut
      if (activeTab !== 'all') {
        if (activeTab === 'pending') {
          filtered = filtered.filter(appointment => 
            appointment.statut === 'en attente' || appointment.statut === 'confirmé'
          );
        } else if (activeTab === 'completed') {
          filtered = filtered.filter(appointment => appointment.statut === 'terminé');
        } else if (activeTab === 'cancelled') {
          filtered = filtered.filter(appointment => appointment.statut === 'annulé');
        }
      }
      
      // Filtrer par date
      if (filterDate) {
        filtered = filtered.filter(appointment => appointment.date === filterDate);
      }
      
      // Filtrer par terme de recherche
      if (searchTerm) {
        const term = searchTerm.toLowerCase();
        filtered = filtered.filter(appointment => 
          (appointment.patientNom && appointment.patientNom.toLowerCase().includes(term)) ||
          (appointment.patientTelephone && appointment.patientTelephone.includes(term)) ||
          (appointment.motif && appointment.motif.toLowerCase().includes(term)) ||
          (appointment.medecinNom && appointment.medecinNom.toLowerCase().includes(term)) ||
          // Ajouter la recherche par code de vérification
          (appointment.verificationCode && appointment.verificationCode.toLowerCase().includes(term))
        );
      }
      
      // Trier par date et heure
      filtered.sort((a, b) => {
        // D'abord par date
        if (a.date !== b.date) {
          return new Date(a.date) - new Date(b.date);
        }
        // Ensuite par heure
        return a.heure.localeCompare(b.heure);
      });
      
      setFilteredAppointments(filtered);
    }, [appointments, activeTab, filterDate, searchTerm]);
  
    // Fonction pour formater la date
    const formatDate = (dateString) => {
      if (!dateString) return '';
      
      const options = { 
        weekday: 'long', 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric'
      };
      
      return new Date(dateString).toLocaleDateString('fr-FR', options);
    };
  
    // Fonction pour copier le code de vérification dans le presse-papier
    const copyVerificationCode = (code) => {
      if (!code) return;
      
      navigator.clipboard.writeText(code)
        .then(() => {
          setCodeCopied(true);
          setTimeout(() => setCodeCopied(false), 2000);
        })
        .catch(err => {
          console.error('Impossible de copier le code:', err);
        });
    };
  
    // Fonction pour mettre à jour le statut d'un rendez-vous
    const updateAppointmentStatus = async (appointmentId, newStatus) => {
      try {
        setProcessingAction(true);
        
        const appointmentRef = doc(db, 'rendezvous', appointmentId);
        await updateDoc(appointmentRef, {
          statut: newStatus,
          updatedAt: new Date()
        });
        
        // Mettre à jour l'état local
        setAppointments(prevAppointments => 
          prevAppointments.map(appointment => 
            appointment.id === appointmentId 
              ? { ...appointment, statut: newStatus, updatedAt: new Date() } 
              : appointment
          )
        );
        
        if (selectedAppointment && selectedAppointment.id === appointmentId) {
          setSelectedAppointment({ ...selectedAppointment, statut: newStatus, updatedAt: new Date() });
        }
        
        // Notification de succès
        alert(`Le statut du rendez-vous a été mis à jour avec succès`);
      } catch (err) {
        console.error('Erreur lors de la mise à jour du statut:', err);
        alert('Impossible de mettre à jour le statut');
      } finally {
        setProcessingAction(false);
      }
    };
  
    // Fonction pour vérifier la disponibilité des créneaux pour la modification
    const checkAvailableTimes = async (medecinId, date, appointmentId) => {
      try {
        // Récupérer le médecin pour connaître ses disponibilités
        const medecinRef = doc(db, 'medecins', medecinId);
        const medecinDoc = await getDoc(medecinRef);
        
        if (!medecinDoc.exists()) {
          console.error('Médecin non trouvé');
          return [];
        }
        
        const medecin = medecinDoc.data();
        
        // Déterminer le jour de la semaine
        const jourDate = new Date(date);
        const joursMap = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
        const jourSemaine = joursMap[jourDate.getDay()];
        
        // Vérifier si le médecin travaille ce jour-là
        let disponibiliteJour = null;
        if (Array.isArray(medecin.disponibilites)) {
          disponibiliteJour = medecin.disponibilites.find(d => 
            d.jour.toLowerCase() === jourSemaine.toLowerCase()
          );
        } else if (medecin.disponibilites && medecin.disponibilites[jourSemaine]) {
          disponibiliteJour = medecin.disponibilites[jourSemaine].actif ? {
            heureDebut: medecin.disponibilites[jourSemaine].debut,
            heureFin: medecin.disponibilites[jourSemaine].fin
          } : null;
        }
        
        if (!disponibiliteJour) {
          return [];
        }
        
        // Récupérer les heures de début et de fin
        const heureDebut = disponibiliteJour.heureDebut || disponibiliteJour.debut;
        const heureFin = disponibiliteJour.heureFin || disponibiliteJour.fin;
        
        // Récupérer tous les rendez-vous de ce médecin pour cette date
        const rdvQuery = query(
          collection(db, 'rendezvous'),
          where('medecinId', '==', medecinId),
          where('date', '==', date),
          where('statut', '!=', 'annulé')
        );
        const rdvSnapshot = await getDocs(rdvQuery);
        const rdvs = rdvSnapshot.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(rdv => rdv.id !== appointmentId); // Exclure le rendez-vous actuel
        
        // Générer tous les créneaux possibles (par tranches de 15 minutes)
        const creneaux = [];
        let heure = heureDebut;
        
        while (heure < heureFin) {
          const [h, m] = heure.split(':').map(Number);
          
          // Vérifier si ce créneau est déjà pris
          const rdvAuCreneau = rdvs.filter(rdv => rdv.heure === heure);
          
          // Nombre maximum de rendez-vous simultanés autorisés
          const MAX_RDV_SIMULTANES = 3;
          
          if (rdvAuCreneau.length < MAX_RDV_SIMULTANES) {
            creneaux.push({
              heure,
              disponible: true,
              occupationLevel: rdvAuCreneau.length
            });
          }
          
          // Passer au créneau suivant (par tranches de 15 minutes)
          const nextHeure = new Date();
          nextHeure.setHours(h, m + 15, 0, 0);
          heure = `${nextHeure.getHours().toString().padStart(2, '0')}:${nextHeure.getMinutes().toString().padStart(2, '0')}`;
        }
        
        return creneaux;
      } catch (error) {
        console.error('Erreur lors de la vérification des disponibilités:', error);
        return [];
      }
    };
  
    // Fonction pour modifier un rendez-vous
    const modifyAppointment = async () => {
      if (!modifiedAppointment || !modifiedAppointment.heure) {
        alert('Veuillez sélectionner une heure pour le rendez-vous');
        return;
      }
      
      try {
        setProcessingAction(true);
        
        const appointmentRef = doc(db, 'rendezvous', selectedAppointment.id);
        await updateDoc(appointmentRef, {
          heure: modifiedAppointment.heure,
          date: modifiedAppointment.date || selectedAppointment.date,
          updatedAt: new Date()
        });
        
        // Mettre à jour l'état local
        setAppointments(prevAppointments => 
          prevAppointments.map(appointment => 
            appointment.id === selectedAppointment.id 
              ? { 
                  ...appointment, 
                  heure: modifiedAppointment.heure, 
                  date: modifiedAppointment.date || appointment.date,
                  updatedAt: new Date() 
                } 
              : appointment
          )
        );
        
        setSelectedAppointment({
          ...selectedAppointment,
          heure: modifiedAppointment.heure,
          date: modifiedAppointment.date || selectedAppointment.date,
          updatedAt: new Date()
        });
        
        // Fermer le modal de modification
        setShowModifyModal(false);
        
        // Notification de succès
        alert('Le rendez-vous a été modifié avec succès');
      } catch (err) {
        console.error('Erreur lors de la modification du rendez-vous:', err);
        alert('Impossible de modifier le rendez-vous');
      } finally {
        setProcessingAction(false);
      }
    };
  
    // Fonction pour ouvrir le modal de modification
    const openModifyModal = async () => {
      if (!selectedAppointment) return;
      
      setModifiedAppointment({
        date: selectedAppointment.date,
        heure: selectedAppointment.heure
      });
      
      const availableTimes = await checkAvailableTimes(
        selectedAppointment.medecinId,
        selectedAppointment.date,
        selectedAppointment.id
      );
      
      setAvailableTimes(availableTimes);
      setShowModifyModal(true);
    };
  
    // Fonction pour changer la date du rendez-vous à modifier
    const handleDateChange = async (e) => {
      const newDate = e.target.value;
      
      setModifiedAppointment(prev => ({
        ...prev,
        date: newDate,
        heure: '' // Réinitialiser l'heure car les disponibilités changent
      }));
      
      if (newDate && selectedAppointment) {
        const availableTimes = await checkAvailableTimes(
          selectedAppointment.medecinId,
          newDate,
          selectedAppointment.id
        );
        
        setAvailableTimes(availableTimes);
      } else {
        setAvailableTimes([]);
      }
    };
  
    return (
      <div className="appointment-details-viewer">
        <Card className="mb-4 shadow-sm">
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">
              <FontAwesomeIcon icon={faCalendarCheck} className="me-2 text-primary" />
              Demandes de rendez-vous
            </h5>
            
            <div className="d-flex gap-2">
              <input
                type="date"
                className="form-control form-control-sm"
                value={filterDate}
                onChange={(e) => setFilterDate(e.target.value)}
              />
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Rechercher..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </Card.Header>
          
          <Card.Body className="p-0">
            <Tabs
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              className="mb-3 px-3 pt-3"
            >
              <Tab eventKey="pending" title={
                <span>
                  <FontAwesomeIcon icon={faClock} className="me-2" />
                  En attente / Confirmés
                </span>
              } />
              <Tab eventKey="completed" title={
                <span>
                  <FontAwesomeIcon icon={faCheck} className="me-2" />
                  Terminés
                </span>
              } />
              <Tab eventKey="cancelled" title={
                <span>
                  <FontAwesomeIcon icon={faTimes} className="me-2" />
                  Annulés
                </span>
              } />
              <Tab eventKey="all" title={
                <span>
                  <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
                  Tous
                </span>
              } />
            </Tabs>
            
            {loading ? (
              <div className="text-center py-5">
                <Spinner animation="border" variant="primary" />
                <p className="mt-3">Chargement des rendez-vous...</p>
              </div>
            ) : error ? (
              <div className="alert alert-danger m-3">
                <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                {error}
              </div>
            ) : filteredAppointments.length === 0 ? (
              <div className="alert alert-info m-3">
                <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                Aucun rendez-vous trouvé pour ces critères.
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead className="table-light">
                    <tr>
                      <th>Date</th>
                      <th>Heure</th>
                      <th>Patient</th>
                      <th>Médecin</th>
                      <th>Code</th>
                      <th>Statut</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredAppointments.map(appointment => (
                      <tr key={appointment.id}>
                        <td>{formatDate(appointment.date)}</td>
                        <td>{appointment.heure}</td>
                        <td>
                          <div className="fw-bold">{appointment.patientNom}</div>
                          <div className="small text-muted">{appointment.patientTelephone}</div>
                        </td>
                        <td>
                          <div>{appointment.medecinNom}</div>
                          <div className="small text-muted">{appointment.medecinSpecialite}</div>
                        </td>
                        <td>
                          {appointment.verificationCode ? (
                            <Badge 
                              bg="info" 
                              className="verification-code-badge"
                              onClick={() => copyVerificationCode(appointment.verificationCode)}
                              title="Cliquez pour copier"
                              style={{ cursor: 'pointer' }}
                            >
                              <FontAwesomeIcon icon={faKey} className="me-1" />
                              {appointment.verificationCode}
                            </Badge>
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </td>
                        <td>
                          <Badge bg={
                            appointment.statut === 'confirmé' ? 'success' :
                            appointment.statut === 'en attente' ? 'warning' :
                            appointment.statut === 'terminé' ? 'info' :
                            'danger'
                          }>
                            {appointment.statut}
                          </Badge>
                          {appointment.typeConsultation === 'teleconsultation' && (
                            <Badge bg="primary" className="ms-1">Téléconsultation</Badge>
                          )}
                        </td>
                        <td>
                          <Button 
                            variant="outline-primary" 
                            size="sm"
                            onClick={() => {
                              setSelectedAppointment(appointment);
                              setShowDetailsModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faInfoCircle} />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </Card.Body>
        </Card>
  
        {/* Modal de détails du rendez-vous */}
        <Modal 
          show={showDetailsModal} 
          onHide={() => setShowDetailsModal(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <FontAwesomeIcon icon={faCalendarCheck} className="me-2 text-primary" />
              Détails du rendez-vous
            </Modal.Title>
          </Modal.Header>
          
          <Modal.Body>
            {selectedAppointment && (
              <>
                <div className="mb-4 text-center">
                  <Badge 
                    bg={
                      selectedAppointment.statut === 'confirmé' ? 'success' :
                      selectedAppointment.statut === 'en attente' ? 'warning' :
                      selectedAppointment.statut === 'terminé' ? 'info' :
                      'danger'
                    }
                    className="fs-6 px-3 py-2"
                  >
                    {selectedAppointment.statut.toUpperCase()}
                  </Badge>
                  
                  {selectedAppointment.typeConsultation === 'teleconsultation' && (
                    <Badge bg="primary" className="ms-2 fs-6 px-3 py-2">
                      TÉLÉCONSULTATION
                    </Badge>
                  )}
                </div>
                
                {/* Affichage du code de vérification en évidence */}
                {selectedAppointment.verificationCode && (
                  <div className="verification-code-container mb-4">
                    <div className="verification-code-box">
                      <div className="verification-code-label">
                        <FontAwesomeIcon icon={faLock} className="me-2" />
                        Code de vérification
                      </div>
                      <div className="verification-code-value">
                        {selectedAppointment.verificationCode}
                      </div>
                      <Button 
                        variant="outline-secondary"
                        size="sm"
                        className="verification-code-copy"
                        onClick={() => copyVerificationCode(selectedAppointment.verificationCode)}
                      >
                        <FontAwesomeIcon icon={faCopy} />
                        {codeCopied ? ' Copié!' : ' Copier'}
                      </Button>
                    </div>
                  </div>
                )}
                
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <Card className="h-100 border-0 shadow-sm">
                      <Card.Header className="bg-light">
                        <h5 className="mb-0">
                          <FontAwesomeIcon icon={faUser} className="me-2 text-primary" />
                          Informations du patient
                        </h5>
                      </Card.Header>
                      <Card.Body>
                        <ListGroup variant="flush">
                          <ListGroup.Item className="d-flex justify-content-between align-items-start">
                            <div className="fw-bold">Nom complet</div>
                            <div>{selectedAppointment.patientNom}</div>
                          </ListGroup.Item>
                          
                          <ListGroup.Item className="d-flex justify-content-between align-items-start">
                            <div className="fw-bold">Téléphone</div>
                            <div>
                              <a href={`tel:${selectedAppointment.patientTelephone}`}>
                                <FontAwesomeIcon icon={faPhone} className="me-2" />
                                {selectedAppointment.patientTelephone}
                              </a>
                            </div>
                          </ListGroup.Item>
                          
                          {selectedAppointment.patientEmail && (
                            <ListGroup.Item className="d-flex justify-content-between align-items-start">
                              <div className="fw-bold">Email</div>
                              <div>
                                <a href={`mailto:${selectedAppointment.patientEmail}`}>
                                  <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                                  {selectedAppointment.patientEmail}
                                </a>
                              </div>
                            </ListGroup.Item>
                          )}
                          
                          {selectedAppointment.patientDateNaissance && (
                            <ListGroup.Item className="d-flex justify-content-between align-items-start">
                              <div className="fw-bold">Date de naissance</div>
                              <div>{formatDate(selectedAppointment.patientDateNaissance)}</div>
                            </ListGroup.Item>
                          )}
                        </ListGroup>
                      </Card.Body>
                    </Card>
                  </div>
                  
                  <div className="col-md-6 mb-4">
                    <Card className="h-100 border-0 shadow-sm">
                      <Card.Header className="bg-light">
                        <h5 className="mb-0">
                          <FontAwesomeIcon icon={faUserMd} className="me-2 text-primary" />
                          Informations du médecin
                        </h5>
                      </Card.Header>
                      <Card.Body>
                        <ListGroup variant="flush">
                          <ListGroup.Item className="d-flex justify-content-between align-items-start">
                            <div className="fw-bold">Médecin</div>
                            <div>{selectedAppointment.medecinNom}</div>
                          </ListGroup.Item>
                          
                          <ListGroup.Item className="d-flex justify-content-between align-items-start">
                            <div className="fw-bold">Spécialité</div>
                            <div>{selectedAppointment.medecinSpecialite}</div>
                          </ListGroup.Item>
                        </ListGroup>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <Card className="h-100 border-0 shadow-sm">
                      <Card.Header className="bg-light">
                        <h5 className="mb-0">
                          <FontAwesomeIcon icon={faCalendarAlt} className="me-2 text-primary" />
                          Détails du rendez-vous
                        </h5>
                      </Card.Header>
                      <Card.Body>
                        <ListGroup variant="flush">
                          <ListGroup.Item className="d-flex justify-content-between align-items-start">
                            <div className="fw-bold">Date</div>
                            <div>{formatDate(selectedAppointment.date)}</div>
                          </ListGroup.Item>
                          
                          <ListGroup.Item className="d-flex justify-content-between align-items-start">
                            <div className="fw-bold">Heure</div>
                            <div>{selectedAppointment.heure}</div>
                          </ListGroup.Item>
                          
                          <ListGroup.Item className="d-flex justify-content-between align-items-start">
                            <div className="fw-bold">Type</div>
                            <div>
                              {selectedAppointment.typeConsultation === 'teleconsultation' 
                                ? 'Téléconsultation' 
                                : 'Consultation en présentiel'}
                            </div>
                          </ListGroup.Item>
                          
                          {selectedAppointment.duree && (
                            <ListGroup.Item className="d-flex justify-content-between align-items-start">
                              <div className="fw-bold">Durée</div>
                              <div>{selectedAppointment.duree} minutes</div>
                            </ListGroup.Item>
                          )}
                          
                          {selectedAppointment.structureNom && (
                            <ListGroup.Item className="d-flex justify-content-between align-items-start">
                              <div className="fw-bold">Structure</div>
                              <div>{selectedAppointment.structureNom}</div>
                            </ListGroup.Item>
                          )}
                        </ListGroup>
                      </Card.Body>
                    </Card>
                  </div>
                  
                  <div className="col-md-6 mb-4">
                    <Card className="h-100 border-0 shadow-sm">
                      <Card.Header className="bg-light">
                        <h5 className="mb-0">
                          <FontAwesomeIcon icon={faInfoCircle} className="me-2 text-primary" />
                          Informations supplémentaires
                        </h5>
                      </Card.Header>
                      <Card.Body>
                        <div className="mb-3">
                          <h6>Motif de la consultation</h6>
                          <p className="border rounded p-3 bg-light">
                            {selectedAppointment.motif || 'Aucun motif spécifié'}
                          </p>
                        </div>
                        
                        <div className="d-flex justify-content-between small text-muted">
                          <div>
                            <strong>Créé le:</strong> {selectedAppointment.createdAt.toLocaleString()}
                          </div>
                          {selectedAppointment.updatedAt && (
                            <div>
                              <strong>Mis à jour le:</strong> {selectedAppointment.updatedAt.toLocaleString()}
                            </div>
                                                    )}
                                                    </div>
                                                    
                                                    {selectedAppointment.source && (
                                                      <div className="mt-2 text-center">
                                                        <Badge bg="secondary">
                                                          Source: {selectedAppointment.source === 'quick' ? 'Demande rapide' : selectedAppointment.source}
                                                        </Badge>
                                                      </div>
                                                    )}
                                                  </Card.Body>
                                                </Card>
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      </Modal.Body>
                                      
                                      <Modal.Footer>
                                        <div className="d-flex justify-content-between w-100">
                                          <div>
                                            {selectedAppointment && selectedAppointment.statut !== 'annulé' && (
                                              <Button 
                                                variant="outline-danger" 
                                                onClick={() => {
                                                  if (window.confirm('Êtes-vous sûr de vouloir annuler ce rendez-vous ?')) {
                                                    updateAppointmentStatus(selectedAppointment.id, 'annulé');
                                                  }
                                                }}
                                                disabled={processingAction}
                                              >
                                                {processingAction ? (
                                                  <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                ) : (
                                                  <FontAwesomeIcon icon={faTimes} className="me-2" />
                                                )}
                                                Annuler le rendez-vous
                                              </Button>
                                            )}
                                          </div>
                                          
                                          <div>
                                            {selectedAppointment && selectedAppointment.statut !== 'annulé' && (
                                              <>
                                                <Button 
                                                  variant="outline-primary" 
                                                  className="me-2"
                                                  onClick={openModifyModal}
                                                  disabled={processingAction}
                                                >
                                                  <FontAwesomeIcon icon={faEdit} className="me-2" />
                                                  Modifier
                                                </Button>
                                                
                                                {selectedAppointment.statut === 'confirmé' && (
                                                  <Button 
                                                    variant="success"
                                                    onClick={() => updateAppointmentStatus(selectedAppointment.id, 'terminé')}
                                                    disabled={processingAction}
                                                  >
                                                    {processingAction ? (
                                                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                    ) : (
                                                      <FontAwesomeIcon icon={faCheck} className="me-2" />
                                                    )}
                                                    Marquer comme terminé
                                                  </Button>
                                                )}
                                                
                                                {selectedAppointment.statut === 'en attente' && (
                                                  <Button 
                                                    variant="success"
                                                    onClick={() => updateAppointmentStatus(selectedAppointment.id, 'confirmé')}
                                                    disabled={processingAction}
                                                  >
                                                    {processingAction ? (
                                                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                    ) : (
                                                      <FontAwesomeIcon icon={faCheck} className="me-2" />
                                                    )}
                                                    Confirmer
                                                  </Button>
                                                )}
                                              </>
                                            )}
                                            
                                            <Button 
                                              variant="secondary" 
                                              onClick={() => setShowDetailsModal(false)}
                                              className="ms-2"
                                            >
                                              Fermer
                                            </Button>
                                          </div>
                                        </div>
                                      </Modal.Footer>
                                    </Modal>
                                    
                                    {/* Modal pour modifier un rendez-vous */}
                                    <Modal 
                                      show={showModifyModal} 
                                      onHide={() => setShowModifyModal(false)}
                                    >
                                      <Modal.Header closeButton>
                                        <Modal.Title>
                                          <FontAwesomeIcon icon={faEdit} className="me-2 text-primary" />
                                          Modifier le rendez-vous
                                        </Modal.Title>
                                      </Modal.Header>
                                      
                                      <Modal.Body>
                                        {selectedAppointment && (
                                          <>
                                            <div className="mb-3">
                                              <label className="form-label">Date du rendez-vous</label>
                                              <input
                                                type="date"
                                                className="form-control"
                                                value={modifiedAppointment?.date || selectedAppointment.date}
                                                onChange={handleDateChange}
                                                min={new Date().toISOString().split('T')[0]}
                                              />
                                            </div>
                                            
                                            <div className="mb-3">
                                              <label className="form-label">Heure du rendez-vous</label>
                                              {availableTimes.length > 0 ? (
                                                <div className="time-slots-grid">
                                                  {availableTimes.map((slot, index) => (
                                                    <div 
                                                      key={index}
                                                      className={`time-slot ${modifiedAppointment?.heure === slot.heure ? 'selected' : ''} ${
                                                        slot.occupationLevel > 0 ? 'partial' : ''
                                                      }`}
                                                      onClick={() => setModifiedAppointment(prev => ({ ...prev, heure: slot.heure }))}
                                                    >
                                                      {slot.heure}
                                                      {slot.occupationLevel > 0 && (
                                                        <span className="occupation-badge">{slot.occupationLevel}/3</span>
                                                      )}
                                                    </div>
                                                  ))}
                                                </div>
                                              ) : (
                                                <div className="alert alert-info">
                                                  <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                                                  Veuillez sélectionner une date pour voir les créneaux disponibles
                                                </div>
                                              )}
                                            </div>
                                            
                                            <div className="alert alert-warning">
                                              <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                                              La modification du rendez-vous enverra une notification au patient.
                                            </div>
                                          </>
                                        )}
                                      </Modal.Body>
                                      
                                      <Modal.Footer>
                                        <Button 
                                          variant="secondary" 
                                          onClick={() => setShowModifyModal(false)}
                                        >
                                          Annuler
                                        </Button>
                                        <Button 
                                          variant="primary" 
                                          onClick={modifyAppointment}
                                          disabled={!modifiedAppointment?.heure || processingAction}
                                        >
                                          {processingAction ? (
                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                          ) : (
                                            <FontAwesomeIcon icon={faCheck} className="me-2" />
                                          )}
                                          Enregistrer les modifications
                                        </Button>
                                      </Modal.Footer>
                                    </Modal>
                                    
                                    <style jsx>{`
                                      .time-slots-grid {
                                        display: grid;
                                        grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
                                        gap: 10px;
                                        margin-top: 10px;
                                      }
                                      
                                      .time-slot {
                                        padding: 10px;
                                        text-align: center;
                                        border: 1px solid #dee2e6;
                                        border-radius: 4px;
                                        cursor: pointer;
                                        position: relative;
                                        transition: all 0.2s;
                                      }
                                      
                                      .time-slot:hover {
                                        background-color: #f8f9fa;
                                      }
                                      
                                      .time-slot.selected {
                                        background-color: #0d6efd;
                                        color: white;
                                        border-color: #0d6efd;
                                      }
                                      
                                      .time-slot.partial {
                                        border-color: #ffc107;
                                        background-color: rgba(255, 193, 7, 0.1);
                                      }
                                      
                                      .time-slot.selected.partial {
                                        background-color: #0d6efd;
                                        border-color: #0d6efd;
                                      }
                                      
                                      .occupation-badge {
                                        position: absolute;
                                        top: -8px;
                                        right: -8px;
                                        background-color: #ffc107;
                                        color: #212529;
                                        border-radius: 50%;
                                        width: 20px;
                                        height: 20px;
                                        font-size: 10px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                      }
                                      
                                      .time-slot.selected .occupation-badge {
                                        background-color: #0d6efd;
                                        color: white;
                                        border: 1px solid white;
                                      }
                                      
                                      .verification-code-badge {
                                        font-family: monospace;
                                        letter-spacing: 1px;
                                        transition: all 0.2s ease;
                                      }
                                      
                                      .verification-code-badge:hover {
                                        transform: scale(1.05);
                                        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
                                      }
                                      
                                      .verification-code-container {
                                        display: flex;
                                        justify-content: center;
                                      }
                                      
                                      .verification-code-box {
                                        background-color: #f8f9fa;
                                        border: 1px solid #dee2e6;
                                        border-radius: 8px;
                                        padding: 15px 25px;
                                        display: flex;
                                        align-items: center;
                                        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
                                      }
                                      
                                      .verification-code-label {
                                        font-weight: 600;
                                        color: #495057;
                                        margin-right: 15px;
                                      }
                                      
                                      .verification-code-value {
                                        font-family: monospace;
                                        font-size: 1.2rem;
                                        font-weight: 700;
                                        letter-spacing: 2px;
                                        color: #0d6efd;
                                        background-color: white;
                                        padding: 6px 12px;
                                        border-radius: 4px;
                                        border: 1px solid #dee2e6;
                                        margin-right: 15px;
                                      }
                                      
                                      .verification-code-copy {
                                        white-space: nowrap;
                                      }
                                    `}</style>
                                  </div>
                                );
                              };
                              
                  
                              
                       
  const ContactRequestsViewer = () => {
    const [contactRequests, setContactRequests] = useState([]);
    const [filteredRequests, setFilteredRequests] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [isAuthChecking, setIsAuthChecking] = useState(true);
    const [filterStatus, setFilterStatus] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    const [sortOrder, setSortOrder] = useState('newest');
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 992);
    const [showMobileDetails, setShowMobileDetails] = useState(false);
    const [replyMessage, setReplyMessage] = useState('');
    const replyTextareaRef = useRef(null);
    const [editingReplyIndex, setEditingReplyIndex] = useState(null);
    const [isEditingReply, setIsEditingReply] = useState(false);
  
    const [showReplyForm, setShowReplyForm] = useState(false);
    const [isSendingReply, setIsSendingReply] = useState(false);
    
    const navigate = useNavigate();
  
    // Détecter la taille de l'écran pour le responsive
    useEffect(() => {
      const handleResize = () => {
        setIsMobileView(window.innerWidth < 992);
      };
      
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    // Vérifier l'authentification et l'autorisation
    useEffect(() => {
      const unsubscribe = onAuthStateChanged(auth, async (user) => {
        if (user) {
          // Vérifier si l'utilisateur est la structure autorisée
          setIsAuthorized(true); // Pour le développement, on autorise tous les utilisateurs
        } else {
          // L'utilisateur n'est pas connecté
          setIsAuthorized(false);
          navigate('/Auth');
        }
        setIsAuthChecking(false);
      });
  
      return () => unsubscribe();
    }, [navigate]);
  
    // Charger les demandes de contact
    useEffect(() => {
      if (!isAuthorized || isAuthChecking) return;
  
      const fetchContactRequests = () => {
        try {
          setIsLoading(true);
          
          // Créer une requête en temps réel pour obtenir les mises à jour automatiquement
          const contactsRef = collection(db, 'contacts');
          const q = query(contactsRef, orderBy('createdAt', 'desc'));
          
          const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const requests = querySnapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data(),
              createdAt: doc.data().createdAt?.toDate() || new Date()
            }));
            
            setContactRequests(requests);
            setFilteredRequests(requests);
            setIsLoading(false);
          }, (err) => {
            console.error('Erreur lors du chargement des demandes:', err);
            setError('Impossible de charger les demandes. Veuillez réessayer plus tard.');
            setIsLoading(false);
          });
          
          return unsubscribe;
        } catch (err) {
          console.error('Erreur lors du chargement des demandes:', err);
          setError('Impossible de charger les demandes. Veuillez réessayer plus tard.');
          setIsLoading(false);
        }
      };
  
      const unsubscribe = fetchContactRequests();
      return () => {
        if (unsubscribe) unsubscribe();
      };
    }, [isAuthorized, isAuthChecking]);
  
    // Filtrer les demandes en fonction des critères
    useEffect(() => {
      if (!contactRequests.length) return;
      
      let filtered = [...contactRequests];
      
      // Filtrer par statut
      if (filterStatus !== 'all') {
        filtered = filtered.filter(request => request.status === filterStatus);
      }
      
      // Filtrer par terme de recherche
      if (searchTerm) {
        const term = searchTerm.toLowerCase();
        filtered = filtered.filter(request => 
          (request.name && request.name.toLowerCase().includes(term)) ||
          (request.email && request.email.toLowerCase().includes(term)) ||
          (request.structure && request.structure.toLowerCase().includes(term)) ||
          (request.message && request.message.toLowerCase().includes(term))
        );
      }
      
      // Trier les résultats
      filtered.sort((a, b) => {
        if (sortOrder === 'newest') {
          return new Date(b.createdAt) - new Date(a.createdAt);
        } else {
          return new Date(a.createdAt) - new Date(b.createdAt);
        }
      });
      
      setFilteredRequests(filtered);
    }, [contactRequests, filterStatus, searchTerm, sortOrder]);
  
    // Fonction pour mettre à jour le statut d'une demande
    const updateRequestStatus = async (requestId, newStatus) => {
      try {
        const requestRef = doc(db, 'contacts', requestId);
        await updateDoc(requestRef, {
          status: newStatus,
          updatedAt: Timestamp.now()
        });
        
        // Mise à jour locale pour une UX fluide
        setContactRequests(prevRequests => 
          prevRequests.map(req => 
            req.id === requestId ? { ...req, status: newStatus } : req
          )
        );
        
        if (selectedRequest && selectedRequest.id === requestId) {
          setSelectedRequest({ ...selectedRequest, status: newStatus });
        }
  
        // Notification de succès
        toast.success(`Statut mis à jour avec succès`);
      } catch (err) {
        console.error('Erreur lors de la mise à jour du statut:', err);
        toast.error('Impossible de mettre à jour le statut');
      }
    };
  
    // Fonction pour commencer à modifier une réponse
    const startEditingReply = (index) => {
      if (!selectedRequest || !selectedRequest.replies || !selectedRequest.replies[index]) return;
      
      const replyToEdit = selectedRequest.replies[index];
      setReplyMessage(replyToEdit.message);
      setEditingReplyIndex(index);
      setIsEditingReply(true);
      setShowReplyForm(true);
      
      // Mettre à jour la valeur du textarea avec useRef
      if (replyTextareaRef.current) {
        replyTextareaRef.current.value = replyToEdit.message;
      }
    };
  
    // Fonction pour annuler l'édition d'une réponse
    const cancelEditingReply = () => {
      setReplyMessage('');
      setEditingReplyIndex(null);
      setIsEditingReply(false);
      setShowReplyForm(false);
      
      // Réinitialiser le textarea
      if (replyTextareaRef.current) {
        replyTextareaRef.current.value = '';
      }
    };
  
    // Fonction pour envoyer une réponse à la demande
    const sendReply = async () => {
      // Récupérer la valeur du textarea via useRef
      const messageToSend = replyTextareaRef.current ? replyTextareaRef.current.value.trim() : '';
      
      if (!selectedRequest || !messageToSend) {
        return;
      }
  
      try {
        setIsSendingReply(true);
        
        const requestRef = doc(db, 'contacts', selectedRequest.id);
        
        // Si nous sommes en mode édition
        if (isEditingReply && editingReplyIndex !== null) {
          // Créer une copie des réponses existantes
          const updatedReplies = [...(selectedRequest.replies || [])];
          
          // Mettre à jour la réponse spécifique
          updatedReplies[editingReplyIndex] = {
            ...updatedReplies[editingReplyIndex],
            message: messageToSend,
            editedAt: Timestamp.now(),
            wasEdited: true
          };
          
          // Mettre à jour le document avec les réponses modifiées
          await updateDoc(requestRef, {
            replies: updatedReplies,
            updatedAt: Timestamp.now()
          });
          
          // Mise à jour locale
          const updatedRequest = {
            ...selectedRequest,
            replies: updatedReplies
          };
          
          setSelectedRequest(updatedRequest);
          
          // Mise à jour de la liste complète
          setContactRequests(prevRequests => 
            prevRequests.map(req => 
              req.id === selectedRequest.id ? updatedRequest : req
            )
          );
          
          // Notification de succès
          toast.success('Réponse modifiée avec succès');
        } else {
          // Mode ajout de nouvelle réponse
          // Préparer l'objet de réponse
          const reply = {
            message: messageToSend,
            sentAt: Timestamp.now(),
            sentBy: auth.currentUser.email || 'Structure'
          };
          
          // Mettre à jour le document avec la réponse
          await updateDoc(requestRef, {
            replies: selectedRequest.replies ? [...selectedRequest.replies, reply] : [reply],
            hasReplies: true,
            updatedAt: Timestamp.now()
          });
          
          // Mise à jour locale
          const updatedRequest = {
            ...selectedRequest,
            replies: selectedRequest.replies ? [...selectedRequest.replies, reply] : [reply],
            hasReplies: true
          };
          
          setSelectedRequest(updatedRequest);
          
          // Mise à jour de la liste complète
          setContactRequests(prevRequests => 
            prevRequests.map(req => 
              req.id === selectedRequest.id ? updatedRequest : req
            )
          );
          
          // Notification de succès
          toast.success('Réponse envoyée avec succès');
        }
        
        // Réinitialiser le formulaire et l'état d'édition
        if (replyTextareaRef.current) {
          replyTextareaRef.current.value = '';
        }
        setReplyMessage('');
        setShowReplyForm(false);
        setIsEditingReply(false);
        setEditingReplyIndex(null);
        
      } catch (err) {
        console.error('Erreur lors de l\'envoi/modification de la réponse:', err);
        toast.error('Impossible d\'envoyer/modifier la réponse');
      } finally {
        setIsSendingReply(false);
      }
    };
  
    // Formater la date
    const formatDate = (date) => {
      if (!date) return 'Date inconnue';
      
      const options = { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      };
      
      return new Date(date).toLocaleDateString('fr-FR', options);
    };
  
    // Obtenir la couleur en fonction du statut
    const getStatusColor = (status) => {
      switch (status) {
        case 'pending': return '#FCD34D'; // Jaune
        case 'processed': return '#10B981'; // Vert
        case 'rejected': return '#EF4444'; // Rouge
        default: return '#9CA3AF'; // Gris
      }
    };
  
    // Obtenir le libellé en fonction du statut
    const getStatusLabel = (status) => {
      switch (status) {
        case 'pending': return 'En attente';
        case 'processed': return 'Traité';
        case 'rejected': return 'Rejeté';
        default: return 'Inconnu';
      }
    };
  
    // Obtenir l'icône en fonction du type d'utilisateur
    const getUserTypeIcon = (type) => {
      switch (type) {
        case 'particulier': return <FaUser />;
        case 'professionnel': return <FaUser style={{ color: '#4F46E5' }} />;
        case 'structure': return <FaBuilding />;
        default: return <FaUser />;
      }
    };
  
    // Variantes d'animation
    const containerVariants = {
      hidden: { opacity: 0 },
      visible: { 
        opacity: 1,
        transition: { duration: 0.5 }
      },
      exit: { 
        opacity: 0,
        transition: { duration: 0.3 }
      }
    };
  
    const listItemVariants = {
      hidden: { opacity: 0, y: 20 },
      visible: { 
        opacity: 1,
        y: 0,
        transition: { duration: 0.3 }
      },
      hover: {
        backgroundColor: '#F9FAFB',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        scale: 1.01,
        transition: { duration: 0.2 }
      }
    };
  
    const slideInVariants = {
      hidden: { x: '100%' },
      visible: { 
        x: 0,
        transition: { type: 'spring', stiffness: 300, damping: 30 }
      },
      exit: { 
        x: '100%',
        transition: { duration: 0.3 }
      }
    };
  
    const replyFormVariants = {
      hidden: { opacity: 0, height: 0, marginTop: 0 },
      visible: { 
        opacity: 1, 
        height: 'auto', 
        marginTop: '1rem',
        transition: { duration: 0.3 }
      },
      exit: { 
        opacity: 0, 
        height: 0, 
        marginTop: 0,
        transition: { duration: 0.2 }
      }
    };
  
    // Styled Components avec améliorations esthétiques
    const Container = styled(motion.div)`
      font-family: 'Poppins', sans-serif;
      max-width: 1400px;
      margin: 0 auto;
      padding: 2rem;
      color: #1F2937;
      
      @media (max-width: 768px) {
        padding: 1rem;
      }
    `;
  
    const Header = styled.header`
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 2rem;
      
      @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
      }
    `;
  
    const HeaderTitle = styled.h1`
      font-size: 2rem;
      font-weight: 700;
      display: flex;
      align-items: center;
      background: linear-gradient(135deg, #4F46E5, #7C3AED);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      
      @media (max-width: 768px) {
        font-size: 1.5rem;
      }
    `;
  
    const HeaderIcon = styled.span`
      font-size: 2.2rem;
      margin-right: 1rem;
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
    `;
  
    const BackButton = styled.button`
      display: flex;
      align-items: center;
      gap: 0.5rem;
      background-color: #F3F4F6;
      color: #4B5563;
      border: none;
      padding: 0.75rem 1.25rem;
      border-radius: 0.75rem;
      font-weight: 500;
      font-size: 0.95rem;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
      
      &:hover {
        background-color: #E5E7EB;
        color: #1F2937;
        transform: translateY(-1px);
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
      }
  
      &:active {
        transform: translateY(0);
      }
    `;
  
    const FiltersSection = styled.div`
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 2rem;
      
      @media (max-width: 992px) {
        flex-direction: column;
        align-items: stretch;
        gap: 1rem;
      }
    `;
  
    const SearchBar = styled.div`
      display: flex;
      align-items: center;
      background-color: white;
      border: 1px solid #E5E7EB;
      border-radius: 0.75rem;
      padding: 0.75rem 1rem;
      flex: 1;
      max-width: 400px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
      transition: all 0.3s ease;
      
      &:focus-within {
        border-color: #6366F1;
        box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
      }
      
      @media (max-width: 992px) {
        max-width: 100%;
      }
    `;
  
    const SearchIcon = styled.div`
      color: #9CA3AF;
      margin-right: 0.75rem;
    `;
  
    const SearchInput = styled.input`
      border: none;
      outline: none;
      width: 100%;
      font-size: 1rem;
      color: #1F2937;
      
      &::placeholder {
        color: #9CA3AF;
      }
    `;
  
    const FiltersGroup = styled.div`
      display: flex;
      align-items: center;
      gap: 1rem;
      
      @media (max-width: 768px) {
        flex-wrap: wrap;
      }
    `;
  
    const FilterLabel = styled.div`
      display: flex;
      align-items: center;
      gap: 0.5rem;
      color: #4B5563;
      font-weight: 500;
    `;
  
    const FilterSelect = styled.select`
      padding: 0.75rem 1rem;
      border: 1px solid #E5E7EB;
      border-radius: 0.75rem;
      background-color: white;
      color: #1F2937;
      font-size: 0.95rem;
      cursor: pointer;
      outline: none;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
      transition: all 0.3s ease;
      
      &:focus {
        border-color: #6366F1;
        box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
      }
    `;
  
    const ContentWrapper = styled.div`
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 2rem;
      
      @media (max-width: 992px) {
        grid-template-columns: 1fr;
      }
    `;
  
    const RequestsList = styled.div`
      background-color: white;
      border-radius: 1rem;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
      overflow: hidden;
      height: calc(100vh - 200px);
      overflow-y: auto;
      
      &::-webkit-scrollbar {
        width: 8px;
      }
      
      &::-webkit-scrollbar-track {
        background: #F9FAFB;
        border-radius: 0 1rem 1rem 0;
      }
      
      &::-webkit-scrollbar-thumb {
        background: #D1D5DB;
        border-radius: 4px;
      }
      
      &::-webkit-scrollbar-thumb:hover {
        background: #9CA3AF;
      }
    `;
  
    const RequestsCount = styled.div`
      padding: 1.25rem;
      background-color: #F9FAFB;
      color: #6B7280;
      font-size: 0.9rem;
      border-bottom: 1px solid #E5E7EB;
      font-weight: 500;
    `;
  
    const RequestItem = styled(motion.div)`
      padding: 1.5rem;
      border-bottom: 1px solid #E5E7EB;
      cursor: pointer;
      background-color: ${props => props.isSelected ? '#F3F4F6' : 'white'};
      border-left: 4px solid ${props => props.isSelected ? '#4F46E5' : 'transparent'};
      transition: all 0.2s ease;
      position: relative;
    `;
  
    const RequestHeader = styled.div`
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.75rem;
    `;
  
    const RequestType = styled.div`
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 0.9rem;
      color: #6B7280;
    `;
  
    const RequestTypeText = styled.span`
      text-transform: capitalize;
    `;
  
    const RequestStatus = styled.div`
      background-color: ${props => `${props.color}20`};
      color: ${props => props.color};
      padding: 0.25rem 0.75rem;
      border-radius: 2rem;
      font-size: 0.8rem;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 0.4rem;
      
      &::before {
        content: '';
        display: block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: ${props => props.color};
      }
    `;
  
    const RequestName = styled.h3`
      font-size: 1.1rem;
      font-weight: 600;
      margin-bottom: 0.75rem;
      display: flex;
      align-items: center;
      color: #111827;
    `;
  
    const RequestInfo = styled.div`
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
      margin-bottom: 0.75rem;
    `;
  
    const RequestInfoItem = styled.div`
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 0.9rem;
      color: #6B7280;
    `;
  
    const RequestPack = styled.div`
      background-color: #EFF6FF;
      color: #2563EB;
      padding: 0.5rem 0.75rem;
      border-radius: 0.5rem;
      font-size: 0.9rem;
      margin-bottom: 0.75rem;
      display: inline-block;
      font-weight: 500;
    `;
  
    const RequestPreview = styled.div`
      font-size: 0.95rem;
      color: #4B5563;
      margin-bottom: 1rem;
      line-height: 1.5;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    `;
  
    const RequestDate = styled.div`
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 0.85rem;
      color: #9CA3AF;
    `;
  
    const HasRepliesBadge = styled.div`
      position: absolute;
      top: 1rem;
      right: 1rem;
      background-color: #4F46E5;
      color: white;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.7rem;
      font-weight: bold;
    `;
  
    const DetailPanel = styled(motion.div)`
      background-color: white;
      border-radius: 1rem;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
      height: calc(100vh - 200px);
      overflow-y: auto;
      display: ${props => props.isOpen ? 'flex' : 'none'};
      flex-direction: column;
      
      &::-webkit-scrollbar {
        width: 8px;
      }
      
      &::-webkit-scrollbar-track {
        background: #F9FAFB;
        border-radius: 0 1rem 1rem 0;
      }
      
      &::-webkit-scrollbar-thumb {
        background: #D1D5DB;
        border-radius: 4px;
      }
      
      &::-webkit-scrollbar-thumb:hover {
        background: #9CA3AF;
      }
      
      @media (max-width: 992px) {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1000;
        height: 100vh;
        border-radius: 0;
      }
    `;
  
    const DetailHeader = styled.div`
      padding: 1.5rem;
      border-bottom: 1px solid #E5E7EB;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: sticky;
      top: 0;
      background-color: white;
      z-index: 10;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    `;
  
    const DetailTitle = styled.h2`
      font-size: 1.3rem;
      font-weight: 700;
      display: flex;
      align-items: center;
      color: #111827;
    `;
  
    const CloseButton = styled.button`
      background: none;
      border: none;
      font-size: 1.5rem;
      cursor: pointer;
      color: #6B7280;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      transition: all 0.2s ease;
      
      &:hover {
        color: #1F2937;
        background-color: #F3F4F6;
      }
    `;
  
    const DetailContent = styled.div`
      padding: 1.5rem;
      flex: 1;
      overflow-y: auto;
    `;
  
    const DetailSection = styled.div`
      margin-bottom: 2rem;
      
      &:last-child {
        margin-bottom: 0;
      }
    `;
  
    const DetailSectionTitle = styled.h3`
      font-size: 1.1rem;
      font-weight: 600;
      margin-bottom: 1rem;
      color: #4F46E5;
      border-bottom: 1px solid #E5E7EB;
      padding-bottom: 0.75rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;
    `;
  
    const DetailInfo = styled.div`
      display: flex;
      margin-bottom: 1rem;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      @media (max-width: 576px) {
        flex-direction: column;
        gap: 0.25rem;
      }
    `;
  
    const DetailInfoLabel = styled.div`
      font-weight: 500;
      color: #6B7280;
      width: 120px;
      flex-shrink: 0;
      
      @media (max-width: 576px) {
        width: 100%;
      }
    `;
  
    const DetailInfoValue = styled.div`
      color: #1F2937;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      
      a {
        color: #4F46E5;
        text-decoration: none;
        transition: all 0.2s ease;
        
        &:hover {
          text-decoration: underline;
          color: #4338CA;
        }
      }
    `;
  
    const DetailPack = styled.span`
      background-color: #EFF6FF;
      color: #2563EB;
      padding: 0.35rem 0.75rem;
      border-radius: 0.5rem;
      font-size: 0.9rem;
      font-weight: 500;
    `;
  
    const DetailMessage = styled.div`
      background-color: #F9FAFB;
      padding: 1.5rem;
      border-radius: 0.75rem;
      font-size: 0.95rem;
      line-height: 1.6;
      color: #4B5563;
      white-space: pre-wrap;
      border: 1px solid #E5E7EB;
    `;
  
    const DetailStatusBadge = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    background-color: ${props => `${props.color}20`};
    color: ${props => props.color};
    padding: 0.5rem 1.25rem;
    border-radius: 0.75rem;
    font-weight: 600;
    font-size: 1rem;
    
    &::before {
      content: '';
      display: block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: ${props => props.color};
    }
  `;

  const DetailActions = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-top: 2rem;
    
    @media (max-width: 576px) {
      flex-direction: column;
    }
  `;

  const ActionButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    background-color: ${props => `${props.color}10`};
    color: ${props => props.color};
    border: 1px solid ${props => props.color};
    padding: 0.75rem 1.25rem;
    border-radius: 0.75rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    flex: 1;
    
    &:hover {
      background-color: ${props => props.color};
      color: white;
      transform: translateY(-1px);
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }
    
    &:active {
      transform: translateY(0);
    }
    
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      
      &:hover {
        background-color: ${props => `${props.color}10`};
        color: ${props => props.color};
        transform: none;
        box-shadow: none;
      }
    }
  `;

  const ReplyButton = styled(ActionButton)`
    background-color: #EFF6FF;
    color: #2563EB;
    border-color: #BFDBFE;
    
    &:hover {
      background-color: #2563EB;
    }
  `;

  const ReplyFormContainer = styled(motion.div)`
    margin-top: 1rem;
    border: 1px solid #E5E7EB;
    border-radius: 0.75rem;
    overflow: hidden;
  `;

  const ReplyTextarea = styled.textarea`
    width: 100%;
    min-height: 120px;
    padding: 1rem;
    border: none;
    outline: none;
    resize: vertical;
    font-family: inherit;
    font-size: 0.95rem;
    color: #1F2937;
    
    &::placeholder {
      color: #9CA3AF;
    }
  `;

  const ReplyFormActions = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 1rem;
    background-color: #F9FAFB;
    border-top: 1px solid #E5E7EB;
  `;

  const ReplyFormInfo = styled.div`
    font-size: 0.85rem;
    color: #6B7280;
  `;

  const SendReplyButton = styled.button`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background-color: #4F46E5;
    color: white;
    border: none;
    padding: 0.75rem 1.25rem;
    border-radius: 0.5rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      background-color: #4338CA;
      transform: translateY(-1px);
    }
    
    &:active {
      transform: translateY(0);
    }
    
    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
      
      &:hover {
        transform: none;
      }
    }
  `;

  const RepliesContainer = styled.div`
    margin-top: 1rem;
  `;

  const ReplyItem = styled.div`
    background-color: #F9FAFB;
    border: 1px solid #E5E7EB;
    border-radius: 0.75rem;
    padding: 1rem;
    margin-bottom: 1rem;
    position: relative;
    
    &:last-child {
      margin-bottom: 0;
    }
  `;

  const ReplyHeader = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.75rem;
    font-size: 0.85rem;
    color: #6B7280;
  `;

  const ReplySender = styled.div`
    font-weight: 500;
    color: #4F46E5;
  `;

  const ReplyDate = styled.div``;

  const ReplyContent = styled.div`
    font-size: 0.95rem;
    line-height: 1.6;
    color: #1F2937;
    white-space: pre-wrap;
  `;
  
  const ReplyActions = styled.div`
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    display: flex;
    gap: 0.25rem;
  `;
  
  const ReplyActionButton = styled.button`
    background: none;
    border: none;
    color: #6B7280;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      background-color: #E5E7EB;
      color: #4B5563;
    }
  `;

  const ReplyEditedBadge = styled.span`
    font-size: 0.7rem;
    color: #9CA3AF;
    margin-left: 0.5rem;
    font-style: italic;
  `;

  const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem;
    height: 100%;
  `;

  const LoadingSpinner = styled.div`
    width: 40px;
    height: 40px;
    border: 4px solid #E5E7EB;
    border-top: 4px solid #4F46E5;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 1rem;
    
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  const LoadingText = styled.div`
    color: #6B7280;
    font-size: 1rem;
  `;

  const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem;
    text-align: center;
  `;

  const ErrorIcon = styled.div`
    font-size: 3rem;
    margin-bottom: 1rem;
    color: #EF4444;
  `;

  const ErrorTitle = styled.h2`
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #EF4444;
  `;

  const ErrorMessage = styled.div`
    color: #6B7280;
    font-size: 1rem;
    max-width: 500px;
    margin-bottom: 2rem;
  `;

  const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4rem 2rem;
    text-align: center;
  `;

  const EmptyIcon = styled.div`
    font-size: 4rem;
    margin-bottom: 1.5rem;
    color: #D1D5DB;
  `;

  const EmptyText = styled.h3`
    font-size: 1.3rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: #4B5563;
  `;

  const EmptySubtext = styled.p`
    color: #9CA3AF;
    font-size: 1rem;
    max-width: 300px;
  `;

  const EmptyDetailState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 2rem;
    text-align: center;
  `;

  const EmptyDetailIcon = styled.div`
    font-size: 3rem;
    margin-bottom: 1.5rem;
    color: #D1D5DB;
  `;

  const EmptyDetailText = styled.p`
    color: #6B7280;
    font-size: 1.1rem;
  `;

  // Mobile Components
  const MobileContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #F9FAFB;
  `;

  const MobileHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    background-color: white;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 0;
    z-index: 10;
  `;

  const MobileBackButton = styled.button`
    background: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: #4B5563;
    
    &:active {
      background-color: #F3F4F6;
    }
  `;

  const MobileTitle = styled.h1`
    font-size: 1.2rem;
    font-weight: 600;
    color: #111827;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  `;

  const MobileFilters = styled.div`
    padding: 1rem;
    background-color: white;
    border-bottom: 1px solid #E5E7EB;
  `;

  const MobileSearchBar = styled.div`
    display: flex;
    align-items: center;
    background-color: #F3F4F6;
    border-radius: 0.75rem;
    padding: 0.75rem 1rem;
    margin-bottom: 1rem;
  `;

  const MobileFilterRow = styled.div`
    display: flex;
    gap: 0.5rem;
  `;

  const MobileFilterButton = styled.button`
    flex: 1;
    padding: 0.75rem;
    border: 1px solid #E5E7EB;
    border-radius: 0.75rem;
    background-color: white;
    color: #4B5563;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    
    &.active {
      background-color: #EFF6FF;
      color: #2563EB;
      border-color: #BFDBFE;
    }
  `;

  const MobileList = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 0.5rem;
  `;

  const MobileListItem = styled.div`
    background-color: white;
    border-radius: 0.75rem;
    padding: 1rem;
    margin-bottom: 0.75rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    border-left: 4px solid ${props => props.color || 'transparent'};
    position: relative;
  `;

  const MobileItemHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.75rem;
  `;

  const MobileItemTitle = styled.h3`
    font-size: 1rem;
    font-weight: 600;
    margin: 0;
    color: #111827;
  `;

  const MobileItemStatus = styled.div`
    background-color: ${props => `${props.color}20`};
    color: ${props => props.color};
    padding: 0.25rem 0.75rem;
    border-radius: 2rem;
    font-size: 0.75rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.3rem;
    
    &::before {
      content: '';
      display: block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: ${props => props.color};
    }
  `;

  const MobileItemInfo = styled.div`
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
    color: #4B5563;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  `;

  const MobileDetailView = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    z-index: 100;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  `;

  const MobileDetailContent = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 1.5rem 1rem;
  `;

  const MobileDetailSection = styled.div`
    margin-bottom: 1.5rem;
    background-color: white;
    border-radius: 0.75rem;
    padding: 1rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  `;

  const MobileDetailSectionTitle = styled.h3`
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #4F46E5;
    border-bottom: 1px solid #E5E7EB;
    padding-bottom: 0.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  `;

  const MobileDetailRow = styled.div`
    margin-bottom: 0.75rem;
    
    &:last-child {
      margin-bottom: 0;
    }
  `;

  const MobileDetailLabel = styled.div`
    font-size: 0.85rem;
    font-weight: 500;
    color: #6B7280;
    margin-bottom: 0.25rem;
  `;

  const MobileDetailValue = styled.div`
    font-size: 0.95rem;
    color: #1F2937;
  `;

  const MobileDetailMessage = styled.div`
    background-color: #F9FAFB;
    padding: 1rem;
    border-radius: 0.75rem;
    font-size: 0.95rem;
    line-height: 1.6;
    color: #4B5563;
    white-space: pre-wrap;
    border: 1px solid #E5E7EB;
  `;

  const MobileDetailActions = styled.div`
    padding: 1rem;
    border-top: 1px solid #E5E7EB;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
    background-color: white;
  `;

  const MobileActionButton = styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    background-color: ${props => `${props.color}10`};
    color: ${props => props.color};
    border: 1px solid ${props => props.color};
    padding: 0.75rem;
    border-radius: 0.75rem;
    font-weight: 500;
    font-size: 0.85rem;
    
    &:disabled {
      opacity: 0.5;
    }
  `;

  const MobileActionIcon = styled.div`
    font-size: 1.2rem;
  `;

  const MobileReplyButton = styled(MobileActionButton)`
    grid-column: span 2;
    background-color: #EFF6FF;
    color: #2563EB;
    border-color: #BFDBFE;
    flex-direction: row;
  `;

  const MobileReplyForm = styled(motion.div)`
    padding: 1rem;
    background-color: white;
    border-top: 1px solid #E5E7EB;
  `;

  const MobileReplyTextarea = styled.textarea`
    width: 100%;
    min-height: 100px;
    padding: 1rem;
    border: 1px solid #E5E7EB;
    border-radius: 0.75rem;
    outline: none;
    resize: none;
    font-family: inherit;
    font-size: 0.95rem;
    margin-bottom: 1rem;
    
    &::placeholder {
      color: #9CA3AF;
    }
  `;

  const MobileReplySendButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;
    background-color: #4F46E5;
    color: white;
    border: none;
    padding: 0.75rem;
    border-radius: 0.75rem;
    font-weight: 500;
    
    &:disabled {
      opacity: 0.7;
    }
  `;

  const MobileRepliesSection = styled.div`
    margin-top: 1rem;
  `;

  const MobileReplyItem = styled.div`
    background-color: #F9FAFB;
    border: 1px solid #E5E7EB;
    border-radius: 0.75rem;
    padding: 1rem;
    margin-bottom: 0.75rem;
    position: relative;
    
    &:last-child {
      margin-bottom: 0;
    }
  `;

  const MobileReplyHeader = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.75rem;
    font-size: 0.8rem;
    color: #6B7280;
  `;

  const MobileReplySender = styled.div`
    font-weight: 500;
    color: #4F46E5;
  `;

  const MobileReplyContent = styled.div`
    font-size: 0.9rem;
    line-height: 1.5;
    color: #1F2937;
    white-space: pre-wrap;
  `;
  
  const MobileReplyActions = styled.div`
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    display: flex;
    gap: 0.25rem;
  `;
  
  const MobileReplyActionButton = styled.button`
    background: none;
    border: none;
    color: #6B7280;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:active {
      background-color: #E5E7EB;
    }
  `;

  const MobileTabBar = styled.div`
    display: flex;
    border-bottom: 1px solid #E5E7EB;
    background-color: white;
  `;

  const MobileTab = styled.button`
    flex: 1;
    padding: 0.75rem;
    border: none;
    background: none;
    font-size: 0.9rem;
    color: ${props => props.active ? '#4F46E5' : '#6B7280'};
    font-weight: ${props => props.active ? '600' : '400'};
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 2px;
      background-color: ${props => props.active ? '#4F46E5' : 'transparent'};
    }
  `;

  if (isAuthChecking) {
    return (
      <LoadingContainer>
        <LoadingSpinner />
        <LoadingText>Vérification de l'authentification...</LoadingText>
      </LoadingContainer>
    );
  }

  if (!isAuthorized && !isAuthChecking) {
    return (
      <ErrorContainer>
        <ErrorIcon>⚠️</ErrorIcon>
        <ErrorTitle>Accès non autorisé</ErrorTitle>
        <ErrorMessage>{error || "Vous n'êtes pas autorisé à accéder à cette page."}</ErrorMessage>
        <BackButton onClick={() => navigate('/')}>
          <FaArrowLeft /> Retour à l'accueil
        </BackButton>
      </ErrorContainer>
    );
  }

 
  // Version desktop
  return (
    <Container
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={containerVariants}
    >
      <Header>
        <HeaderTitle>
          <HeaderIcon>📨</HeaderIcon>
          Demandes de contact
        </HeaderTitle>
        <BackButton onClick={() => navigate('/structuredashboard')}>
          <FaArrowLeft /> Retour au tableau de bord
        </BackButton>
      </Header>

      <FiltersSection>
        <SearchBar>
          <SearchIcon>
            <FaSearch />
          </SearchIcon>
          <SearchInput 
            type="text" 
            placeholder="Rechercher..." 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </SearchBar>

        <FiltersGroup>
          <FilterLabel>
            <FaFilter /> Filtrer par:
          </FilterLabel>
          <FilterSelect 
            value={filterStatus} 
            onChange={(e) => setFilterStatus(e.target.value)}
          >
            <option value="all">Tous les statuts</option>
            <option value="pending">En attente</option>
            <option value="processed">Traités</option>
            <option value="rejected">Rejetés</option>
          </FilterSelect>

          <FilterSelect 
            value={sortOrder} 
            onChange={(e) => setSortOrder(e.target.value)}
          >
            <option value="newest">Plus récents d'abord</option>
            <option value="oldest">Plus anciens d'abord</option>
          </FilterSelect>
        </FiltersGroup>
      </FiltersSection>

      <ContentWrapper>
        <RequestsList>
          <RequestsCount>
            {filteredRequests.length} demande{filteredRequests.length !== 1 ? 's' : ''} trouvée{filteredRequests.length !== 1 ? 's' : ''}
          </RequestsCount>

          {isLoading ? (
            <LoadingContainer>
              <LoadingSpinner />
              <LoadingText>Chargement des demandes...</LoadingText>
            </LoadingContainer>
          ) : error ? (
            <ErrorContainer>
              <ErrorIcon>⚠️</ErrorIcon>
              <ErrorMessage>{error}</ErrorMessage>
            </ErrorContainer>
          ) : filteredRequests.length === 0 ? (
            <EmptyState>
              <EmptyIcon>📭</EmptyIcon>
              <EmptyText>Aucune demande trouvée</EmptyText>
              <EmptySubtext>
                {filterStatus !== 'all' || searchTerm 
                  ? "Essayez de modifier vos filtres de recherche"
                  : "Vous n'avez pas encore reçu de demandes de contact"}
              </EmptySubtext>
            </EmptyState>
          ) : (
            <AnimatePresence>
              {filteredRequests.map((request, index) => (
                <RequestItem
                  key={request.id}
                  variants={listItemVariants}
                  initial="hidden"
                  animate="visible"
                  whileHover="hover"
                  transition={{ delay: index * 0.05 }}
                  onClick={() => {
                    setSelectedRequest(request);
                    setShowReplyForm(false);
                    setIsEditingReply(false);
                    setEditingReplyIndex(null);
                    setReplyMessage('');
                    if (replyTextareaRef.current) {
                      replyTextareaRef.current.value = '';
                    }
                  }}
                  isSelected={selectedRequest?.id === request.id}
                >
                  {request.hasReplies && (
                    <HasRepliesBadge>
                      <FaReply size={10} />
                    </HasRepliesBadge>
                  )}
                  
                  <RequestHeader>
                    <RequestType>
                      {getUserTypeIcon(request.type)}
                      <RequestTypeText>{request.type || 'Inconnu'}</RequestTypeText>
                    </RequestType>
                    <RequestStatus color={getStatusColor(request.status)}>
                      {getStatusLabel(request.status)}
                    </RequestStatus>
                  </RequestHeader>
                  
                  <RequestName>
                    {request.structure ? (
                      <>
                        <FaBuilding style={{ marginRight: '8px' }} />
                        {request.structure}
                      </>
                    ) : (
                      <>
                        <FaUser style={{ marginRight: '8px' }} />
                        {request.name || 'Nom inconnu'}
                      </>
                    )}
                  </RequestName>
                  
                  <RequestInfo>
                    {request.email && (
                      <RequestInfoItem>
                        <FaEnvelope /> {request.email}
                      </RequestInfoItem>
                    )}
                    {request.phone && (
                      <RequestInfoItem>
                        <FaPhone /> {request.phone}
                      </RequestInfoItem>
                    )}
                  </RequestInfo>
                  
                  {request.pack && (
                    <RequestPack>
                      Pack demandé: <strong>{request.pack}</strong>
                    </RequestPack>
                  )}
                  
                  <RequestPreview>
                    {request.message ? (
                      `${request.message.substring(0, 100)}${request.message.length > 100 ? '...' : ''}`
                    ) : (
                      'Pas de message'
                    )}
                  </RequestPreview>
                  
                  <RequestDate>
                    <FaCalendarAlt /> {formatDate(request.createdAt)}
                  </RequestDate>
                </RequestItem>
              ))}
            </AnimatePresence>
          )}
        </RequestsList>

        <DetailPanel isOpen={!!selectedRequest}>
          {selectedRequest ? (
            <>
              <DetailHeader>
                <DetailTitle>
                  {selectedRequest.structure ? (
                    <>
                      <FaBuilding style={{ marginRight: '10px' }} />
                      {selectedRequest.structure}
                    </>
                  ) : (
                    <>
                      <FaUser style={{ marginRight: '10px' }} />
                      {selectedRequest.name || 'Nom inconnu'}
                    </>
                  )}
                </DetailTitle>
                <CloseButton onClick={() => setSelectedRequest(null)}>×</CloseButton>
              </DetailHeader>

              <DetailContent>
                <DetailSection>
                  <DetailSectionTitle>Informations générales</DetailSectionTitle>
                  <DetailInfo>
                    <DetailInfoLabel>Type:</DetailInfoLabel>
                    <DetailInfoValue>
                      {getUserTypeIcon(selectedRequest.type)}
                      {selectedRequest.type || 'Inconnu'}
                    </DetailInfoValue>
                  </DetailInfo>
                  
                  {selectedRequest.name && (
                    <DetailInfo>
                      <DetailInfoLabel>Nom:</DetailInfoLabel>
                      <DetailInfoValue>{selectedRequest.name}</DetailInfoValue>
                    </DetailInfo>
                  )}
                  
                
                  {selectedRequest.email && (
                    <DetailInfo>
                      <DetailInfoLabel>Email:</DetailInfoLabel>
                      <DetailInfoValue>
                        <a href={`mailto:${selectedRequest.email}`}>{selectedRequest.email}</a>
                      </DetailInfoValue>
                    </DetailInfo>
                  )}
                  
                  {selectedRequest.phone && (
                    <DetailInfo>
                      <DetailInfoLabel>Téléphone:</DetailInfoLabel>
                      <DetailInfoValue>
                        <a href={`tel:${selectedRequest.phone}`}>{selectedRequest.phone}</a>
                      </DetailInfoValue>
                    </DetailInfo>
                  )}
                  
                  {selectedRequest.structureType && (
                    <DetailInfo>
                      <DetailInfoLabel>Type de structure:</DetailInfoLabel>
                      <DetailInfoValue>{selectedRequest.structureType}</DetailInfoValue>
                    </DetailInfo>
                  )}
                  
                  {selectedRequest.specialty && (
                    <DetailInfo>
                      <DetailInfoLabel>Spécialité:</DetailInfoLabel>
                      <DetailInfoValue>{selectedRequest.specialty}</DetailInfoValue>
                    </DetailInfo>
                  )}
                  
                  {selectedRequest.pack && (
                    <DetailInfo>
                      <DetailInfoLabel>Pack demandé:</DetailInfoLabel>
                      <DetailInfoValue>
                        <DetailPack>{selectedRequest.pack}</DetailPack>
                      </DetailInfoValue>
                    </DetailInfo>
                  )}
                </DetailSection>

                <DetailSection>
                  <DetailSectionTitle>Message</DetailSectionTitle>
                  <DetailMessage>
                    {selectedRequest.message || 'Aucun message fourni'}
                  </DetailMessage>
                </DetailSection>

                {/* Section des réponses */}
                {selectedRequest.replies && selectedRequest.replies.length > 0 && (
                  <DetailSection>
                    <DetailSectionTitle>
                      <FaReply /> Réponses ({selectedRequest.replies.length})
                    </DetailSectionTitle>
                    <RepliesContainer>
                      {selectedRequest.replies.map((reply, index) => (
                        <ReplyItem key={index}>
                          <ReplyHeader>
                            <ReplySender>{reply.sentBy}</ReplySender>
                            <ReplyDate>
                              {formatDate(reply.sentAt?.toDate ? reply.sentAt.toDate() : reply.sentAt)}
                              {reply.wasEdited && <ReplyEditedBadge>(modifié)</ReplyEditedBadge>}
                            </ReplyDate>
                          </ReplyHeader>
                          <ReplyContent>{reply.message}</ReplyContent>
                          
                          {/* Actions sur les réponses (édition) */}
                          {reply.sentBy === (auth.currentUser?.email || 'Structure') && (
                            <ReplyActions>
                              <ReplyActionButton 
                                onClick={(e) => {
                                  e.stopPropagation();
                                  startEditingReply(index);
                                }}
                                title="Modifier cette réponse"
                              >
                                <FaEdit size={14} />
                              </ReplyActionButton>
                            </ReplyActions>
                          )}
                        </ReplyItem>
                      ))}
                    </RepliesContainer>
                  </DetailSection>
                )}

                <DetailSection>
                  <DetailSectionTitle>Dates</DetailSectionTitle>
                  <DetailInfo>
                    <DetailInfoLabel>Créé le:</DetailInfoLabel>
                    <DetailInfoValue>{formatDate(selectedRequest.createdAt)}</DetailInfoValue>
                  </DetailInfo>
                  
                  {selectedRequest.updatedAt && (
                    <DetailInfo>
                      <DetailInfoLabel>Mis à jour le:</DetailInfoLabel>
                      <DetailInfoValue>
                        {formatDate(selectedRequest.updatedAt instanceof Timestamp ? 
                          selectedRequest.updatedAt.toDate() : 
                          selectedRequest.updatedAt)}
                      </DetailInfoValue>
                    </DetailInfo>
                  )}
                </DetailSection>

                <DetailSection>
                  <DetailSectionTitle>Statut actuel</DetailSectionTitle>
                  <DetailStatusBadge color={getStatusColor(selectedRequest.status)}>
                    {getStatusLabel(selectedRequest.status)}
                  </DetailStatusBadge>
                </DetailSection>

                {/* Formulaire de réponse */}
                <DetailSection>
                  <DetailSectionTitle>
                    <FaReply /> {isEditingReply ? 'Modifier la réponse' : 'Répondre à cette demande'}
                  </DetailSectionTitle>
                  
                  {showReplyForm ? (
                    <ReplyFormContainer
                      initial="hidden"
                      animate="visible"
                      exit="exit"
                      variants={replyFormVariants}
                    >
                      <ReplyTextarea
                        placeholder="Écrivez votre réponse ici..."
                        ref={replyTextareaRef}
                        defaultValue={replyMessage}
                        onBlur={() => {
                          if (replyTextareaRef.current) {
                            setReplyMessage(replyTextareaRef.current.value);
                          }
                        }}
                      />
                      <ReplyFormActions>
                        <ReplyFormInfo>
                          {isEditingReply ? 
                            'Modification de la réponse' : 
                            `La réponse sera envoyée à ${selectedRequest.email || 'l\'utilisateur'}`
                          }
                        </ReplyFormInfo>
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                          <ActionButton 
                            color="#6B7280"
                            onClick={cancelEditingReply}
                          >
                            Annuler
                          </ActionButton>
                          <SendReplyButton
                            onClick={sendReply}
                            disabled={!replyMessage.trim() || isSendingReply}
                          >
                            {isSendingReply ? 'Envoi en cours...' : (
                              <>
                                <FaPaperPlane /> {isEditingReply ? 'Modifier' : 'Envoyer'}
                              </>
                            )}
                          </SendReplyButton>
                        </div>
                      </ReplyFormActions>
                    </ReplyFormContainer>
                  ) : (
                    <ReplyButton 
                      color="#2563EB"
                      onClick={() => setShowReplyForm(true)}
                    >
                      <FaReply /> Rédiger une réponse
                    </ReplyButton>
                  )}
                </DetailSection>

                <DetailActions>
                  <ActionButton 
                    color="#10B981"
                    disabled={selectedRequest.status === 'processed'}
                    onClick={() => updateRequestStatus(selectedRequest.id, 'processed')}
                  >
                    <FaCheck /> Traité
                  </ActionButton>
                  
                  <ActionButton 
                    color="#EF4444"
                    disabled={selectedRequest.status === 'rejected'}
                    onClick={() => updateRequestStatus(selectedRequest.id, 'rejected')}
                  >
                    <FaTimes /> Rejeter
                  </ActionButton>
                  
                  <ActionButton 
                    color="#FCD34D"
                    disabled={selectedRequest.status === 'pending'}
                    onClick={() => updateRequestStatus(selectedRequest.id, 'pending')}
                  >
                    <FaEllipsisH /> En attente
                  </ActionButton>
                </DetailActions>
              </DetailContent>
            </>
          ) : (
            <EmptyDetailState>
              <EmptyDetailIcon>👈</EmptyDetailIcon>
              <EmptyDetailText>Sélectionnez une demande pour voir les détails</EmptyDetailText>
            </EmptyDetailState>
          )}
        </DetailPanel>
      </ContentWrapper>
      
      {/* Toast notifications */}
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Container>
  );
};

                      

      

      


  
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const docRef = doc(db, "structures", user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setStructureData(docSnap.data());
          // Autres appels pour récupérer les données
            // Si vous voulez aussi charger les auxiliaires immédiatement
        fetchAuxiliaires(user.uid);
        } else {
          navigate("/auth");
        }
      } else {
        navigate("/auth");
      }
    });
    return () => unsubscribe();
  }, [auth, navigate]);

  // Fonction pour réinitialiser le formulaire d'auxiliaire
  const resetAuxiliaireForm = () => {
    setAuxiliaireForm({
      nom: "",
      email: "",
      telephone: "",
      role: "assistant",
      medecinIds: [],
      permissions: {
        ajouterPatients: false,
        ajouterRendezVous: false,
        voirTousLesRendezVous: false
      },
      horaires: {
        lundi: { actif: false, debut: "08:00", fin: "18:00" },
        mardi: { actif: false, debut: "08:00", fin: "18:00" },
        mercredi: { actif: false, debut: "08:00", fin: "18:00" },
        jeudi: { actif: false, debut: "08:00", fin: "18:00" },
        vendredi: { actif: false, debut: "08:00", fin: "18:00" },
        samedi: { actif: false, debut: "08:00", fin: "18:00" },
        dimanche: { actif: false, debut: "08:00", fin: "18:00" }
      }
    });
  };

  const handleHoraireChange = (jour, field, value) => {
    setAuxiliaireForm(prev => ({
      ...prev,
      horaires: {
        ...prev.horaires,
        [jour]: {
          ...prev.horaires[jour],
          [field]: field === "actif" ? !prev.horaires[jour].actif : value
        }
      }
    }));
  };


// Fonction pour gérer les changements dans le formulaire
const handleAuxiliaireChange = (e) => {
  const { name, value } = e.target;
  setAuxiliaireForm(prev => ({
    ...prev,
    [name]: value
  }));
};

const handleAddAuxiliaire = async (e) => {
  e.preventDefault();
  try {
    const user = auth.currentUser;
    let auxiliaireAuthId;
    let generatedPassword = "";

    if (!currentAuxiliaire) {
      console.log("🔄 Création d'un nouvel auxiliaire...");
      generatedPassword = generateRandomPassword(6);
      console.log("🔑 Mot de passe généré");

      try {
        // Utiliser la seconde instance d'authentification
        console.log("👤 Création du compte utilisateur...");
        const userCredential = await createUserWithEmailAndPassword(
          secondaryAuth,
          auxiliaireForm.email,
          generatedPassword
        );
        auxiliaireAuthId = userCredential.user.uid;
        console.log("✅ Compte utilisateur créé avec succès, UID:", auxiliaireAuthId);

        // Déconnecter immédiatement l'utilisateur de la seconde instance
        await signOut(secondaryAuth);
        console.log("👋 Utilisateur déconnecté de l'authentification secondaire");

        // Préparer et envoyer le message de bienvenue
        console.log("📱 Préparation du message WhatsApp pour l'auxiliaire...");
        const welcomeMessage = 
          `Bonjour  ${auxiliaireForm.nom},\n\n` +
          `Vous avez été ajouté(e) comme auxiliaire médical sur notre plateforme!\n\n` +
          `Voici vos informations de connexion:\n` +
          `Email: ${auxiliaireForm.email}\n` +
          `Mot de passe: ${generatedPassword}\n\n` +
          `Nous vous recommandons de changer votre mot de passe après votre première connexion.`;

        console.log("📞 Numéro de téléphone de l'auxiliaire:", auxiliaireForm.telephone);

        // Envoyer le message WhatsApp
        console.log("🚀 Envoi du message WhatsApp à l'auxiliaire...");
        const messageResult = await sendWhatsAppMessage(
          auxiliaireForm.telephone,
          welcomeMessage
        );

        if (messageResult.success) {
          console.log("✅ Message WhatsApp envoyé avec succès à l'auxiliaire!");
          toast.success("Message de bienvenue envoyé à l'auxiliaire par WhatsApp");
        } else {
          console.warn("⚠️ Impossible d'envoyer le message WhatsApp:", messageResult.error);
          toast.warning("Impossible d'envoyer le message WhatsApp à l'auxiliaire. Vérifiez la configuration Maytapi.");
        }
      } catch (authError) {
        console.error("❌ Erreur lors de la création du compte:", authError);
        throw new Error(`Erreur d'authentification: ${authError.message}`);
      }
    } else {
      console.log("🔄 Mise à jour d'un auxiliaire existant...");
      auxiliaireAuthId = currentAuxiliaire.id;
    }

    // Convertir les horaires du format du formulaire vers le format à stocker
    const horairesAEnregistrer = [];
    Object.entries(auxiliaireForm.horaires).forEach(([jour, valeur]) => {
      if (valeur.actif) {
        horairesAEnregistrer.push({
          jour: jour.charAt(0).toUpperCase() + jour.slice(1),
          heureDebut: valeur.debut,
          heureFin: valeur.fin,
        });
      }
    });

    const auxiliaireData = {
      ...auxiliaireForm,
      horaires: horairesAEnregistrer, // Utiliser le format converti des horaires
      structureId: user.uid,
      role: auxiliaireForm.role,
      type: "auxiliaire"
    };

    console.log("💾 Enregistrement des données de l'auxiliaire...");
    console.log("📅 Horaires de travail configurés:", horairesAEnregistrer);

    if (currentAuxiliaire) {
      await updateDoc(doc(db, "auxiliaires", currentAuxiliaire.id), {
        ...auxiliaireData,
        updatedAt: new Date()
      });
      console.log("✅ Auxiliaire mis à jour avec succès");
      setMessage("Auxiliaire mis à jour avec succès.");
    } else {
      await setDoc(doc(db, "auxiliaires", auxiliaireAuthId), {
        ...auxiliaireData,
        createdAt: new Date()
      });
      console.log("✅ Auxiliaire ajouté avec succès");
      setMessage("Auxiliaire ajouté avec succès.");
    }

    resetAuxiliaireForm();
    setShowAuxiliaireModal(false);
    fetchAuxiliaires(user.uid);
    setTimeout(() => setMessage(""), 3000);
  } catch (error) {
    console.error("❌ Erreur lors de l'ajout/modification de l'auxiliaire:", error);
    setMessage(`Erreur: ${error.message}`);
  }
};


// Fonction pour modifier un auxiliaire
const handleEditAuxiliaire = (auxiliaire) => {
  setCurrentAuxiliaire(auxiliaire);
  
  // Conversion des horaires du format stocké vers le format du formulaire
  let horairesFormattees = {
    lundi: { actif: false, debut: "08:00", fin: "18:00" },
    mardi: { actif: false, debut: "08:00", fin: "18:00" },
    mercredi: { actif: false, debut: "08:00", fin: "18:00" },
    jeudi: { actif: false, debut: "08:00", fin: "18:00" },
    vendredi: { actif: false, debut: "08:00", fin: "18:00" },
    samedi: { actif: false, debut: "08:00", fin: "18:00" },
    dimanche: { actif: false, debut: "08:00", fin: "18:00" }
  };

  // Si l'auxiliaire a des horaires existants, les convertir
  if (auxiliaire.horaires && Array.isArray(auxiliaire.horaires)) {
    auxiliaire.horaires.forEach((horaire) => {
      const jour = horaire.jour.toLowerCase();
      if (horairesFormattees[jour]) {
        horairesFormattees[jour] = {
          actif: true,
          debut: horaire.heureDebut || "08:00",
          fin: horaire.heureFin || "18:00",
        };
      }
    });
  } else if (auxiliaire.horaires && typeof auxiliaire.horaires === "object") {
    // Si les horaires sont déjà au bon format
    horairesFormattees = auxiliaire.horaires;
  }
  
  setAuxiliaireForm({
    nom: auxiliaire.nom || "",
    email: auxiliaire.email || "",
    telephone: auxiliaire.telephone || "",
    role: auxiliaire.role || "assistant",
    medecinIds: auxiliaire.medecinIds || [],
    permissions: auxiliaire.permissions || {
      ajouterPatients: false,
      ajouterRendezVous: false,
      voirTousLesRendezVous: false
    },
    horaires: horairesFormattees
  });
  
  setShowAuxiliaireModal(true);
};

// Fonction pour supprimer un auxiliaire
const handleDeleteAuxiliaire = async (id) => {
  if (window.confirm("Êtes-vous sûr de vouloir supprimer cet auxiliaire ?")) {
    try {
      await deleteDoc(doc(db, "auxiliaires", id));
      setMessage("Auxiliaire supprimé avec succès.");
      const user = auth.currentUser;
      fetchAuxiliaires(user.uid);
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      setMessage(`Erreur lors de la suppression: ${error.message}`);
    }
  }
};

// Fonction pour récupérer les auxiliaires
const fetchAuxiliaires = async (structureId) => {
  try {
    const q = query(
      collection(db, "auxiliaires"),
      where("structureId", "==", structureId)
    );
    const querySnapshot = await getDocs(q);
    const auxiliairesData = [];
    querySnapshot.forEach((doc) => {
      auxiliairesData.push({ id: doc.id, ...doc.data() });
    });
    setAuxiliaires(auxiliairesData);
  } catch (error) {
    setMessage(`Erreur lors du chargement des auxiliaires: ${error.message}`);
  }
};




  if (!structureData)
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
    
  

if(isMobile){
  return (
    <div className="mobile-dashboard">
      {/* Header mobile avec navigation */}
      <div className="mobile-header">
        <div className="mobile-header-content d-flex justify-content-between">
          <button 
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
          <button className="mobile-profile-btn" onClick={handleLogout}>
            <FontAwesomeIcon icon={faSignOutAlt} />
          </button>
          <h1 className="mobile-title">{structureData.nom}</h1>
         
        </div>
      </div>
  
      {/* Menu mobile en overlay */}
      {mobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={() => setMobileMenuOpen(false)}>
          <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
            <div className="mobile-menu-header">
              <h3>{structureData.nom}</h3>
              <button 
                className="mobile-menu-close"
                onClick={() => setMobileMenuOpen(false)}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            
            <div className="mobile-menu-items">
              {[
                { key: "info", icon: faUser, label: "Informations", badge: null },
                { key: "medecins", icon: faUserMd, label: "Médecins", badge: medecins.length },
                { key: "patients", icon: faUser, label: "Patients", badge: patients.length },
                { key: "auxiliaires", icon: faUserNurse, label: "Auxiliaires", badge: auxiliaires.length },
                { key: "rendezvous", icon: faCalendarAlt, label: "Rendez-vous", badge: rendezvous.length },
                { key: "archives", icon: faArchive, label: "Archives", badge: archives.length },
                { key: "demandesRapides", icon: faBolt, label: "RDV rapides", badge: null },
                { key: "ContactRequestsViewer", icon: faInbox, label: "Demandes", badge: newDemandesCount > 0 ? newDemandesCount : null },
                { key: "affiliations", icon: faLink, label: "Affiliations", badge: (pendingDoctorRequests?.length || 0) + (affiliationRequests?.filter(req => req.statut === "en attente")?.length || 0) > 0 ? (pendingDoctorRequests?.length || 0) + (affiliationRequests?.filter(req => req.statut === "en attente")?.length || 0) : null }
              ].map((item) => (
                <button
                  key={item.key}
                  className={`mobile-menu-item ${activeTab === item.key ? "active" : ""}`}
                  onClick={() => {
                    setActiveTab(item.key);
                    setMobileMenuOpen(false);
                  }}
                >
                  <div className="menu-item-content">
                    <FontAwesomeIcon icon={item.icon} className="menu-icon" />
                    <span className="menu-label">{item.label}</span>
                  </div>
                  {item.badge && (
                    <span className="menu-badge">{item.badge}</span>
                  )}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
  
      {/* Contenu principal mobile */}
      <div className="mobile-content">
        {/* Section header avec titre et actions */}
        <div className="mobile-section-header">
          <h2 className="section-title">
            {activeTab === "medecins" && "Médecins"}
            {activeTab === "patients" && "Patients"}
            {activeTab === "auxiliaires" && "Auxiliaires"}
            {activeTab === "rendezvous" && "Rendez-vous"}
            {activeTab === "archives" && "Archives"}
            {activeTab === "demandesRapides" && "RDV rapides"}
            {activeTab === "affiliations" && "Affiliations"}
            {activeTab === "info" && "Informations"}
            {activeTab === "ContactRequestsViewer" && "Demandes"}
          </h2>
  
          {/* Actions spécifiques par section */}
          {(activeTab === "medecins" || activeTab === "patients" || activeTab === "rendezvous" || activeTab === "archives") && (
            <button
              className="mobile-add-btn"
              onClick={() => {
                if (activeTab === "medecins") {
                  resetMedecinForm();
                  setShowMedecinForm(!showMedecinForm);
                } else if (activeTab === "patients") {
                  resetPatientForm();
                  setShowPatientForm(!showPatientForm);
                } else if (activeTab === "rendezvous") {
                  resetRdvForm();
                  setShowRendezvousForm(!showRendezvousForm);
                } else if (activeTab === "archives") {
                  resetArchiveForm();
                  setShowArchiveForm(!showArchiveForm);
                }
              }}
            >
              <FontAwesomeIcon icon={faPlus} />
            </button>
          )}
  
          {activeTab === "auxiliaires" && (
            <button
              className="mobile-add-btn"
              onClick={() => {
                setCurrentAuxiliaire(null);
                resetAuxiliaireForm();
                setShowAuxiliaireModal(true);
              }}
            >
              <FontAwesomeIcon icon={faPlus} />
            </button>
          )}
        </div>
  
        {/* Barre de recherche pour médecins et patients */}
        {(activeTab === "medecins" || activeTab === "patients") && (
          <div className="mobile-search-bar">
            <div className="search-input-container">
              <FontAwesomeIcon icon={faSearch} className="search-icon" />
              <input
                type="text"
                className="mobile-search-input"
                placeholder={activeTab === "medecins" ? "Rechercher un médecin..." : "Rechercher un patient..."}
                value={activeTab === "medecins" ? (medecinSearchQuery || "") : (patientSearchQuery || "")}
                onChange={(e) => {
                  if (activeTab === "medecins") {
                    setMedecinSearchQuery(e.target.value);
                  } else {
                    setPatientSearchQuery(e.target.value);
                  }
                }}
              />
              {((activeTab === "medecins" && medecinSearchQuery) || (activeTab === "patients" && patientSearchQuery)) && (
                <button 
                  className="search-clear-btn"
                  onClick={() => {
                    if (activeTab === "medecins") {
                      setMedecinSearchQuery("");
                    } else {
                      setPatientSearchQuery("");
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              )}
            </div>
          </div>
        )}
  
        {/* Messages de notification */}
        {message && (
          <div className={`mobile-alert ${message.includes("Erreur") ? "error" : "success"}`}>
            <span>{message}</span>
            <button 
              className="alert-close-btn"
              onClick={() => setMessage("")}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        )}
  
        {/* Contenu des sections */}
        <div className="mobile-section-content mb-5">
          
          {/* Section Informations */}
          {activeTab === "info" && (
            <div className="mobile-card">
              <div className="mobile-form">
                {Object.keys(form).map((key) => {
                  if (key === "createdAt" || key === "updatedAt") return null;
  
                  if (key === "specialites") {
                    return (
                      <div className="mobile-form-group" key={key}>
                        <label className="mobile-form-label">Spécialités</label>
                        <div className="mobile-badges">
                          {form.specialites && form.specialites.length > 0 ? (
                            form.specialites.map((specialite) => (
                              <span key={specialite} className="mobile-badge primary">
                                {specialite}
                              </span>
                            ))
                          ) : (
                            <span className="mobile-text-muted">Aucune spécialité</span>
                          )}
                        </div>
                        <div className="mobile-checkboxes">
                          {specialites.map((specialite) => (
                            <label key={specialite} className="mobile-checkbox">
                              <input
                                type="checkbox"
                                value={specialite}
                                checked={form.specialites?.includes(specialite) || false}
                                onChange={(e) => {
                                  const { checked, value } = e.target;
                                  let updatedSpecialites = [...(form.specialites || [])];
                                  if (checked) {
                                    updatedSpecialites.push(value);
                                  } else {
                                    updatedSpecialites = updatedSpecialites.filter(s => s !== value);
                                  }
                                  setForm({ ...form, specialites: updatedSpecialites });
                                }}
                              />
                              <span className="checkbox-label">{specialite}</span>
                            </label>
                          ))}
                        </div>
                      </div>
                    );
                  }
  
                  if (key === "assurances") {
                    return (
                      <div className="mobile-form-group" key={key}>
                        <label className="mobile-form-label">Assurances acceptées</label>
                        <div className="mobile-badges">
                          {form.assurances && form.assurances.length > 0 ? (
                            form.assurances.map((assurance) => (
                              <span key={assurance} className="mobile-badge success">
                                {assurance}
                              </span>
                            ))
                          ) : (
                            <span className="mobile-text-muted">Aucune assurance</span>
                          )}
                        </div>
                        <div className="mobile-checkboxes">
                          {assurancesList.map((assurance) => (
                            <label key={assurance} className="mobile-checkbox">
                              <input
                                type="checkbox"
                                value={assurance}
                                checked={form.assurances?.includes(assurance) || false}
                                onChange={(e) => {
                                  const { checked, value } = e.target;
                                  let updatedAssurances = [...(form.assurances || [])];
                                  if (checked) {
                                    updatedAssurances.push(value);
                                  } else {
                                    updatedAssurances = updatedAssurances.filter(a => a !== value);
                                  }
                                  setForm({ ...form, assurances: updatedAssurances });
                                }}
                              />
                              <span className="checkbox-label">{assurance}</span>
                            </label>
                          ))}
                        </div>
                      </div>
                    );
                  }
  
                  return (
                    <div className="mobile-form-group" key={key}>
                      <label className="mobile-form-label">
                        {key.charAt(0).toUpperCase() + key.slice(1)}
                      </label>
                      <input
                        name={key}
                        value={form[key] || ""}
                        onChange={handleChange}
                        className="mobile-input"
                        placeholder={key}
                      />
                    </div>
                  );
                })}
              </div>
              <button
                onClick={handleUpdate}
                className="mobile-primary-btn"
              >
                <FontAwesomeIcon icon={faCheck} className="btn-icon" />
                Mettre à jour
              </button>
            </div>
          )}
  
          {/* Section Médecins */}
          {activeTab === "medecins" && (
            <div>
              {/* Formulaire d'ajout/modification */}
              {showMedecinForm && (
                <div className="mobile-card form-card">
                  <div className="mobile-card-header">
                    <h3>{currentMedecin ? "Modifier le médecin" : "Ajouter un médecin"}</h3>
                    <button 
                      className="mobile-close-btn"
                      onClick={() => {
                        resetMedecinForm();
                        setShowMedecinForm(false);
                      }}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </div>
                  
                  <form onSubmit={handleAddMedecin} className="mobile-form">
                    <div className="mobile-form-group">
                      <label className="mobile-form-label">Prénom et Nom</label>
                      <input
                        type="text"
                        name="nom"
                        className="mobile-input"
                        value={medecinForm.nom}
                        onChange={handleMedecinChange}
                        required
                      />
                    </div>
  
                    <div className="mobile-form-row">
                      <div className="mobile-form-group">
                        <label className="mobile-form-label">Titre</label>
                        <select
                          name="titre"
                          className="mobile-select"
                          value={medecinForm.titre || "Dr"}
                          onChange={handleMedecinChange}
                          required
                        >
                          <option value="Dr">Dr</option>
                          <option value="Pr">Pr</option>
                        </select>
                      </div>
                      
                      <div className="mobile-form-group">
                        <label className="mobile-checkbox">
                          <input
                            type="checkbox"
                            name="consultationDomicile"
                            checked={medecinForm.consultationDomicile || false}
                            onChange={(e) => {
                              setMedecinForm({
                                ...medecinForm,
                                consultationDomicile: e.target.checked
                              });
                            }}
                          />
                          <span className="checkbox-label">Consultations à domicile</span>
                        </label>
                      </div>
                    </div>
  
                    <div className="mobile-form-group">
                      <label className="mobile-form-label">Spécialité</label>
                      <select
                        name="specialite"
                        className="mobile-select"
                        value={medecinForm.specialite}
                        onChange={handleMedecinChange}
                        required
                      >
                        <option value="">Sélectionner une spécialité</option>
                        {specialites.map((spec) => (
                          <option key={spec} value={spec}>{spec}</option>
                        ))}
                      </select>
                    </div>
  
                    <div className="mobile-form-row">
                      <div className="mobile-form-group">
                        <label className="mobile-form-label">Téléphone</label>
                        <input
                          type="tel"
                          name="telephone"
                          className="mobile-input"
                          value={medecinForm.telephone}
                          onChange={handleMedecinChange}
                          required
                        />
                      </div>
                      
                      <div className="mobile-form-group">
                        <label className="mobile-form-label">Email</label>
                        <input
                          type="email"
                          name="email"
                          className="mobile-input"
                          value={medecinForm.email}
                          onChange={handleMedecinChange}
                          required
                        />
                      </div>
                    </div>
  
                    {/* Disponibilités - Version mobile simplifiée */}
                    <div className="mobile-form-group">
                      <label className="mobile-form-label">Disponibilités</label>
                      <div className="mobile-disponibilites">
                        {joursSemaine.map((jour) => (
                          <div key={jour} className="mobile-jour-container">
                            <div className="jour-header">
                              <label className="mobile-checkbox">
                                <input
                                  type="checkbox"
                                  checked={medecinForm.disponibilites[jour].actif}
                                  onChange={() => handleDisponibiliteChange(jour, "actif")}
                                />
                                <span className="checkbox-label">
                                  {jour.charAt(0).toUpperCase() + jour.slice(1)}
                                </span>
                              </label>
                            </div>
                            
                            {medecinForm.disponibilites[jour].actif && (
                              <div className="creneaux-mobile">
                                {medecinForm.disponibilites[jour].creneaux.map((creneau, index) => (
                                  <div key={index} className="creneau-mobile">
                                    <div className="mobile-form-row">
                                      <input
                                        type="time"
                                        className="mobile-input time-input"
                                        value={creneau.debut}
                                        onChange={(e) => handleDisponibiliteChange(jour, "debut", e.target.value, index)}
                                      />
                                      <input
                                        type="time"
                                        className="mobile-input time-input"
                                        value={creneau.fin}
                                        onChange={(e) => handleDisponibiliteChange(jour, "fin", e.target.value, index)}
                                      />
                                      <button
                                        type="button"
                                        className="mobile-delete-btn"
                                        onClick={() => removeCreneau(jour, index)}
                                        disabled={medecinForm.disponibilites[jour].creneaux.length <= 1}
                                      >
                                        <FontAwesomeIcon icon={faTimes} />
                                      </button>
                                    </div>
                                    <select
                                      className="mobile-select"
                                      value={creneau.structureId || ""}
                                      onChange={(e) => handleDisponibiliteChange(jour, "structureId", e.target.value, index)}
                                    >
                                      <option value="">Structure ou Prestataire actuelle</option>
                                      {allStructures.map((structure) => (
                                        <option key={structure.id} value={structure.id}>
                                          {structure.nom}
                                        </option>
                                      ))}
                                      <option value="autres">Autres</option>
                                    </select>
                                  </div>
                                ))}
                                <button
                                  type="button"
                                  className="mobile-add-creneau-btn"
                                  onClick={() => addCreneau(jour)}
                                >
                                  <FontAwesomeIcon icon={faPlus} className="btn-icon" />
                                  Ajouter un créneau
                                </button>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
  
                    {/* Assurances */}
                    <div className="mobile-form-group">
                      <label className="mobile-form-label">Assurances acceptées</label>
                      <div className="mobile-checkboxes">
                        {assurancesList.map((assurance) => (
                          <label key={assurance} className="mobile-checkbox">
                            <input
                              type="checkbox"
                              name="assurances"
                              value={assurance}
                              checked={medecinForm.assurances.includes(assurance)}
                              onChange={handleMedecinChange}
                            />
                            <span className="checkbox-label">{assurance}</span>
                          </label>
                        ))}
                      </div>
                    </div>
  
                    <div className="mobile-form-actions">
                      <button
                        type="button"
                        className="mobile-secondary-btn"
                        onClick={() => {
                          resetMedecinForm();
                          setShowMedecinForm(false);
                        }}
                      >
                        Annuler
                      </button>
                      <button type="submit" className="mobile-primary-btn">
                        <FontAwesomeIcon icon={faCheck} className="btn-icon" />
                        {currentMedecin ? "Mettre à jour" : "Ajouter"}
                      </button>
                    </div>
                  </form>
                </div>
              )}
  
              {/* Liste des médecins */}
              <div className="mobile-cards-grid">
                {medecins.length > 0 ? (
                  filtreMedecins.map((medecin) => (
                    <div key={medecin.id} className="mobile-item-card">
                      <div className="mobile-card-content">
                        <div className="item-header">
                          <h4 className="item-title">
                            {medecin.titre || "Dr"} {medecin.nom}
                          </h4>
                          <div className="item-badges">
                            <span className="mobile-badge info">{medecin.specialite}</span>
                            {medecin.consultationDomicile && (
                              <span className="mobile-badge success">
                                <FontAwesomeIcon icon={faHome} className="badge-icon" />
                                Domicile
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      
                      <div className="mobile-card-actions">
                        <button
                          className="mobile-action-btn primary"
                          onClick={() => setCurrentView({ type: 'medecin', data: medecin })}
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </button>
                        <button
                          className="mobile-action-btn secondary"
                          onClick={() => handleEditMedecin(medecin)}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                        <button
                          className="mobile-action-btn danger"
                          onClick={() => handleDeleteMedecin(medecin.id)}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="mobile-empty-state">
                    <FontAwesomeIcon icon={faUserMd} className="empty-icon" />
                    <p>Aucun médecin ajouté</p>
                    <button
                      className="mobile-primary-btn"
                      onClick={() => {
                        resetMedecinForm();
                        setShowMedecinForm(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faPlus} className="btn-icon" />
                      Ajouter un médecin
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
  
          {/* Section Patients */}
          {activeTab === "patients" && (
            <div>
              {/* Formulaire d'ajout/modification */}
              {showPatientForm && (
                <div className="mobile-card form-card">
                  <div className="mobile-card-header">
                    <h3>{currentPatient ? "Modifier le patient" : "Ajouter un patient"}</h3>
                    <button 
                      className="mobile-close-btn"
                      onClick={() => {
                        resetPatientForm();
                        setShowPatientForm(false);
                      }}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </div>
                  
                  <form onSubmit={handleAddPatient} className="mobile-form">
                    <div className="mobile-form-group">
                      <label className="mobile-form-label">Prénom et Nom</label>
                      <input
                        type="text"
                        name="nom"
                        className="mobile-input"
                        value={patientForm.nom}
                        onChange={handlePatientChange}
                        required
                      />
                    </div>
  
                    <div className="mobile-form-group">
                      <label className="mobile-form-label">Date de naissance</label>
                      <input
                        type="date"
                        name="dateNaissance"
                        className="mobile-input"
                        value={patientForm.dateNaissance}
                        onChange={handlePatientChange}
                        required
                      />
                    </div>
  
                    <div className="mobile-form-row">
                      <div className="mobile-form-group">
                        <label className="mobile-form-label">Téléphone</label>
                        <input
                          type="tel"
                          name="telephone"
                          className="mobile-input"
                          value={patientForm.telephone}
                          onChange={handlePatientChange}
                          required
                        />
                      </div>
                      
                      <div className="mobile-form-group">
                        <label className="mobile-form-label">Email</label>
                        <input
                          type="email"
                          name="email"
                          className="mobile-input"
                          value={patientForm.email}
                          onChange={handlePatientChange}
                          required
                        />
                      </div>
                    </div>
  
                    <div className="mobile-form-group">
                      <label className="mobile-form-label">Assurances</label>
                      <div className="mobile-checkboxes">
                        {assurancesList.map((assurance) => (
                          <label key={assurance} className="mobile-checkbox">
                            <input
                              type="checkbox"
                              name="assurances"
                              value={assurance}
                              checked={patientForm.assurances.includes(assurance)}
                              onChange={handlePatientChange}
                            />
                            <span className="checkbox-label">{assurance}</span>
                          </label>
                        ))}
                      </div>
                    </div>
  
                    <div className="mobile-form-group">
                      <label className="mobile-form-label">Diagnostics</label>
                      <textarea
                        name="diagnostics"
                        className="mobile-textarea"
                        value={patientForm.diagnostics}
                        onChange={handlePatientChange}
                        rows="3"
                        placeholder="Entrez les diagnostics du patient"
                      />
                    </div>
  
                    <div className="mobile-form-actions">
                      <button
                        type="button"
                        className="mobile-secondary-btn"
                        onClick={() => {
                          resetPatientForm();
                          setShowPatientForm(false);
                        }}
                      >
                        Annuler
                      </button>
                      <button type="submit" className="mobile-primary-btn">
                        <FontAwesomeIcon icon={faCheck} className="btn-icon" />
                        {currentPatient ? "Mettre à jour" : "Ajouter"}
                      </button>
                    </div>
                  </form>
                </div>
              )}
  
              {/* Liste des patients */}
              <div className="mobile-cards-grid">
                {patients.length > 0 ? (
                  filtrePatients.map((patient) => (
                    <div key={patient.id} className="mobile-item-card">
                      <div className="mobile-card-content">
                        <div className="item-header">
                          <h4 className="item-title">{patient.nom}</h4>
                          <div className="item-badges">
                            <span className="mobile-badge secondary">
                              {formatAge(patient.dateNaissance)}
                            </span>
                          </div>
                        </div>
                      </div>
                      
                      <div className="mobile-card-actions">
                        <button
                          className="mobile-action-btn primary"
                          onClick={() => setCurrentView({ type: 'patient', data: patient })}
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </button>
                        <button
                          className="mobile-action-btn secondary"
                          onClick={() => handleEditPatient(patient)}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                        <button
                          className="mobile-action-btn danger"
                          onClick={() => handleDeletePatient(patient.id)}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="mobile-empty-state">
                    <FontAwesomeIcon icon={faUser} className="empty-icon" />
                    <p>Aucun patient ajouté</p>
                    <button
                      className="mobile-primary-btn"
                      onClick={() => {
                        resetPatientForm();
                        setShowPatientForm(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faPlus} className="btn-icon" />
                      Ajouter un patient
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
  
          {/* Section Auxiliaires */}
          {activeTab === "auxiliaires" && (
            <div className="mobile-cards-grid">
              {auxiliaires.length > 0 ? (
                auxiliaires.map((auxiliaire) => (
                  <div key={auxiliaire.id} className="mobile-item-card">
                    <div className="mobile-card-content">
                      <div className="item-header">
                        <h4 className="item-title">{auxiliaire.nom}</h4>
                        <div className="item-badges">
                          <span className="mobile-badge info">{auxiliaire.role}</span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="mobile-card-actions">
                      <button
                        className="mobile-action-btn primary"
                        onClick={() => setCurrentView({ type: 'auxiliaire', data: auxiliaire })}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </button>
                      <button
                        className="mobile-action-btn secondary"
                        onClick={() => handleEditAuxiliaire(auxiliaire)}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                      <button
                        className="mobile-action-btn danger"
                        onClick={() => handleDeleteAuxiliaire(auxiliaire.id)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </div>
                  </div>
                ))
              ) : (
              <div className="mobile-empty-state">
                <FontAwesomeIcon icon={faUserNurse} className="empty-icon" />
                <p>Aucun auxiliaire ajouté</p>
                <button
                  className="mobile-primary-btn"
                  onClick={() => {
                    resetAuxiliaireForm();
                    setShowAuxiliaireModal(true);
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} className="btn-icon" />
                  Ajouter un auxiliaire
                </button>
              </div>
            )}
          </div>
        )}

        {/* Section Rendez-vous */}
        {activeTab === "rendezvous" && (
          <div>
            {/* Formulaire d'ajout/modification */}
            {showRendezvousForm && (
              <div className="mobile-card form-card">
                <div className="mobile-card-header">
                  <h3>{currentRendezvous ? "Modifier le RDV" : "Ajouter un RDV"}</h3>
                  <button 
                    className="mobile-close-btn"
                    onClick={() => {
                      resetRdvForm();
                      setShowRendezvousForm(false);
                    }}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                </div>
                
                <form onSubmit={handleAddRendezvous} className="mobile-form">
                  <div className="mobile-form-group">
                    <label className="mobile-form-label">Médecin</label>
                    <select
                      name="medecinId"
                      className="mobile-select"
                      value={rdvForm.medecinId}
                      onChange={handleRdvChange}
                      required
                    >
                      <option value="">Sélectionner un médecin</option>
                      {medecins.map((medecin) => (
                        <option key={medecin.id} value={medecin.id}>
                          Dr. {medecin.nom} - {medecin.specialite}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mobile-form-group">
                    <label className="mobile-form-label">Patient</label>
                    <select
                      name="patientId"
                      className="mobile-select"
                      value={rdvForm.patientId}
                      onChange={handleRdvChange}
                      required
                    >
                      <option value="">Sélectionner un patient</option>
                      {patients.map((patient) => (
                        <option key={patient.id} value={patient.id}>
                          {patient.nom}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mobile-form-row">
                    <div className="mobile-form-group">
                      <label className="mobile-form-label">Date</label>
                      <input
                        type="date"
                        name="date"
                        className="mobile-input"
                        value={rdvForm.date}
                        onChange={handleRdvChange}
                        required
                      />
                    </div>
                    
                    <div className="mobile-form-group">
                      <label className="mobile-form-label">Statut</label>
                      <select
                        name="statut"
                        className="mobile-select"
                        value={rdvForm.statut}
                        onChange={handleRdvChange}
                        required
                      >
                        {statutsRdv.map((statut) => (
                          <option key={statut} value={statut}>
                            {statut.charAt(0).toUpperCase() + statut.slice(1)}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Créneaux horaires */}
                  {rdvForm.medecinId && rdvForm.date && (
                    <div className="mobile-form-group">
                      <label className="mobile-form-label">Heure</label>
                      <div className="mobile-time-slots">
                        {getCreneauxAvecStatut().map((creneau) => (
                          <button
                            key={creneau.heure}
                            type="button"
                            className={`mobile-time-slot ${creneau.statut} ${
                              rdvForm.heure === creneau.heure ? "selected" : ""
                            }`}
                            onClick={() => {
                              if (creneau.statut !== "complet") {
                                setRdvForm({ ...rdvForm, heure: creneau.heure });
                              }
                            }}
                            disabled={creneau.statut === "complet"}
                          >
                            <span className="time">{creneau.heure}</span>
                            {creneau.statut === "partiel" && (
                              <span className="slot-info">
                                {creneau.nombreRdv}/3
                              </span>
                            )}
                            {creneau.statut === "complet" && (
                              <span className="slot-info">Complet</span>
                            )}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  <div className="mobile-form-group">
                    <label className="mobile-form-label">Motif</label>
                    <textarea
                      name="motif"
                      className="mobile-textarea"
                      value={rdvForm.motif}
                      onChange={handleRdvChange}
                      rows="3"
                      placeholder="Motif de la consultation"
                    />
                  </div>

                  <div className="mobile-form-group">
                    <label className="mobile-form-label">Type de consultation</label>
                    <div className="mobile-radio-group">
                      <label className="mobile-radio">
                        <input
                          type="radio"
                          name="typeConsultation"
                          value="presentiel"
                          checked={rdvForm.typeConsultation === "presentiel"}
                          onChange={handleRdvChange}
                        />
                        <span className="radio-label">Présentiel</span>
                      </label>
                      <label className="mobile-radio">
                        <input
                          type="radio"
                          name="typeConsultation"
                          value="teleconsultation"
                          checked={rdvForm.typeConsultation === "teleconsultation"}
                          onChange={handleRdvChange}
                        />
                        <span className="radio-label">Téléconsultation</span>
                      </label>
                    </div>
                  </div>

                  <div className="mobile-form-actions">
                    <button
                      type="button"
                      className="mobile-secondary-btn"
                      onClick={() => {
                        resetRdvForm();
                        setShowRendezvousForm(false);
                      }}
                    >
                      Annuler
                    </button>
                    <button type="submit" className="mobile-primary-btn">
                      <FontAwesomeIcon icon={faCheck} className="btn-icon" />
                      {currentRendezvous ? "Mettre à jour" : "Ajouter"}
                    </button>
                  </div>
                </form>
              </div>
            )}

            {/* Calendrier mobile simplifié */}
            <div className="mobile-card">
              <div className="mobile-card-header">
                <div className="calendar-nav">
                  <button
                    className="mobile-nav-btn"
                    onClick={handlePrevMonth}
                  >
                    <FontAwesomeIcon icon={faChevronLeft} />
                  </button>
                  <h3 className="calendar-title">
                    {currentMonth.toLocaleString("fr-FR", {
                      month: "long",
                      year: "numeric",
                    })}
                  </h3>
                  <button
                    className="mobile-nav-btn"
                    onClick={handleNextMonth}
                  >
                    <FontAwesomeIcon icon={faChevronRight} />
                  </button>
                </div>
                <button
                  className="mobile-reminder-btn"
                  onClick={sendAppointmentReminders}
                  disabled={loading}
                >
                  <FontAwesomeIcon
                    icon={loading ? faSpinner : faBell}
                    className={loading ? "fa-spin" : ""}
                  />
                </button>
              </div>

              <div className="mobile-calendar">
                <div className="mobile-calendar-header">
                  {["D", "L", "M", "M", "J", "V", "S"].map((day, index) => (
                    <div key={index} className="mobile-calendar-day-header">
                      {day}
                    </div>
                  ))}
                </div>
                <div className="mobile-calendar-body">
                  {getMonthData().map((day, index) => (
                    <div
                      key={index}
                      className={`mobile-calendar-day ${
                        !day.isCurrentMonth ? "other-month" : ""
                      } ${day.hasEvents ? "has-events" : ""}`}
                      onClick={() => handleDateClick(day)}
                    >
                      <span className="day-number">{day.date.getDate()}</span>
                      {day.hasEvents && (
                        <div className="event-dot">
                          <span className="event-count">{day.medecinCount}</span>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Section Archives */}
        {activeTab === "archives" && (
          <div>
            {/* Formulaire d'ajout/modification */}
            {showArchiveForm && (
              <div className="mobile-card form-card">
                <div className="mobile-card-header">
                  <h3>{currentArchive ? "Modifier l'archive" : "Ajouter une archive"}</h3>
                  <button 
                    className="mobile-close-btn"
                    onClick={() => {
                      resetArchiveForm();
                      setShowArchiveForm(false);
                    }}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                </div>
                
                <form onSubmit={handleAddArchive} className="mobile-form">
                  <div className="mobile-form-group">
                    <label className="mobile-form-label">Patient</label>
                    <select
                      name="patientId"
                      className="mobile-select"
                      value={archiveForm.patientId}
                      onChange={handleArchiveChange}
                      required
                    >
                      <option value="">Sélectionner un patient</option>
                      {patients.map((patient) => (
                        <option key={patient.id} value={patient.id}>
                          {patient.nom}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mobile-form-group">
                    <label className="mobile-form-label">Titre</label>
                    <input
                      type="text"
                      name="titre"
                      className="mobile-input"
                      value={archiveForm.titre}
                      onChange={handleArchiveChange}
                      required
                    />
                  </div>

                  <div className="mobile-form-group">
                    <label className="mobile-form-label">Date</label>
                    <input
                      type="date"
                      name="date"
                      className="mobile-input"
                      value={archiveForm.date}
                      onChange={handleArchiveChange}
                      required
                    />
                  </div>

                  <div className="mobile-form-group">
                    <label className="mobile-form-label">Description</label>
                    <textarea
                      name="description"
                      className="mobile-textarea"
                      value={archiveForm.description}
                      onChange={handleArchiveChange}
                      rows="3"
                      placeholder="Description de l'archive"
                    />
                  </div>

                  <div className="mobile-form-group">
                    <label className="mobile-form-label">Notes</label>
                    <textarea
                      name="notes"
                      className="mobile-textarea"
                      value={archiveForm.notes}
                      onChange={handleArchiveChange}
                      rows="3"
                      placeholder="Notes additionnelles"
                    />
                  </div>

                  <div className="mobile-form-group">
                    <label className="mobile-form-label">Tags</label>
                    <div className="mobile-checkboxes">
                      {tagsList.map((tag) => (
                        <label key={tag} className="mobile-checkbox">
                          <input
                            type="checkbox"
                            name="tags"
                            value={tag}
                            checked={archiveForm.tags.includes(tag)}
                            onChange={handleArchiveChange}
                          />
                          <span className="checkbox-label">{tag}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="mobile-form-group">
                    <label className="mobile-form-label">Fichiers</label>
                    <input
                      type="file"
                      className="mobile-file-input"
                      onChange={handleFileChange}
                      multiple
                    />
                    {selectedFiles.length > 0 && (
                      <div className="mobile-file-list">
                        {selectedFiles.map((file, index) => (
                          <div key={index} className="mobile-file-item">
                            <span className="file-name">{file.name}</span>
                            <span className="file-size">
                              {(file.size / 1024).toFixed(2)} KB
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="mobile-form-actions">
                    <button
                      type="button"
                      className="mobile-secondary-btn"
                      onClick={() => {
                        resetArchiveForm();
                        setShowArchiveForm(false);
                      }}
                    >
                      Annuler
                    </button>
                    <button type="submit" className="mobile-primary-btn">
                      <FontAwesomeIcon icon={faCheck} className="btn-icon" />
                      {currentArchive ? "Mettre à jour" : "Ajouter"}
                    </button>
                  </div>
                </form>
              </div>
            )}

            {/* Barre de recherche pour archives */}
            <div className="mobile-search-bar">
              <div className="search-input-container">
                <FontAwesomeIcon icon={faSearch} className="search-icon" />
                <input
                  type="text"
                  className="mobile-search-input"
                  placeholder="Rechercher une archive..."
                  value={filtreArchivePatient}
                  onChange={(e) => setFiltreArchivePatient(e.target.value)}
                />
                {filtreArchivePatient && (
                  <button 
                    className="search-clear-btn"
                    onClick={() => setFiltreArchivePatient("")}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                )}
              </div>
            </div>

            {/* Liste des archives */}
            <div className="mobile-cards-grid">
              {archives.length > 0 ? (
                archives
                  .filter((archive) => {
                    if (!filtreArchivePatient) return true;
                    const patientNom = archive.patientNom || "";
                    return patientNom
                      .toLowerCase()
                      .includes(filtreArchivePatient.toLowerCase());
                  })
                  .map((archive) => (
                    <div key={archive.id} className="mobile-item-card">
                      <div className="mobile-card-content">
                        <div className="item-header">
                          <h4 className="item-title">{archive.titre}</h4>
                          <div className="item-meta">
                            <span className="meta-text">{archive.patientNom}</span>
                            <span className="meta-date">
                              {new Date(archive.date).toLocaleDateString()}
                            </span>
                          </div>
                        </div>
                        {archive.tags && archive.tags.length > 0 && (
                          <div className="item-badges">
                            {archive.tags.map((tag, index) => (
                              <span key={index} className="mobile-badge info">
                                {tag}
                              </span>
                            ))}
                          </div>
                        )}
                        {archive.files && archive.files.length > 0 && (
                          <div className="item-files">
                            <FontAwesomeIcon icon={faPaperclip} className="file-icon" />
                            <span>{archive.files.length} fichier(s)</span>
                          </div>
                        )}
                      </div>
                      
                      <div className="mobile-card-actions">
                        <button
                          className="mobile-action-btn secondary"
                          onClick={() => handleEditArchive(archive)}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                        <button
                          className="mobile-action-btn danger"
                          onClick={() => handleDeleteArchive(archive.id)}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </div>
                    </div>
                  ))
              ) : (
                <div className="mobile-empty-state">
                  <FontAwesomeIcon icon={faArchive} className="empty-icon" />
                  <p>Aucune archive ajoutée</p>
                  <button
                    className="mobile-primary-btn"
                    onClick={() => {
                      resetArchiveForm();
                      setShowArchiveForm(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} className="btn-icon" />
                    Ajouter une archive
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Section Demandes rapides */}
        {activeTab === "demandesRapides" && (
          <div className="mobile-card">
            <AppointmentDetailsViewer structureId={auth.currentUser?.uid} />
          </div>
        )}

        {/* Section Demandes de contact */}
        {activeTab === "ContactRequestsViewer" && (
          <div className="mobile-card">
            <ContactRequestsViewer />
          </div>
        )}

        {/* Section Affiliations */}
        {activeTab === "affiliations" && (
          <div className="mobile-card">
            <AffiliationRequestsManager onRequestProcessed={fetchPendingRequests} />
          </div>
        )}
      </div>
    </div>

    {/* Modales existantes adaptées pour mobile */}
    {/* Modal pour les détails des médecins */}
    <Modal 
      show={currentView?.type === 'medecin'} 
      onHide={() => setCurrentView(null)}
      size="lg"
      className="mobile-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {currentView?.data?.titre || "Dr"} {currentView?.data?.nom}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="mobile-modal-body">
        {currentView?.data && (
          <div className="mobile-detail-content">
            <div className="detail-section">
              <h5>Informations générales</h5>
              <div className="detail-grid">
                <div className="detail-item">
                  <span className="detail-label">Nom:</span>
                  <span className="detail-value">{currentView.data.nom}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Spécialité:</span>
                  <span className="detail-value">{currentView.data.specialite}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Téléphone:</span>
                  <a href={`tel:${currentView.data.telephone}`} className="detail-link">
                    {currentView.data.telephone}
                  </a>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Email:</span>
                  <a href={`mailto:${currentView.data.email}`} className="detail-link">
                    {currentView.data.email}
                  </a>
                </div>
              </div>
            </div>

            {currentView.data.assurances && currentView.data.assurances.length > 0 && (
              <div className="detail-section">
                <h5>Assurances acceptées</h5>
                <div className="mobile-badges">
                  {currentView.data.assurances.map((assurance, index) => (
                    <span key={index} className="mobile-badge success">
                      {assurance}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="mobile-modal-footer">
        <Button 
          variant="outline-primary"
          onClick={() => {
            handleEditMedecin(currentView.data);
            setCurrentView(null);
          }}
        >
          <FontAwesomeIcon icon={faEdit} className="me-2" />
          Modifier
        </Button>
        <Button variant="secondary" onClick={() => setCurrentView(null)}>
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>

    {/* Modal pour les détails des patients */}
    <Modal 
      show={currentView?.type === 'patient'} 
      onHide={() => setCurrentView(null)}
      size="lg"
      className="mobile-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {currentView?.data?.nom}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="mobile-modal-body">
        {currentView?.data && (
          <div className="mobile-detail-content">
            <div className="detail-section">
              <h5>Informations générales</h5>
              <div className="detail-grid">
                <div className="detail-item">
                  <span className="detail-label">Nom:</span>
                  <span className="detail-value">{currentView.data.nom}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Âge:</span>
                  <span className="detail-value">{formatAge(currentView.data.dateNaissance)}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Téléphone:</span>
                  <a href={`tel:${currentView.data.telephone}`} className="detail-link">
                    {currentView.data.telephone}
                  </a>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Email:</span>
                  <a href={`mailto:${currentView.data.email}`} className="detail-link">
                    {currentView.data.email}
                  </a>
                </div>
              </div>
            </div>

            {currentView.data.diagnostics && (
              <div className="detail-section">
                <h5>Diagnostics</h5>
                <div className="detail-text">
                  {currentView.data.diagnostics}
                </div>
              </div>
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="mobile-modal-footer">
        <Button 
          variant="outline-primary"
          onClick={() => {
            handleEditPatient(currentView.data);
            setCurrentView(null);
          }}
        >
          <FontAwesomeIcon icon={faEdit} className="me-2" />
          Modifier
        </Button>
        <Button variant="secondary" onClick={() => setCurrentView(null)}>
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>

    {/* Modal pour les détails des auxiliaires */}
    <Modal 
      show={currentView?.type === 'auxiliaire'} 
      onHide={() => setCurrentView(null)}
      size="lg"
      className="mobile-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {currentView?.data?.nom}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="mobile-modal-body">
        {currentView?.data && (
          <div className="mobile-detail-content">
            <div className="detail-section">
              <h5>Informations générales</h5>
              <div className="detail-grid">
                <div className="detail-item">
                  <span className="detail-label">Nom:</span>
                  <span className="detail-value">{currentView.data.nom}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Rôle:</span>
                  <span className="detail-value">{currentView.data.role}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="mobile-modal-footer">
        <Button 
          variant="outline-primary"
          onClick={() => {
            handleEditAuxiliaire(currentView.data);
            setCurrentView(null);
          }}
        >
          <FontAwesomeIcon icon={faEdit} className="me-2" />
          Modifier
        </Button>
        <Button variant="secondary" onClick={() => setCurrentView(null)}>
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>

    {/* Modal pour les rendez-vous d'une date */}
    <Modal
      show={showDateModal}
      onHide={() => setShowDateModal(false)}
      size="lg"
      className="mobile-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Rendez-vous du {selectedDate && selectedDate.date.toLocaleDateString()}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="mobile-modal-body">
        <div className="mobile-rdv-list">
          {selectedDate &&
            getMedecinsByDate(selectedDate).map((item, index) => (
              <div
                key={index}
                className="mobile-rdv-item"
                onClick={() => handleMedecinClick(item.medecin.id)}
              >
                <div className="rdv-medecin-info">
                  <h6>Dr. {item.medecin.nom}</h6>
                  <p className="rdv-specialite">{item.medecin.specialite}</p>
                </div>
                <span className="mobile-badge primary">{item.rdvCount}</span>
              </div>
            ))}
        </div>
      </Modal.Body>
    </Modal>

    {/* Modal pour les rendez-vous d'un médecin */}
    <Modal
      show={showMedecinRdvModal}
      onHide={() => setShowMedecinRdvModal(false)}
      size="lg"
      className="mobile-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {selectedMedecinId && selectedDate && (
            <>
              Dr. {medecins.find((m) => m.id === selectedMedecinId)?.nom}
              <div className="modal-subtitle">
                {selectedDate.date.toLocaleDateString()}
              </div>
            </>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="mobile-modal-body">
        <div className="mobile-rdv-details">
          {selectedMedecinId &&
            selectedDate &&
            getMedecinRdvs(selectedMedecinId, selectedDate).map((rdv, index) => (
              <div key={rdv.id} className="mobile-rdv-detail-item">
                <div className="rdv-order">#{index + 1}</div>
                <div className="rdv-info">
                  <div className="rdv-time">
                    <FontAwesomeIcon icon={faClock} />
                    {rdv.heure}
                  </div>
                  <div className="rdv-patient">
                    <FontAwesomeIcon icon={faUser} />
                    {patients.find((p) => p.id === rdv.patientId)?.nom || rdv.patientNom}
                  </div>
                  <span className={`mobile-badge status-${rdv.statut}`}>
                    {rdv.statut}
                  </span>
                </div>
                <div className="rdv-actions">
                  <button
                    className="mobile-action-btn secondary"
                    onClick={() => {
                      handleEditRendezvous(rdv);
                      setShowMedecinRdvModal(false);
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                  <button
                    className="mobile-action-btn danger"
                    onClick={() => {
                      if (window.confirm("Supprimer ce rendez-vous ?")) {
                        handleDeleteRendezvous(rdv.id);
                      }
                    }}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                </div>
              </div>
            ))}
        </div>
      </Modal.Body>
    </Modal>

    {/* Modal pour l'auxiliaire */}
    <Modal 
      show={showAuxiliaireModal} 
      onHide={() => setShowAuxiliaireModal(false)}
      size="lg"
      className="mobile-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {currentAuxiliaire ? "Modifier l'auxiliaire" : "Ajouter un auxiliaire"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="mobile-modal-body">
        <Form onSubmit={handleAddAuxiliaire} className="mobile-form">
        <div className="mobile-form-group">
            <label className="mobile-form-label">Prénom et Nom</label>
            <input
              type="text"
              name="nom"
              className="mobile-input"
              value={auxiliaireForm.nom}
              onChange={handleAuxiliaireChange}
              required
            />
          </div>

          <div className="mobile-form-row">
            <div className="mobile-form-group">
              <label className="mobile-form-label">Email</label>
              <input
                type="email"
                name="email"
                className="mobile-input"
                value={auxiliaireForm.email}
                onChange={handleAuxiliaireChange}
                required
              />
            </div>
            
            <div className="mobile-form-group">
              <label className="mobile-form-label">Téléphone</label>
              <input
                type="tel"
                name="telephone"
                className="mobile-input"
                value={auxiliaireForm.telephone}
                onChange={handleAuxiliaireChange}
                required
              />
            </div>
          </div>

          <div className="mobile-form-group">
            <label className="mobile-form-label">Rôle</label>
            <select
              name="role"
              className="mobile-select"
              value={auxiliaireForm.role}
              onChange={handleAuxiliaireChange}
              required
            >
              <option value="assistant">Assistant(e) médical(e)</option>
              <option value="secretaire">Secrétaire médical(e)</option>
              <option value="infirmier">Infirmier(ère)</option>
              <option value="autre">Autre</option>
            </select>
          </div>

          <div className="mobile-form-group">
            <label className="mobile-form-label">Médecins assignés</label>
            <div className="mobile-checkboxes">
              {medecins.map((medecin) => (
                <label key={medecin.id} className="mobile-checkbox">
                  <input
                    type="checkbox"
                    checked={auxiliaireForm.medecinIds.includes(medecin.id)}
                    onChange={(e) => {
                      const { checked } = e.target;
                      setAuxiliaireForm(prev => ({
                        ...prev,
                        medecinIds: checked 
                          ? [...prev.medecinIds, medecin.id]
                          : prev.medecinIds.filter(id => id !== medecin.id)
                      }));
                    }}
                  />
                  <span className="checkbox-label">
                    Dr. {medecin.nom} - {medecin.specialite}
                  </span>
                </label>
              ))}
            </div>
          </div>

          <div className="mobile-form-group">
            <label className="mobile-form-label">Permissions</label>
            <div className="mobile-checkboxes">
              <label className="mobile-checkbox">
                <input
                  type="checkbox"
                  checked={auxiliaireForm.permissions.ajouterPatients}
                  onChange={(e) => {
                    setAuxiliaireForm(prev => ({
                      ...prev,
                      permissions: {
                        ...prev.permissions,
                        ajouterPatients: e.target.checked
                      }
                    }));
                  }}
                />
                <span className="checkbox-label">Ajouter des patients</span>
              </label>
              
              <label className="mobile-checkbox">
                <input
                  type="checkbox"
                  checked={auxiliaireForm.permissions.ajouterRendezVous}
                  onChange={(e) => {
                    setAuxiliaireForm(prev => ({
                      ...prev,
                      permissions: {
                        ...prev.permissions,
                        ajouterRendezVous: e.target.checked
                      }
                    }));
                  }}
                />
                <span className="checkbox-label">Ajouter des rendez-vous</span>
              </label>
              
              <label className="mobile-checkbox">
                <input
                  type="checkbox"
                  checked={auxiliaireForm.permissions.voirTousLesRendezVous}
                  onChange={(e) => {
                    setAuxiliaireForm(prev => ({
                      ...prev,
                      permissions: {
                        ...prev.permissions,
                        voirTousLesRendezVous: e.target.checked
                      }
                    }));
                  }}
                />
                <span className="checkbox-label">Voir tous les rendez-vous</span>
              </label>
            </div>
          </div>

          <div className="mobile-form-group">
            <label className="mobile-form-label">
              <FontAwesomeIcon icon={faClock} className="me-2" />
              Horaires de travail
            </label>
            <div className="mobile-horaires">
              {['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'].map((jour) => (
                <div key={jour} className="mobile-horaire-item">
                  <label className="mobile-checkbox">
                    <input
                      type="checkbox"
                      checked={auxiliaireForm.horaires[jour].actif}
                      onChange={() => handleHoraireChange(jour, "actif")}
                    />
                    <span className="checkbox-label">
                      {jour.charAt(0).toUpperCase() + jour.slice(1)}
                    </span>
                  </label>
                  
                  {auxiliaireForm.horaires[jour].actif && (
                    <div className="mobile-form-row">
                      <input
                        type="time"
                        className="mobile-input time-input"
                        value={auxiliaireForm.horaires[jour].debut}
                        onChange={(e) => handleHoraireChange(jour, "debut", e.target.value)}
                      />
                      <input
                        type="time"
                        className="mobile-input time-input"
                        value={auxiliaireForm.horaires[jour].fin}
                        onChange={(e) => handleHoraireChange(jour, "fin", e.target.value)}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="mobile-form-actions">
            <button
              type="button"
              className="mobile-secondary-btn"
              onClick={() => {
                resetAuxiliaireForm();
                setShowAuxiliaireModal(false);
              }}
            >
              Annuler
            </button>
            <button type="submit" className="mobile-primary-btn">
              <FontAwesomeIcon icon={faCheck} className="btn-icon" />
              {currentAuxiliaire ? "Mettre à jour" : "Ajouter"}
            </button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>

    <style jsx>{`
      /* Variables CSS - Palette harmonieuse et équilibrée */
      :root {
        --gradient-primary: linear-gradient(135deg,rgb(11, 65, 163) 0%,rgb(111, 95, 147) 100%);
        --gradient-secondary: linear-gradient(135deg, #06b6d4 0%, #3b82f6 100%);
        --gradient-success: linear-gradient(135deg, #10b981 0%, #059669 100%);
        --gradient-warning: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        --gradient-danger: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
        --gradient-accent: linear-gradient(135deg, #ec4899 0%, #be185d 100%);
        
        --color-primary: #6366f1;
        --color-secondary: #06b6d4;
        --color-success: #10b981;
        --color-warning: #f59e0b;
        --color-danger: #ef4444;
        --color-accent: #ec4899;
        
        --bg-primary: #f8fafc;
        --bg-secondary: #f1f5f9;
        --bg-tertiary: #e2e8f0;
        --bg-card: rgba(255, 255, 255, 0.9);
        --bg-glass: rgba(255, 255, 255, 0.7);
        --bg-overlay: rgba(15, 23, 42, 0.1);
        
        --text-primary: #1e293b;
        --text-secondary: #475569;
        --text-muted: #64748b;
        --text-light: #94a3b8;
        
        --border-light: rgba(226, 232, 240, 0.8);
        --border-medium: rgba(203, 213, 225, 0.9);
        --border-strong: rgba(148, 163, 184, 0.6);
        
        --shadow-sm: 0 2px 8px rgba(15, 23, 42, 0.08);
        --shadow-md: 0 4px 16px rgba(15, 23, 42, 0.12);
        --shadow-lg: 0 8px 32px rgba(15, 23, 42, 0.16);
        --shadow-xl: 0 16px 48px rgba(15, 23, 42, 0.2);
        
        --radius-sm: 8px;
        --radius-md: 12px;
        --radius-lg: 16px;
        --radius-xl: 24px;
        
        --spacing-xs: 6px;
        --spacing-sm: 12px;
        --spacing-md: 18px;
        --spacing-lg: 24px;
        --spacing-xl: 36px;
      }

      /* Reset et base */
      * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
      }

      /* Layout principal */
      .mobile-dashboard {
        min-height: 100vh;
        background: var(--bg-primary);
        background-image: 
          radial-gradient(circle at 25% 25%, rgba(99, 102, 241, 0.05) 0%, transparent 50%),
          radial-gradient(circle at 75% 75%, rgba(6, 182, 212, 0.05) 0%, transparent 50%),
          linear-gradient(135deg, rgba(16, 185, 129, 0.02) 0%, rgba(236, 72, 153, 0.02) 100%);
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        color: var(--text-primary);
        overflow-x: hidden;
      }

      /* Header avec design épuré */
      .mobile-header {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1000;
        background: var(--bg-card);
        backdrop-filter: blur(20px);
        border-bottom: 1px solid var(--border-light);
        box-shadow: var(--shadow-sm);
      }

      .mobile-header-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: var(--spacing-md);
        height: 64px;
      }

      .mobile-menu-btn,
      .mobile-profile-btn {
        width: 40px;
        height: 40px;
        border-radius: var(--radius-md);
        background: var(--bg-glass);
        border: 1px solid var(--border-light);
        color: var(--text-secondary);
        font-size: 16px;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .mobile-menu-btn:hover,
      .mobile-profile-btn:hover {
        background: white;
        border-color: var(--color-primary);
        color: var(--color-primary);
        transform: translateY(-1px);
        box-shadow: var(--shadow-md);
      }

      .mobile-title {
        font-size: 18px;
        font-weight: 700;
        background: var(--gradient-primary);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-align: center;
        flex: 1;
        margin: 0 var(--spacing-md);
      }

      /* Menu latéral moderne */
      .mobile-menu-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(15, 23, 42, 0.4);
        backdrop-filter: blur(4px);
        z-index: 1100;
        animation: fadeIn 0.3s ease;
      }

      .mobile-menu {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        width: 300px;
        background: white;
        border-right: 1px solid var(--border-light);
        box-shadow: var(--shadow-xl);
        animation: slideInLeft 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        overflow-y: auto;
      }

      .mobile-menu-header {
        padding: var(--spacing-lg);
        background: var(--gradient-primary);
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        overflow: hidden;
      }

      .mobile-menu-header::before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 100px;
        height: 100px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 50%;
        transform: translate(30px, -30px);
      }

      .mobile-menu-header h3 {
        font-size: 18px;
        font-weight: 600;
        color: white;
        margin: 0;
        position: relative;
        z-index: 1;
      }

      .mobile-menu-close {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.2);
        border: none;
        color: white;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s ease;
        position: relative;
        z-index: 1;
      }

      .mobile-menu-close:hover {
        background: rgba(255, 255, 255, 0.3);
        transform: rotate(90deg);
      }

      .mobile-menu-items {
        padding: var(--spacing-md);
      }

      .mobile-menu-item {
        width: 100%;
        background: none;
        border: none;
        padding: var(--spacing-md);
        margin-bottom: var(--spacing-xs);
        text-align: left;
        border-radius: var(--radius-md);
        transition: all 0.3s ease;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }

      .mobile-menu-item::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 3px;
        height: 100%;
        background: var(--gradient-primary);
        transform: scaleY(0);
        transition: transform 0.3s ease;
      }

      .mobile-menu-item:hover,
      .mobile-menu-item.active {
        background: var(--bg-secondary);
        color: var(--color-primary);
        transform: translateX(4px);
      }

      .mobile-menu-item:hover::before,
      .mobile-menu-item.active::before {
        transform: scaleY(1);
      }

      .menu-item-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .menu-icon {
        font-size: 18px;
        margin-right: var(--spacing-md);
        width: 20px;
        color: var(--color-secondary);
        transition: all 0.3s ease;
      }

      .mobile-menu-item:hover .menu-icon,
      .mobile-menu-item.active .menu-icon {
        color: var(--color-primary);
        transform: scale(1.1);
      }

      .menu-label {
        flex: 1;
        font-size: 15px;
        font-weight: 500;
        color: var(--text-primary);
      }

      .menu-badge {
        background: var(--gradient-accent);
        color: white;
        font-size: 10px;
        padding: 3px 6px;
        border-radius: 10px;
        min-width: 18px;
        text-align: center;
        font-weight: 600;
      }

      /* Contenu principal */
      .mobile-content {
        margin-top: 64px;
        padding: var(--spacing-lg) var(--spacing-md);
        min-height: calc(100vh - 64px);
      }

      .mobile-section-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: var(--spacing-xl);
        padding: var(--spacing-md) 0;
      }

      .section-title {
        font-size: 24px;
        font-weight: 800;
        color: var(--text-primary);
        margin: 0;
        position: relative;
      }

      .section-title::after {
        content: '';
        position: absolute;
        bottom: -4px;
        left: 0;
        width: 40px;
        height: 3px;
        background: var(--gradient-primary);
        border-radius: 2px;
      }

      .mobile-add-btn {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background: var(--gradient-primary);
        border: none;
        color: white;
        font-size: 20px;
        cursor: pointer;
        box-shadow: var(--shadow-md);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
        overflow: hidden;
      }

      .mobile-add-btn::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 0;
        height: 0;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 50%;
        transition: all 0.3s ease;
        transform: translate(-50%, -50%);
      }

      .mobile-add-btn:hover {
        transform: translateY(-2px) scale(1.05);
        box-shadow: var(--shadow-lg);
      }

      .mobile-add-btn:hover::before {
        width: 100%;
        height: 100%;
      }

      /* Barre de recherche élégante */
      .mobile-search-bar {
        margin-bottom: var(--spacing-xl);
      }

      .search-input-container {
        position: relative;
        background: white;
        border: 1px solid var(--border-light);
        border-radius: var(--radius-lg);
        overflow: hidden;
        transition: all 0.3s ease;
        box-shadow: var(--shadow-sm);
      }

      .search-input-container:focus-within {
        border-color: var(--color-primary);
        box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1), var(--shadow-md);
        transform: translateY(-1px);
      }

      .search-icon {
        position: absolute;
        left: var(--spacing-md);
        top: 50%;
        transform: translateY(-50%);
        color: var(--text-muted);
        font-size: 16px;
        z-index: 1;
      }

      .mobile-search-input {
        width: 100%;
        padding: var(--spacing-md) var(--spacing-md) var(--spacing-md) 48px;
        background: none;
        border: none;
        color: var(--text-primary);
        font-size: 15px;
        outline: none;
      }

      .mobile-search-input::placeholder {
        color: var(--text-muted);
      }

      .search-clear-btn {
        position: absolute;
        right: var(--spacing-md);
        top: 50%;
        transform: translateY(-50%);
        background: none;
        border: none;
        color: var(--text-muted);
        font-size: 14px;
        cursor: pointer;
        padding: var(--spacing-xs);
        border-radius: 50%;
        transition: all 0.3s ease;
      }

      .search-clear-btn:hover {
        background: var(--bg-secondary);
        color: var(--text-primary);
      }

      /* Alertes modernes */
      .mobile-alert {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: var(--spacing-md);
        margin-bottom: var(--spacing-lg);
        border-radius: var(--radius-md);
        border: 1px solid;
        animation: slideInDown 0.4s ease;
        position: relative;
        overflow: hidden;
      }

      .mobile-alert::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 4px;
        height: 100%;
      }

      .mobile-alert.success {
        background: rgba(16, 185, 129, 0.1);
        border-color: rgba(16, 185, 129, 0.3);
        color: #065f46;
      }

      .mobile-alert.success::before {
        background: var(--color-success);
      }

      .mobile-alert.error {
        background: rgba(239, 68, 68, 0.1);
        border-color: rgba(239, 68, 68, 0.3);
        color: #991b1b;
      }

      .mobile-alert.error::before {
        background: var(--color-danger);
      }

      .alert-close-btn {
        background: none;
        border: none;
        color: inherit;
        font-size: 14px;
        cursor: pointer;
        padding: var(--spacing-xs);
        border-radius: 50%;
        transition: all 0.3s ease;
      }

      .alert-close-btn:hover {
        background: rgba(0, 0, 0, 0.1);
      }

      /* Cartes élégantes */
      .mobile-card {
        background: white;
        border: 1px solid var(--border-light);
        border-radius: var(--radius-lg);
        margin-bottom: var(--spacing-xl);
        overflow: hidden;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: var(--shadow-sm);
        position: relative;
      }

      .mobile-card::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 2px;
        background: var(--gradient-secondary);
        transform: scaleX(0);
        transition: transform 0.3s ease;
      }

      .mobile-card:hover {
        transform: translateY(-2px);
        box-shadow: var(--shadow-lg);
        border-color: var(--border-medium);
      }

      .mobile-card:hover::before {
        transform: scaleX(1);
      }

      .mobile-card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: var(--spacing-lg);
        background: var(--bg-secondary);
        border-bottom: 1px solid var(--border-light);
      }

      .mobile-card-header h3 {
        font-size: 18px;
        font-weight: 700;
        color: var(--text-primary);
        margin: 0;
      }

      .mobile-close-btn {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: var(--bg-tertiary);
        border: none;
        color: var(--text-muted);
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s ease;
      }

      .mobile-close-btn:hover {
        background: var(--color-danger);
        color: white;
        transform: rotate(90deg);
      }

      /* Formulaires raffinés */
      .mobile-form {
        padding: var(--spacing-lg);
      }

      .mobile-form-group {
        margin-bottom: var(--spacing-lg);
      }

      .mobile-form-row {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: var(--spacing-md);
      }

      .mobile-form-label {
        display: block;
        font-size: 13px;
        font-weight: 600;
        color: var(--text-secondary);
        margin-bottom: var(--spacing-sm);
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      .mobile-input,
      .mobile-select,
      .mobile-textarea {
        width: 100%;
        padding: var(--spacing-md);
        background: white;
        border: 1px solid var(--border-light);
        border-radius: var(--radius-md);
        color: var(--text-primary);
        font-size: 15px;
        transition: all 0.3s ease;
      }

      .mobile-input:focus,
      .mobile-select:focus,
      .mobile-textarea:focus {
        outline: none;
        border-color: var(--color-primary);
        box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
        background: var(--bg-card);
      }

      .mobile-input::placeholder,
      .mobile-textarea::placeholder {
        color: var(--text-light);
      }

      .mobile-textarea {
        resize: vertical;
        min-height: 80px;
      }

      /* Checkboxes et radios stylés */
      .mobile-checkboxes {
        display: grid;
        gap: var(--spacing-sm);
      }

      .mobile-checkbox,
      .mobile-radio {
        display: flex;
        align-items: center;
        padding: var(--spacing-sm);
        border-radius: var(--radius-sm);
        cursor: pointer;
        transition: all 0.3s ease;
        border: 1px solid transparent;
      }

      .mobile-checkbox:hover,
      .mobile-radio:hover {
        background: var(--bg-secondary);
        border-color: var(--border-light);
      }

      .mobile-checkbox input,
      .mobile-radio input {
        margin-right: var(--spacing-sm);
        transform: scale(1.2);
        accent-color: var(--color-primary);
      }

      .checkbox-label,
      .radio-label {
        font-size: 14px;
        color: var(--text-primary);
        font-weight: 500;
      }

      /* Boutons modernes */
      .mobile-primary-btn {
        background: var(--gradient-primary);
        border: none;
        color: white;
        padding: var(--spacing-md) var(--spacing-lg);
        border-radius: var(--radius-md);
        font-size: 15px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: var(--spacing-sm);
        min-height: 44px;
        box-shadow: var(--shadow-sm);
        position: relative;
        overflow: hidden;
      }

      .mobile-primary-btn::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
        transition: left 0.5s ease;
      }

      .mobile-primary-btn:hover {
        transform: translateY(-1px);
        box-shadow: var(--shadow-md);
      }

      .mobile-primary-btn:hover::before {
        left: 100%;
      }

      .mobile-secondary-btn {
        background: white;
        border: 1px solid var(--border-medium);
        color: var(--text-primary);
        padding: var(--spacing-md) var(--spacing-lg);
        border-radius: var(--radius-md);
        font-size: 15px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: var(--spacing-sm);
        min-height: 44px;
        box-shadow: var(--shadow-sm);
      }

      .mobile-secondary-btn:hover {
        background: var(--bg-secondary);
        border-color: var(--color-primary);
        color: var(--color-primary);
        transform: translateY(-1px);
        box-shadow: var(--shadow-md);
      }

      .mobile-form-actions {
        display: flex;
        gap: var(--spacing-md);
        margin-top: var(--spacing-xl);
      }

      .mobile-form-actions .mobile-secondary-btn,
      .mobile-form-actions .mobile-primary-btn {
        flex: 1;
      }

      /* Badges colorés */
      .mobile-badges {
        display: flex;
        flex-wrap: wrap;
        gap: var(--spacing-sm);
        margin-bottom: var(--spacing-md);
      }

      .mobile-badge {
        display: inline-flex;
        align-items: center;
        gap: var(--spacing-xs);
        padding: 4px 10px;
        border-radius: 16px;
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        border: 1px solid;
      }

      .mobile-badge.primary {
        background: rgba(99, 102, 241, 0.1);
        border-color: rgba(99, 102, 241, 0.3);
        color: var(--color-primary);
      }

      .mobile-badge.success {
        background: rgba(16, 185, 129, 0.1);
        border-color: rgba(16, 185, 129, 0.3);
        color: var(--color-success);
      }

      .mobile-badge.info {
        background: rgba(6, 182, 212, 0.1);
        border-color: rgba(6, 182, 212, 0.3);
        color: var(--color-secondary);
      }

      .mobile-badge.secondary {
        background: rgba(100, 116, 139, 0.1);
        border-color: rgba(100, 116, 139, 0.3);
        color: var(--text-secondary);
      }

      .mobile-badge.warning {
        background: rgba(245, 158, 11, 0.1);
        border-color: rgba(245, 158, 11, 0.3);
        color: var(--color-warning);
      }

      .mobile-badge.danger {
        background: rgba(239, 68, 68, 0.1);
        border-color: rgba(239, 68, 68, 0.3);
        color: var(--color-danger);
      }

      /* Grille de cartes */
      .mobile-cards-grid {
        display: grid;
        gap: var(--spacing-md);
        animation: fadeInUp 0.6s ease;
      }

      .mobile-item-card {
        background: white;
        border: 1px solid var(--border-light);
        border-radius: var(--radius-lg);
        overflow: hidden;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: var(--shadow-sm);
        position: relative;
      }

      .mobile-item-card::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 2px;
        background: var(--gradient-accent);
        transform: scaleX(0);
        transition: transform 0.3s ease;
      }

      .mobile-item-card:hover {
        transform: translateY(-3px);
        box-shadow: var(--shadow-lg);
        border-color: var(--border-medium);
      }

      .mobile-item-card:hover::before {
        transform: scaleX(1);
      }

      .mobile-card-content {
        padding: var(--spacing-lg);
      }

      .item-header {
        margin-bottom: var(--spacing-md);
      }

      .item-title {
        font-size: 16px;
        font-weight: 700;
        color: var(--text-primary);
        margin: 0 0 var(--spacing-sm) 0;
      }

      .item-meta {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-xs);
      }

      .meta-text {
        font-size: 13px;
        color: var(--text-secondary);
        font-weight: 500;
      }

      .meta-date {
        font-size: 11px;
        color: var(--text-muted);
      }

      /* Actions des cartes */
      .mobile-card-actions {
        display: flex;
        justify-content: flex-end;
        gap: var(--spacing-sm);
        padding: var(--spacing-md) var(--spacing-lg);
        background: var(--bg-secondary);
        border-top: 1px solid var(--border-light);
      }

      .mobile-action-btn {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: none;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: var(--shadow-sm);
      }

      .mobile-action-btn.primary {
        background: var(--gradient-primary);
        color: white;
      }

      .mobile-action-btn.secondary {
        background: var(--gradient-secondary);
        color: white;
      }

      .mobile-action-btn.danger {
        background: var(--gradient-danger);
        color: white;
      }

      .mobile-action-btn:hover {
        transform: translateY(-2px) scale(1.05);
        box-shadow: var(--shadow-md);
      }

      /* État vide */
      .mobile-empty-state {
        text-align: center;
        padding: var(--spacing-xl);
        background: white;
        border: 1px solid var(--border-light);
        border-radius: var(--radius-lg);
        box-shadow: var(--shadow-sm);
        animation: fadeIn 0.6s ease;
      }

      .empty-icon {
        font-size: 48px;
        color: var(--text-light);
        margin-bottom: var(--spacing-lg);
        animation: float 3s ease-in-out infinite;
      }

      .mobile-empty-state p {
        font-size: 15px;
        color: var(--text-secondary);
        margin-bottom: var(--spacing-xl);
        font-weight: 500;
      }

      /* Créneaux horaires */
      .mobile-time-slots {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
        gap: var(--spacing-sm);
        margin-top: var(--spacing-md);
      }

      .mobile-time-slot {
        background: white;
        border: 1px solid var(--border-light);
        border-radius: var(--radius-md);
        padding: var(--spacing-md);
        text-align: center;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(        0.4, 0, 0.2, 1);
        min-height: 60px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-shadow: var(--shadow-sm);
      }

      .mobile-time-slot:hover {
        border-color: var(--color-primary);
        transform: translateY(-2px);
        box-shadow: var(--shadow-md);
        background: rgba(99, 102, 241, 0.05);
      }

      .mobile-time-slot.selected {
        background: var(--gradient-primary);
        color: white;
        border-color: var(--color-primary);
        box-shadow: var(--shadow-lg);
      }

      .mobile-time-slot.complet {
        background: rgba(239, 68, 68, 0.05);
        color: var(--text-muted);
        cursor: not-allowed;
        border-color: rgba(239, 68, 68, 0.2);
      }

      .mobile-time-slot.partiel {
        background: rgba(245, 158, 11, 0.05);
        border-color: rgba(245, 158, 11, 0.3);
        color: var(--color-warning);
      }

      .time {
        font-size: 13px;
        font-weight: 700;
        margin-bottom: 2px;
      }

      .slot-info {
        font-size: 9px;
        opacity: 0.8;
        font-weight: 500;
      }

      /* Calendrier élégant */
      .calendar-nav {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 1;
      }

      .mobile-nav-btn {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: var(--gradient-secondary);
        border: none;
        color: white;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: var(--shadow-sm);
      }

      .mobile-nav-btn:hover {
        transform: scale(1.05);
        box-shadow: var(--shadow-md);
      }

      .calendar-title {
        font-size: 16px;
        font-weight: 700;
        color: var(--text-primary);
        margin: 0;
        text-align: center;
      }

      .mobile-reminder-btn {
        background: var(--gradient-warning);
        border: none;
        color: white;
        padding: var(--spacing-sm) var(--spacing-md);
        border-radius: var(--radius-md);
        font-size: 11px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        box-shadow: var(--shadow-sm);
      }

      .mobile-reminder-btn:hover {
        transform: translateY(-1px);
        box-shadow: var(--shadow-md);
      }

      .mobile-calendar {
        padding: var(--spacing-lg);
      }

      .mobile-calendar-header {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 2px;
        margin-bottom: var(--spacing-md);
      }

      .mobile-calendar-day-header {
        text-align: center;
        font-size: 11px;
        font-weight: 700;
        color: var(--text-secondary);
        padding: var(--spacing-sm);
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      .mobile-calendar-body {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 2px;
      }

      .mobile-calendar-day {
        aspect-ratio: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: white;
        border: 1px solid var(--border-light);
        border-radius: var(--radius-sm);
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
        min-height: 40px;
      }

      .mobile-calendar-day:hover {
        border-color: var(--color-primary);
        background: rgba(99, 102, 241, 0.05);
        transform: scale(1.05);
      }

      .mobile-calendar-day.other-month {
        color: var(--text-light);
        background: var(--bg-secondary);
      }

      .mobile-calendar-day.has-events {
        background: rgba(6, 182, 212, 0.1);
        border-color: var(--color-secondary);
      }

      .day-number {
        font-size: 12px;
        font-weight: 600;
        color: var(--text-primary);
      }

      .event-dot {
        position: absolute;
        bottom: 3px;
        right: 3px;
        background: var(--gradient-accent);
        color: white;
        border-radius: 50%;
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 8px;
        font-weight: 700;
      }

      /* Modales modernes */
      .mobile-modal .modal-dialog {
        margin: 0;
        max-width: 100%;
        height: 100vh;
      }

      .mobile-modal .modal-content {
        height: 100vh;
        border-radius: 0;
        border: none;
        background: var(--bg-primary);
      }

      .mobile-modal-body {
        flex: 1;
        overflow-y: auto;
        padding: var(--spacing-lg);
      }

      .mobile-modal-footer {
        border-top: 1px solid var(--border-light);
        padding: var(--spacing-lg);
        background: white;
      }

      /* Listes de rendez-vous */
      .mobile-rdv-list {
        display: grid;
        gap: var(--spacing-md);
      }

      .mobile-rdv-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: var(--spacing-md);
        background: white;
        border: 1px solid var(--border-light);
        border-radius: var(--radius-md);
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: var(--shadow-sm);
      }

      .mobile-rdv-item:hover {
        border-color: var(--color-primary);
        transform: translateY(-2px);
        box-shadow: var(--shadow-md);
      }

      .rdv-medecin-info h6 {
        font-size: 15px;
        font-weight: 700;
        color: var(--text-primary);
        margin: 0 0 var(--spacing-xs) 0;
      }

      .rdv-specialite {
        font-size: 12px;
        color: var(--text-secondary);
        margin: 0;
        font-weight: 500;
      }

      .mobile-rdv-details {
        display: grid;
        gap: var(--spacing-md);
      }

      .mobile-rdv-detail-item {
        display: flex;
        align-items: center;
        gap: var(--spacing-md);
        padding: var(--spacing-md);
        background: white;
        border: 1px solid var(--border-light);
        border-radius: var(--radius-md);
        transition: all 0.3s ease;
        box-shadow: var(--shadow-sm);
      }

      .mobile-rdv-detail-item:hover {
        border-color: var(--color-secondary);
        transform: translateX(2px);
      }

      .rdv-order {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: var(--gradient-secondary);
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: 700;
        flex-shrink: 0;
      }

      .rdv-info {
        flex: 1;
        display: grid;
        gap: var(--spacing-xs);
      }

      .rdv-time,
      .rdv-patient {
        display: flex;
        align-items: center;
        gap: var(--spacing-sm);
        font-size: 12px;
        color: var(--text-primary);
        font-weight: 500;
      }

      .rdv-actions {
        display: flex;
        gap: var(--spacing-sm);
      }

      /* Badges de statut */
      .mobile-badge.status-confirmé,
      .mobile-badge.status-confirme {
        background: rgba(16, 185, 129, 0.1);
        border-color: rgba(16, 185, 129, 0.3);
        color: var(--color-success);
      }

      .mobile-badge.status-en-attente,
      .mobile-badge.status-en_attente {
        background: rgba(245, 158, 11, 0.1);
        border-color: rgba(245, 158, 11, 0.3);
        color: var(--color-warning);
      }

      .mobile-badge.status-annulé,
      .mobile-badge.status-annule {
        background: rgba(239, 68, 68, 0.1);
        border-color: rgba(239, 68, 68, 0.3);
        color: var(--color-danger);
      }

      .mobile-badge.status-terminé,
      .mobile-badge.status-termine {
        background: rgba(99, 102, 241, 0.1);
        border-color: rgba(99, 102, 241, 0.3);
        color: var(--color-primary);
      }

      /* Horaires auxiliaires */
      .mobile-horaires {
        border: 1px solid var(--border-light);
        border-radius: var(--radius-md);
        overflow: hidden;
        background: white;
        box-shadow: var(--shadow-sm);
      }

      .mobile-horaire-item {
        padding: var(--spacing-md);
        border-bottom: 1px solid var(--border-light);
        transition: all 0.3s ease;
      }

      .mobile-horaire-item:last-child {
        border-bottom: none;
      }

      .mobile-horaire-item:hover {
        background: var(--bg-secondary);
      }

      .time-input {
        max-width: 100px;
        background: var(--bg-secondary);
        border-color: var(--border-medium);
      }

      /* Fichiers */
      .mobile-file-input {
        padding: var(--spacing-lg);
        border: 2px dashed var(--border-medium);
        border-radius: var(--radius-md);
        background: var(--bg-secondary);
        cursor: pointer;
        transition: all 0.3s ease;
        text-align: center;
        color: var(--text-secondary);
      }

      .mobile-file-input:hover {
        border-color: var(--color-primary);
        background: rgba(99, 102, 241, 0.05);
        color: var(--color-primary);
      }

      .mobile-file-list {
        margin-top: var(--spacing-md);
        border: 1px solid var(--border-light);
        border-radius: var(--radius-md);
        overflow: hidden;
        background: white;
        box-shadow: var(--shadow-sm);
      }

      .mobile-file-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: var(--spacing-md);
        border-bottom: 1px solid var(--border-light);
        transition: all 0.3s ease;
      }

      .mobile-file-item:last-child {
        border-bottom: none;
      }

      .mobile-file-item:hover {
        background: var(--bg-secondary);
      }

      .file-name {
        font-size: 13px;
        color: var(--text-primary);
        flex: 1;
        margin-right: var(--spacing-md);
        font-weight: 500;
      }

      .file-size {
        font-size: 10px;
        color: var(--text-muted);
        background: var(--bg-tertiary);
        padding: 3px 6px;
        border-radius: 8px;
        font-weight: 600;
      }

      /* Animations */
      @keyframes fadeIn {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }

      @keyframes slideInLeft {
        from {
          transform: translateX(-100%);
        }
        to {
          transform: translateX(0);
        }
      }

      @keyframes slideInDown {
        from {
          transform: translateY(-20px);
          opacity: 0;
        }
        to {
          transform: translateY(0);
          opacity: 1;
        }
      }

      @keyframes fadeInUp {
        from {
          transform: translateY(20px);
          opacity: 0;
        }
        to {
          transform: translateY(0);
          opacity: 1;
        }
      }

      @keyframes float {
        0%, 100% {
          transform: translateY(0px);
        }
        50% {
          transform: translateY(-8px);
        }
      }

      /* Scrollbar personnalisée */
      ::-webkit-scrollbar {
        width: 6px;
      }

      ::-webkit-scrollbar-track {
        background: var(--bg-secondary);
      }

      ::-webkit-scrollbar-thumb {
        background: var(--color-primary);
        border-radius: 3px;
      }

      ::-webkit-scrollbar-thumb:hover {
        background: var(--color-secondary);
      }

      /* Responsive */
      @media (max-width: 360px) {
        .mobile-form-row {
          grid-template-columns: 1fr;
        }

        .mobile-time-slots {
          grid-template-columns: repeat(2, 1fr);
        }

        .mobile-menu {
          width: 100%;
        }

        .mobile-title {
          font-size: 16px;
        }

        .section-title {
          font-size: 20px;
        }
      }

      @media (min-width: 768px) {
        .mobile-cards-grid {
          grid-template-columns: repeat(2, 1fr);
        }

        .mobile-time-slots {
          grid-template-columns: repeat(4, 1fr);
        }
      }

      @media (min-width: 1000px) {
        .mobile-cards-grid {
          grid-template-columns: repeat(3, 1fr);
        }

        .mobile-form-row {
          grid-template-columns: repeat(3, 1fr);
        }
      }

      /* États de focus améliorés */
      .mobile-menu-item:focus,
      .mobile-action-btn:focus,
      .mobile-primary-btn:focus,
      .mobile-secondary-btn:focus,
      .mobile-input:focus,
      .mobile-select:focus,
      .mobile-textarea:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
      }

      /* Loading states */
      .loading {
        opacity: 0.6;
        pointer-events: none;
        position: relative;
      }

      .loading::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 16px;
        height: 16px;
        margin: -8px 0 0 -8px;
        border: 2px solid var(--color-primary);
        border-top: 2px solid transparent;
        border-radius: 50%;
        animation: spin 1s linear infinite;
      }

      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }

      /* Texte muet */
      .mobile-text-muted {
        color: var(--text-muted);
        font-style: italic;
        font-size: 13px;
      }

      /* Disponibilités */
      .mobile-disponibilites {
        border: 1px solid var(--border-light);
        border-radius: var(--radius-md);
        overflow: hidden;
        background: white;
        box-shadow: var(--shadow-sm);
      }

      .mobile-jour-container {
        border-bottom: 1px solid var(--border-light);
      }

      .mobile-jour-container:last-child {
        border-bottom: none;
      }

      .jour-header {
        padding: var(--spacing-md);
        background: var(--bg-secondary);
        border-bottom: 1px solid var(--border-light);
        font-weight: 600;
        color: var(--text-primary);
      }

      .creneaux-mobile {
        padding: var(--spacing-md);
      }

      .creneau-mobile {
        margin-bottom: var(--spacing-md);
        padding: var(--spacing-md);
        border: 1px solid var(--border-light);
        border-radius: var(--radius-md);
        background: white;
        box-shadow: var(--shadow-sm);
      }

      .mobile-delete-btn {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: var(--gradient-danger);
        color: white;
        border: none;
        font-size: 11px;
        cursor: pointer;
        transition: all 0.3s ease;
      }

      .mobile-delete-btn:hover {
        transform: scale(1.1);
        box-shadow: var(--shadow-md);
      }

      .mobile-delete-btn:disabled {
        background: var(--text-light);
        color: white;
        cursor: not-allowed;
        transform: none;
      }

      .mobile-add-creneau-btn {
        width: 100%;
        background: transparent;
        color: var(--color-primary);
        border: 1px dashed var(--color-primary);
        padding: var(--spacing-md);
        border-radius: var(--radius-md);
        font-size: 13px;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: var(--spacing-sm);
        font-weight: 500;
      }

      .mobile-add-creneau-btn:hover {
        background: rgba(99, 102, 241, 0.05);
        border-style: solid;
      }

      /* Contenu détaillé */
      .mobile-detail-content {
        padding: 0;
      }

      .detail-section {
        margin-bottom: var(--spacing-xl);
      }

      .detail-section h5 {
        font-size: 15px;
        font-weight: 700;
        color: var(--text-primary);
        margin-bottom: var(--spacing-md);
        padding-bottom: var(--spacing-sm);
        border-bottom: 1px solid var(--border-light);
      }

      .detail-grid {
        display: grid;
        gap: var(--spacing-md);
      }

      .detail-item {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-xs);
      }

      .detail-label {
        font-size: 11px;
        font-weight: 700;
        color: var(--text-secondary);
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      .detail-value {
        font-size: 13px;
        color: var(--text-primary);
        font-weight: 500;
      }

      .detail-link {
        font-size: 13px;
        color: var(--color-primary);
        text-decoration: none;
        font-weight: 500;
      }

      .detail-link:hover {
        text-decoration: underline;
      }

      .detail-text {
        font-size: 13px;
        color: var(--text-primary);
        line-height: 1.5;
        background: var(--bg-secondary);
        padding: var(--spacing-md);
        border-radius: var(--radius-md);
        border: 1px solid var(--border-light);
      }
    `}</style>
  </div>
);


}


  
//Contenu principal
   return (
    <div className="dashboard-container">
      {/* Menu latéral */}
      <div className={`sidebar ${sidebarCollapsed ? "collapsed" : ""}`}>
        <div className="sidebar-header">
          <h3>{!sidebarCollapsed && structureData.nom}</h3>
          <button className="toggle-btn" onClick={toggleSidebar}>
            <FontAwesomeIcon
              icon={sidebarCollapsed ? faChevronRight : faChevronLeft}
            />
          </button>
        </div>
  
        <div className="sidebar-menu">
          <ul>
            <li
              className={activeTab === "info" ? "active" : ""}
              onClick={() => setActiveTab("info")}
            >
              <FontAwesomeIcon icon={faUser} />
              {!sidebarCollapsed && <span>Informations</span>}
            </li>
  
            <li
              className={activeTab === "medecins" ? "active" : ""}
              onClick={() => setActiveTab("medecins")}
            >
              <FontAwesomeIcon icon={faUserMd} />
              {!sidebarCollapsed && <span>Médecins</span>}
              <span className="badge bg-info">{medecins.length}</span>
            </li>
            <li
              className={activeTab === "patients" ? "active" : ""}
              onClick={() => setActiveTab("patients")}
            >
              <FontAwesomeIcon icon={faUser} />
              {!sidebarCollapsed && <span>Patients</span>}
              <span className="badge bg-info">{patients.length}</span>
            </li>
            <li
      className={activeTab === "auxiliaires" ? "active" : ""}
      onClick={() => setActiveTab("auxiliaires")}
    >
      <FontAwesomeIcon icon={faUserNurse} />
      {!sidebarCollapsed && <span>Auxiliaires</span>}
      <span className="badge bg-info">{auxiliaires.length}</span>
    </li>
            <li
              className={activeTab === "rendezvous" ? "active" : ""}
              onClick={() => setActiveTab("rendezvous")}
            >
              <FontAwesomeIcon icon={faCalendarAlt} />
              {!sidebarCollapsed && <span>Rendez-vous</span>}
              <div className="badge-container">
                <span className="badge bg-info">{rendezvous.length}</span>
                {quickRequestsCount > 0 && (
                  <span className="badge bg-danger quick-badge">
                    {quickRequestsCount}
                  </span>
                )}
              </div>
            </li>
  
            <li
              className={activeTab === "archives" ? "active" : ""}
              onClick={() => setActiveTab("archives")}
            >
              <FontAwesomeIcon icon={faArchive} />
              {!sidebarCollapsed && <span>Archives</span>}
              <span className="badge bg-info">{archives.length}</span>
            </li>
  
            <li
              className={activeTab === "demandesRapides" ? "active" : ""}
              onClick={() => setActiveTab("demandesRapides")}
            >
              <FontAwesomeIcon icon={faBolt} />
              {!sidebarCollapsed && <span>Rendez-vous rapides</span>}
              <div className="badge-container">
                
              </div>
            </li>
            <li
  className={activeTab === "ContactRequestsViewer" ? "active" : ""}
  onClick={() => setActiveTab("ContactRequestsViewer")}
  >
  <FontAwesomeIcon icon={faInbox} />
  {!sidebarCollapsed && <span>Demandes</span>}
  {newDemandesCount > 0 && (
    <span className="badge bg-danger">{newDemandesCount}</span>
  )}
  </li>
  
  <li
  className={activeTab === "affiliations" ? "active" : ""}
  onClick={() => setActiveTab("affiliations")}
>
  <FontAwesomeIcon icon={faLink} />
  {!sidebarCollapsed && <span>Affiliations</span>}
  {(pendingDoctorRequests?.length || 0) +
    (affiliationRequests?.filter(
      (req) => req.statut === "en attente"
    )?.length || 0) >
    0 && (
    <span className="badge bg-danger">
      {(pendingDoctorRequests?.length || 0) +
        (affiliationRequests?.filter(
          (req) => req.statut === "en attente"
        )?.length || 0)}
    </span>
  )}
</li>

            <li onClick={handleLogout}>
              <FontAwesomeIcon icon={faSignOutAlt} />
              {!sidebarCollapsed && <span>Déconnexion</span>}
            </li>
          </ul>
        </div>
      </div>
  
      {/* Contenu principal */}
      <div className={`main-content ${sidebarCollapsed ? "expanded" : ""}`}>
        {/* En-tête avec le titre de la section active */}
        <div className="content-header">
          <div className="header-left">
            <h2>
              {activeTab === "medecins" && "Gestion des médecins"}
              {activeTab === "patients" && "Gestion des patients"}
              {activeTab === "auxiliaires"  }
              {activeTab === "rendezvous" && "Gestion des rendez-vous"}
              {activeTab === "archives" && "Archives des patients"}
              {activeTab === "password" && "Modification du mot de passe"}
              {activeTab === "demandesRapides" }
              {activeTab === "affiliations" && "Gestion des affiliations"}
              {activeTab === "info" && "Informations de la structure"}
              {activeTab === "ContactRequestsViewer"}
            </h2>
          </div>
          
          {/* Indicateur de statut temps réel */}
          <div className="realtime-status">
            <div className={`status-indicator ${realtimeStatus.connected ? 'connected' : 'disconnected'}`}>
              <FontAwesomeIcon 
                icon={realtimeStatus.connected ? faBolt : faSync} 
                className={`status-icon ${realtimeStatus.connected ? '' : 'spinning'}`}
              />
              <span className="status-text">
                {realtimeStatus.connected ? 'Temps réel' : 'Reconnexion...'}
              </span>
              {realtimeStatus.connected && realtimeStatus.lastUpdate && (
                <small className="last-update">
                  {new Date(realtimeStatus.lastUpdate).toLocaleTimeString('fr-FR', {
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                  })}
                </small>
              )}
            </div>
            {realtimeStatus.connected && (
              <div className="listeners-count">
                <FontAwesomeIcon icon={faEye} className="me-1" />
                <span>{realtimeStatus.activeListeners} écouteurs actifs</span>
              </div>
            )}
          </div>
  
          {/* Boutons d'action spécifiques à chaque onglet */}
          <div className="action-buttons">
            
            {activeTab === "medecins" && (
       <>
                   {/* Barre de recherche pour les médecins */}
    <div className="card-body d-flex ">
      <div className="input-group">
        <span className="input-group-text">
          <FontAwesomeIcon icon={faSearch} />
        </span>
        <input
          type="text"
          className="form-control"
          placeholder="Rechercher un médecin par nom ou spécialité..."
          value={medecinSearchQuery || ""}
          onChange={(e) => setMedecinSearchQuery(e.target.value)}
        />
        {medecinSearchQuery && (
          <button 
            className="btn btn-outline-secondary" 
            onClick={() => setMedecinSearchQuery("")}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        )}
      </div>
      <button
                className="btn btn-primary"
                onClick={() => {
                  resetMedecinForm();
                  setShowMedecinForm(!showMedecinForm);
                }}
              >
                <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                {showMedecinForm ? "Annuler" : "Ajouter un médecin"}
              </button>
    </div>
  
  
              
       
       
       </>
            )}
  
            {activeTab === "patients" && (
              <>
  
               {/* Barre de recherche pour les patients */}
      <div className="card-body d-flex">
        <div className="input-group">
          <span className="input-group-text">
            <FontAwesomeIcon icon={faSearch} />
          </span>
          <input
            type="text"
            className="form-control"
            placeholder="Rechercher un patient par nom ou prénom..."
            value={patientSearchQuery || ""}
            onChange={(e) => setPatientSearchQuery(e.target.value)}
          />
          {patientSearchQuery && (
            <button 
              className="btn btn-outline-secondary" 
              onClick={() => setPatientSearchQuery("")}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          )}
        </div>
        <button
                className="btn btn-primary"
                onClick={() => {
                  resetPatientForm();
                  setShowPatientForm(!showPatientForm);
                }}
              >
                <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                {showPatientForm ? "Annuler" : "Ajouter un patient"}
              </button>
      </div>
  
             
              </>
  
            )}
  
  
  
            {activeTab === "rendezvous" && (
              <button
                className="btn btn-primary"
                onClick={() => {
                  resetRdvForm();
                  setShowRendezvousForm(!showRendezvousForm);
                }}
              >
                <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                {showRendezvousForm ? "Annuler" : "Ajouter un rendez-vous"}
              </button>
            )}
  
            {activeTab === "archives" && (
              <button
                className="btn btn-primary"
                onClick={() => {
                  resetArchiveForm();
                  setShowArchiveForm(!showArchiveForm);
                }}
              >
                <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                {showArchiveForm ? "Annuler" : "Ajouter une archive"}
              </button>
            )}
          </div>
        </div>
  
        {/* Affichage des messages de notification */}
        {message && (
          <div
            className={`alert alert-dismissible fade show ${
              message.includes("Erreur") ? "alert-danger" : "alert-success"
            }`}
            role="alert"
          >
            {message}
            <button
              type="button"
              className="btn-close"
              onClick={() => setMessage("")}
            ></button>
          </div>
        )}
  
        {/* Contenu des différents onglets */}
        <div className="content-body">
          {/* Onglet Informations */}
          {activeTab === "info" && (
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="form-mobile">
                  {Object.keys(form).map((key) => {
                    if (key === "createdAt" || key === "updatedAt") {
                      return null;
                    }
  
                    // Traitement spécial pour les spécialités
                    if (key === "specialites") {
                      return (
                        <div className="form-group-mobile" key={key}>
                          <label className="form-label">Spécialités</label>
                          <div className="badge-container">
                            {form.specialites && form.specialites.length > 0 ? (
                              form.specialites.map((specialite) => (
                                <span
                                  key={specialite}
                                  className="badge bg-primary m-1"
                                >
                                  {specialite}
                                </span>
                              ))
                            ) : (
                              <span className="text-muted">
                                Aucune spécialité sélectionnée
                              </span>
                            )}
                          </div>
                          <div className="specialty-checkboxes mt-2">
                            {specialites.map((specialite) => (
                              <div key={specialite} className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`specialite-${specialite}`}
                                  value={specialite}
                                  checked={
                                    form.specialites?.includes(specialite) ||
                                    false
                                  }
                                  onChange={(e) => {
                                    const { checked, value } = e.target;
                                    let updatedSpecialites = [
                                      ...(form.specialites || []),
                                    ];
                                    if (checked) {
                                      updatedSpecialites.push(value);
                                    } else {
                                      updatedSpecialites =
                                        updatedSpecialites.filter(
                                          (s) => s !== value
                                        );
                                    }
                                    setForm({
                                      ...form,
                                      specialites: updatedSpecialites,
                                    });
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`specialite-${specialite}`}
                                >
                                  {specialite}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      );
                    }
  
                    // Traitement spécial pour les assurances
                    if (key === "assurances") {
                      return (
                        <div className="form-group-mobile" key={key}>
                          <label className="form-label">
                            Assurances acceptées
                          </label>
                          <div className="badge-container">
                            {form.assurances && form.assurances.length > 0 ? (
                              form.assurances.map((assurance) => (
                                <span
                                  key={assurance}
                                  className="badge bg-success m-1"
                                >
                                  {assurance}
                                </span>
                              ))
                            ) : (
                              <span className="text-muted">
                                Aucune assurance sélectionnée
                              </span>
                            )}
                          </div>
                          <div className="insurance-checkboxes mt-2">
                            {assurancesList.map((assurance) => (
                              <div key={assurance} className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`assurance-${assurance}`}
                                  value={assurance}
                                  checked={
                                    form.assurances?.includes(assurance) ||
                                    false
                                  }
                                  onChange={(e) => {
                                    const { checked, value } = e.target;
                                    let updatedAssurances = [
                                      ...(form.assurances || []),
                                    ];
                                    if (checked) {
                                      updatedAssurances.push(value);
                                    } else {
                                      updatedAssurances =
                                        updatedAssurances.filter(
                                          (a) => a !== value
                                        );
                                    }
                                    setForm({
                                      ...form,
                                      assurances: updatedAssurances,
                                    });
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`assurance-${assurance}`}
                                >
                                  {assurance}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      );
                    }
  
                    // Pour les autres champs, conserver le comportement actuel
                    return (
                      <div className="form-group-mobile" key={key}>
                        <label className="form-label">
                          {key.charAt(0).toUpperCase() + key.slice(1)}
                        </label>
                        <input
                          name={key}
                          value={form[key] || ""}
                          onChange={handleChange}
                          className="form-control"
                          placeholder={key}
                        />
                      </div>
                    );
                  })}
                </div>
                <div className="action-container-mobile">
                  <button
                    onClick={handleUpdate}
                    className="btn btn-primary btn-block"
                  >
                    <FontAwesomeIcon icon={faCheck} className="me-2" />
                    Mettre à jour
                  </button>
                </div>
              </div>
            </div>
          )}
  
          {/* Onglet Affiliations */}
          {activeTab === "affiliations" && (
            <div className="card shadow-sm">
              <div className="card-body">
                <AffiliationRequestsManager
                  onRequestProcessed={fetchPendingRequests}
                />
              </div>
            </div>
          )}
  
          {/* Onglet Médecins - Affichage en mode carte */}
          {activeTab === "medecins" && (
            <div>
              {showMedecinForm && (
                <div className="card shadow-sm mb-4 " id="medecin-form">
                  <div className="card-header">
                    <h5>
                      {currentMedecin
                        ? "Modifier le médecin"
                        : "Ajouter un médecin"}
                    </h5>
                  </div>
                  <div className="card-body">
                    <form onSubmit={handleAddMedecin}>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Prénom et Nom</label>
                          <input
                            type="text"
                            name="nom"
                            className="form-control"
                            value={medecinForm.nom}
                            onChange={handleMedecinChange}
                            required
                          />
                        </div>
                        {/* Dans le formulaire d'ajout/modification de médecin */}
  <div className="row">
  <div className="col-md-6 mb-3">
    <label className="form-label">Titre</label>
    <select
      name="titre"
      className="form-select"
      value={medecinForm.titre || "Dr"}
      onChange={handleMedecinChange}
      required
    >
      <option value="Dr">Dr</option>
      <option value="Pr">Pr</option>
    </select>
  </div>
  <div className="col-md-6 mb-3">
    <div className="form-check mt-4">
      <input
        type="checkbox"
        className="form-check-input"
        id="consultationDomicile"
        name="consultationDomicile"
        checked={medecinForm.consultationDomicile || false}
        onChange={(e) => {
          setMedecinForm({
            ...medecinForm,
            consultationDomicile: e.target.checked
          });
        }}
      />
      <label className="form-check-label" htmlFor="consultationDomicile">
        Accepte les consultations à domicile
      </label>
    </div>
  </div>
  </div>
  
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Spécialité</label>
                          <select
                            name="specialite"
                            className="form-select"
                            value={medecinForm.specialite}
                            onChange={handleMedecinChange}
                            required
                          >
                            <option value="">
                              Sélectionner une spécialité
                            </option>
                            {specialites.map((spec) => (
                              <option key={spec} value={spec}>
                                {spec}
                              </option>
                            ))}
                          </select>
                          {medecinForm.specialite === "Autre" && (
                            <input
                              type="text"
                              name="specialiteAutre"
                              className="form-control mt-2"
                              placeholder="Précisez la spécialité"
                              value={medecinForm.specialiteAutre || ""}
                              onChange={handleMedecinChange}
                            />
                          )}
                        </div>
                      </div>
  
                      <div className="row">
                       
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Téléphone</label>
                          <input
                            type="tel"
                            name="telephone"
                            className="form-control"
                            value={medecinForm.telephone}
                            onChange={handleMedecinChange}
                            required
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Email</label>
                          <input
                            type="email"
                            name="email"
                            className="form-control"
                            value={medecinForm.email}
                            onChange={handleMedecinChange}
                            required
                          />
                        </div>
                      </div>
  
                      
                      <div className="mb-3">
  <label className="form-label">Disponibilités</label>
  <div className="table-responsive">
    <table className="table table-bordered">
      <thead>
        <tr>
          <th>Jour</th>
          <th>Disponible</th>
          <th>Créneaux</th>
        </tr>
      </thead>
      <tbody>
        {joursSemaine.map((jour) => (
          <tr key={jour}>
            <td>
              {jour.charAt(0).toUpperCase() + jour.slice(1)}
            </td>
            <td>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`disponible-${jour}`}
                  checked={medecinForm.disponibilites[jour].actif}
                  onChange={() => handleDisponibiliteChange(jour, "actif")}
                />
                <label
                  className="form-check-label"
                  htmlFor={`disponible-${jour}`}
                >
                  {medecinForm.disponibilites[jour].actif ? "Oui" : "Non"}
                </label>
              </div>
            </td>
            <td>
              {medecinForm.disponibilites[jour].actif && (
                <div className="creneaux-container">
                  {medecinForm.disponibilites[jour].creneaux.map((creneau, index) => (
                    <div key={index} className="creneau-row mb-2">
                      <div className="row g-2 align-items-center">
                        <div className="col-md-3">
                          <input
                            type="time"
                            className="form-control form-control-sm"
                            value={creneau.debut}
                            onChange={(e) => handleDisponibiliteChange(jour, "debut", e.target.value, index)}
                          />
                        </div>
                        <div className="col-md-3">
                          <input
                            type="time"
                            className="form-control form-control-sm"
                            value={creneau.fin}
                            onChange={(e) => handleDisponibiliteChange(jour, "fin", e.target.value, index)}
                          />
                        </div>
                        <div className="col-md-4">
                          <select
                            className="form-select form-select-sm"
                            value={creneau.structureId || ""}
                            onChange={(e) => handleDisponibiliteChange(jour, "structureId", e.target.value, index)}
                          >
                            <option value="">Structure ou Prestataire actuelle</option>
                            {allStructures.map((structure) => (
                              <option key={structure.id} value={structure.id}>
                                {structure.nom}
                              </option>
                            ))}
                            <option value="autres">Autres</option>
                          </select>
                        </div>
                        <div className="col-md-2">
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => removeCreneau(jour, index)}
                            disabled={medecinForm.disponibilites[jour].creneaux.length <= 1}
                          >
                            <FontAwesomeIcon icon={faTimes} />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary mt-2"
                    onClick={() => addCreneau(jour)}
                  >
                    <FontAwesomeIcon icon={faPlus} className="me-1" />
                    Ajouter un créneau
                  </button>
                </div>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
  </div>
  
  
                      <div className="mb-3">
                        <label className="form-label">
                          Assurances acceptées
                        </label>
                        <div className="d-flex flex-wrap">
                          {assurancesList.map((assurance) => (
                            <div
                              className="form-check me-3 mb-2"
                              key={assurance}
                            >
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`assurance-medecin-${assurance}`}
                                name="assurances"
                                value={assurance}
                                checked={medecinForm.assurances.includes(
                                  assurance
                                )}
                                onChange={handleMedecinChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`assurance-medecin-${assurance}`}
                              >
                                {assurance}
                              </label>
                            </div>
                          ))}
                        </div>
                        {medecinForm.assurances.includes("Autre") && (
                          <input
                            type="text"
                            name="assuranceAutre"
                            className="form-control mt-2"
                            placeholder="Précisez l'assurance"
                            value={medecinForm.assuranceAutre || ""}
                            onChange={handleMedecinChange}
                          />
                        )}
                      </div>
  
                      <div className="text-end mt-3">
                        <button
                          type="button"
                          className="btn btn-secondary me-2"
                          onClick={() => {
                            resetMedecinForm();
                            setShowMedecinForm(false);
                          }}
                        >
                          <FontAwesomeIcon icon={faTimes} className="me-2" />
                          Annuler
                        </button>
                        <button type="submit" className="btn btn-primary">
                          <FontAwesomeIcon icon={faCheck} className="me-2" />
                          {currentMedecin ? "Mettre à jour" : "Ajouter"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
        
  
            {/* Liste des médecins en mode carte - VERSION SIMPLIFIÉE */}
<div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
  {medecins.length > 0 ? (
    filtreMedecins.map((medecin) => (
      <div className="col" key={medecin.id}>
        <div className="card h-100 shadow-sm hover-card">
          <div className="card-body">
            {/* En-tête simplifié avec nom et spécialité */}
            <div className="d-flex justify-content-between align-items-start mb-3">
              <div className="flex-grow-1">
                <h5 className="card-title mb-2">
                  {medecin.titre || "Dr"} {medecin.nom}
                </h5>
                <span className="badge bg-info mb-2">
                  {medecin.specialite}
                </span>
                {medecin.consultationDomicile && (
                  <div>
                    <span className="badge bg-success">
                      <FontAwesomeIcon icon={faHome} className="me-1" />
                      Consultations à domicile
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
          
          {/* Pied de carte avec boutons d'action */}
          <div className="card-footer bg-transparent border-top-0">
            <div className="d-flex justify-content-between align-items-center">
              {/* Bouton Détails */}
              <button
                className="btn btn-outline-info btn-sm"
                onClick={() => setCurrentView({ type: 'medecin', data: medecin })}
              >
                <FontAwesomeIcon icon={faEye} className="me-1" />
                Détails
              </button>
              
              {/* Boutons d'action */}
              <div>
                <button
                  className="btn btn-sm btn-outline-primary me-2"
                  onClick={() => handleEditMedecin(medecin)}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => handleDeleteMedecin(medecin.id)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    ))
  ) : (
    <div className="col-12 text-center py-5">
      <p className="text-muted">Aucun médecin n'a été ajouté</p>
      <button
        className="btn btn-primary"
        onClick={() => {
          resetMedecinForm();
          setShowMedecinForm(true);
        }}
      >
        <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
        Ajouter un médecin
      </button>
    </div>
  )}
</div>

            </div>
          )}
  
  {activeTab === "auxiliaires" && (
  <div>
    <div className="d-flex justify-content-between align-items-center mb-4">
      <h4>
        <FontAwesomeIcon icon={faUserNurse} className="me-2" />
        Gestion des auxiliaires médicaux
      </h4>
      <Button 
        variant="primary" 
        onClick={() => {
          setCurrentAuxiliaire(null);
          resetAuxiliaireForm();
          setShowAuxiliaireModal(true);
        }}
      >
        <FontAwesomeIcon icon={faPlus} className="me-2" />
        Ajouter un auxiliaire
      </Button>
    </div>
  
   {/* Liste des auxiliaires en mode carte - VERSION SIMPLIFIÉE */}
<div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
  {auxiliaires.length > 0 ? (
    auxiliaires.map((auxiliaire) => (
      <div className="col" key={auxiliaire.id}>
        <Card className="h-100 shadow-sm hover-card">
          <Card.Body>
            {/* En-tête simplifié avec nom et rôle */}
            <div className="d-flex justify-content-between align-items-start mb-3">
              <div className="flex-grow-1">
                <h5 className="card-title mb-2">
                  {auxiliaire.nom}
                </h5>
                <Badge bg="info">{auxiliaire.role}</Badge>
              </div>
            </div>
          </Card.Body>
          
          {/* Pied de carte avec boutons d'action */}
          <Card.Footer className="bg-transparent border-top-0">
            <div className="d-flex justify-content-between align-items-center">
              {/* Bouton Détails */}
              <Button 
                variant="outline-info" 
                size="sm"
                onClick={() => setCurrentView({ type: 'auxiliaire', data: auxiliaire })}
              >
                <FontAwesomeIcon icon={faEye} className="me-1" />
                Détails
              </Button>
              
              {/* Boutons d'action */}
              <div>
                <Button 
                  variant="outline-primary" 
                  size="sm" 
                  className="me-2"
                  onClick={() => handleEditAuxiliaire(auxiliaire)}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </Button>
                <Button 
                  variant="outline-danger" 
                  size="sm"
                  onClick={() => handleDeleteAuxiliaire(auxiliaire.id)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              </div>
            </div>
          </Card.Footer>
        </Card>
      </div>
    ))
  ) : (
    <div className="text-center py-5">
      <p className="text-muted">Aucun auxiliaire médical n'a été ajouté</p>
      <Button 
        variant="primary"
        onClick={() => {
          resetAuxiliaireForm();
          setShowAuxiliaireModal(true);
        }}
      >
        <FontAwesomeIcon icon={faPlus} className="me-2" />
        Ajouter un auxiliaire
      </Button>
    </div>
  )}
</div>

  </div>
  )}
  
  
          {/* Onglet Patients - Affichage en mode carte */}
          {activeTab === "patients" && (
            <div>
              {showPatientForm && (
                <div className="card shadow-sm mb-4">
                  <div className="card-header" id="patient-form">
                    <h5>
                      {currentPatient
                        ? "Modifier le patient"
                        : "Ajouter un patient"}
                    </h5>
                  </div>
                  <div className="card-body">
                    <form onSubmit={handleAddPatient}>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Prénom et Nom</label>
                          <input
                            type="text"
                            name="nom"
                            className="form-control"
                            value={patientForm.nom}
                            onChange={handlePatientChange}
                            required
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label">
                            Date de naissance
                          </label>
                          <input
                            type="date"
                            name="dateNaissance"
                            className="form-control"
                            value={patientForm.dateNaissance}
                            onChange={handlePatientChange}
                            required
                          />
                        </div>
                      </div>
  
                      <div className="row">
                       
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Téléphone</label>
                          <input
                            type="tel"
                            name="telephone"
                            className="form-control"
                            value={patientForm.telephone}
                            onChange={handlePatientChange}
                            required
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Email</label>
                          <input
                            type="email"
                            name="email"
                            className="form-control"
                            value={patientForm.email}
                            onChange={handlePatientChange}
                            required
                          />
                        </div>
                      </div>
  
                     
  
                      <div className="mb-3">
                        <label className="form-label">Assurances</label>
                        <div className="d-flex flex-wrap">
                          {assurancesList.map((assurance) => (
                            <div
                              className="form-check me-3 mb-2"
                              key={assurance}
                            >
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`assurance-patient-${assurance}`}
                                name="assurances"
                                value={assurance}
                                checked={patientForm.assurances.includes(
                                  assurance
                                )}
                                onChange={handlePatientChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`assurance-patient-${assurance}`}
                              >
                                {assurance}
                              </label>
                            </div>
                          ))}
                        </div>
                        {patientForm.assurances.includes("Autre") && (
                          <input
                            type="text"
                            name="assuranceAutre"
                            className="form-control mt-2"
                            placeholder="Précisez l'assurance"
                            value={patientForm.assuranceAutre || ""}
                            onChange={handlePatientChange}
                          />
                        )}
                      </div>
  
                      <div className="mb-3">
                        <label className="form-label">Diagnostics</label>
                        <textarea
                          name="diagnostics"
                          className="form-control"
                          value={patientForm.diagnostics}
                          onChange={handlePatientChange}
                          rows="3"
                          placeholder="Entrez les diagnostics du patient"
                        />
                      </div>
  
                      <div className="text-end mt-3">
                        <button
                          type="button"
                          className="btn btn-secondary me-2"
                          onClick={() => {
                            resetPatientForm();
                            setShowPatientForm(false);
                          }}
                        >
                          <FontAwesomeIcon icon={faTimes} className="me-2" />
                          Annuler
                        </button>
                        <button type="submit" className="btn btn-primary">
                          <FontAwesomeIcon icon={faCheck} className="me-2" />
                          {currentPatient ? "Mettre à jour" : "Ajouter"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
  
            {/* Liste des patients en mode carte - VERSION SIMPLIFIÉE */}
<div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
  {patients.length > 0 ? (
    filtrePatients.map((patient) => (
      <div className="col" key={patient.id}>
        <div className="card h-100 shadow-sm hover-card">
          <div className="card-body">
            {/* En-tête simplifié avec nom et âge */}
            <div className="d-flex justify-content-between align-items-start mb-3">
              <div className="flex-grow-1">
                <h5 className="card-title mb-2">
                  {patient.nom}
                </h5>
                <span className="badge bg-secondary">
  {formatAge(patient.dateNaissance)}
</span>

              </div>
            </div>
          </div>
          
          {/* Pied de carte avec boutons d'action */}
          <div className="card-footer bg-transparent border-top-0">
            <div className="d-flex justify-content-between align-items-center">
              {/* Bouton Détails */}
              <button
                className="btn btn-outline-info btn-sm"
                onClick={() => setCurrentView({ type: 'patient', data: patient })}
              >
                <FontAwesomeIcon icon={faEye} className="me-1" />
                Détails
              </button>
              
              {/* Boutons d'action */}
              <div>
                <button
                  className="btn btn-sm btn-outline-primary me-2"
                  onClick={() => handleEditPatient(patient)}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => handleDeletePatient(patient.id)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    ))
  ) : (
    <div className="col-12 text-center py-5">
      <p className="text-muted">Aucun patient n'a été ajouté</p>
      <button
        className="btn btn-primary"
        onClick={() => {
          resetPatientForm();
          setShowPatientForm(true);
        }}
      >
        <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
        Ajouter un patient
      </button>
    </div>
  )}
</div>

            </div>
          )}
  
          {/* Onglet Rendez-vous - Vue mensuelle */}
          {activeTab === "rendezvous" && (
            <div>
              {showRendezvousForm && (
                <div className="card shadow-sm mb-4">
                  <div className="card-header">
                    <h5>
                      {currentRendezvous
                        ? "Modifier le rendez-vous"
                        : "Ajouter un rendez-vous"}
                    </h5>
                  </div>
                  <div className="card-body">
                    <form onSubmit={handleAddRendezvous}>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Médecin</label>
                          <select
                            name="medecinId"
                            className="form-select"
                            value={rdvForm.medecinId}
                            onChange={handleRdvChange}
                            required
                          >
                            <option value="">Sélectionner un médecin</option>
                            {medecins.map((medecin) => (
                              <option key={medecin.id} value={medecin.id}>
                                Dr.  {medecin.nom} -{" "}
                                {medecin.specialite}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Patient</label>
                          <select
                            name="patientId"
                            className="form-select"
                            value={rdvForm.patientId}
                            onChange={handleRdvChange}
                            required
                          >
                            <option value="">Sélectionner un patient</option>
                            {patients.map((patient) => (
                              <option key={patient.id} value={patient.id}>
                                 {patient.nom}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
  
                      <div className="row">
                        <div className="col-md-4 mb-3">
                          <label className="form-label">Date</label>
                          <input
                            type="date"
                            name="date"
                            className="form-control"
                            value={rdvForm.date}
                            onChange={handleRdvChange}
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Heure</label>
                          <div className="time-slots-container">
                            {rdvForm.medecinId && rdvForm.date ? (
                              getCreneauxAvecStatut().map((creneau) => (
                                <div
                                  key={creneau.heure}
                                  className={`time-slot ${creneau.statut} ${
                                    rdvForm.heure === creneau.heure
                                      ? "selected"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    if (creneau.statut !== "complet") {
                                      setRdvForm({
                                        ...rdvForm,
                                        heure: creneau.heure,
                                      });
                                    }
                                  }}
                                >
                                  {creneau.heure}
                                  {creneau.statut === "partiel" && (
                                    <div className="slot-info">
                                      {creneau.nombreRdv}/{3} occupé
                                      {creneau.nombreRdv > 1 ? "s" : ""}
                                    </div>
                                  )}
                                  {creneau.statut === "complet" && (
                                    <div className="slot-info">Complet</div>
                                  )}
                                </div>
                              ))
                            ) : (
                              <div className="alert alert-info">
                                Veuillez sélectionner un médecin et une date
                              </div>
                            )}
                          </div>
                        </div>
  
                        {/*  <div className="col-md-4 mb-3">
                        <label className="form-label">Durée (minutes)</label>
                        <select
                          name="duree"
                          className="form-select"
                          value={rdvForm.duree}
                          onChange={handleRdvChange}
                          required
                        >
                          {dureesRdv.map((duree) => (
                            <option key={duree} value={duree}>
                              {duree} min
                            </option>
                          ))}
                        </select>
                      </div> */}
                      </div>
  
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Motif</label>
                          <textarea
                            name="motif"
                            className="form-control"
                            value={rdvForm.motif}
                            onChange={handleRdvChange}
                            rows="3"
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Statut</label>
                          <select
                            name="statut"
                            className="form-select"
                            value={rdvForm.statut}
                            onChange={handleRdvChange}
                            required
                          >
                            {statutsRdv.map((statut) => (
                              <option key={statut} value={statut}>
                                {statut.charAt(0).toUpperCase() +
                                  statut.slice(1)}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
  
                      <div className="form-group-mobile">
                        <label className="form-label">Type de consultation</label>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="typeConsultation"
                            id="presentiel"
                            value="presentiel"
                            checked={rdvForm.typeConsultation === "presentiel"}
                            onChange={handleRdvChange}
                          />
                          <label className="form-check-label" htmlFor="presentiel">
                            Consultation en présentiel
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input" 
                            type="radio"
                            name="typeConsultation"
                            id="teleconsultation"
                            value="teleconsultation"
                            checked={rdvForm.typeConsultation === "teleconsultation"}
                            onChange={handleRdvChange}
                          />
                          <label className="form-check-label" htmlFor="teleconsultation">
                            Téléconsultation
                          </label>
                        </div>
                      </div>
  
                      <div className="text-end mt-3">
                        <button
                          type="button"
                          className="btn btn-secondary me-2"
                          onClick={() => {
                            resetRdvForm();
                            setShowRendezvousForm(false);
                          }}
                        >
                          <FontAwesomeIcon icon={faTimes} className="me-2" />
                          Annuler
                        </button>
                        <button type="submit" className="btn btn-primary">
                          <FontAwesomeIcon icon={faCheck} className="me-2" />
                          {currentRendezvous ? "Mettre à jour" : "Ajouter"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
  
              {/* Vue calendrier des rendez-vous */}
              <div className="card shadow-sm mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <button
                      className="btn btn-sm btn-outline-secondary me-2"
                      onClick={handlePrevMonth}
                    >
                      <FontAwesomeIcon icon={faChevronLeft} />
                    </button>
                    <h5 className="mb-0 mx-3">
                      {currentMonth.toLocaleString("fr-FR", {
                        month: "long",
                        year: "numeric",
                      })}
                    </h5>
                    <button
                      className="btn btn-sm btn-outline-secondary ms-2"
                      onClick={handleNextMonth}
                    >
                      <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                  </div>
                  <div className="d-flex align-items-center">
                    <h5 className="mb-0 me-3">
                      <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
                      Calendrier des rendez-vous
                    </h5>
                    <Button
                      variant="outline-warning"
                      onClick={sendAppointmentReminders}
                      disabled={loading}
                    >
                      <FontAwesomeIcon
                        icon={loading ? faSpinner : faBell}
                        className={loading ? "fa-spin me-2" : "me-2"}
                      />
                      Envoyer les rappels de demain
                    </Button>
                  </div>
                </div>
                <div className="card-body p-0">
                  <div className="calendar-container">
                    <div className="calendar-header">
                      {["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"].map(
                        (day, index) => (
                          <div key={index} className="calendar-cell header">
                            {day}
                          </div>
                        )
                      )}
                    </div>
                    <div className="calendar-body">
                      {getMonthData().map((day, index) => (
                        <div
                          key={index}
                          className={`calendar-cell ${
                            !day.isCurrentMonth ? "other-month" : ""
                          } ${day.hasEvents ? "has-events" : ""}`}
                          onClick={() => handleDateClick(day)}
                        >
                          <div className="date-number">
                            {day.date.getDate()}
                          </div>
                          {day.hasEvents && (
                            <div className="event-indicator">
                              <span className="badge rounded-pill bg-primary">
                                {day.medecinCount}{" "}
                                {day.medecinCount > 1 ? "médecins" : "médecin"}
                              </span>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
  
  
          
          {activeTab === "demandesRapides" && (
            <div>
      <AppointmentDetailsViewer structureId={auth.currentUser?.uid} />
      </div>
          )}
  
          {activeTab === "ContactRequestsViewer" && (
            <div>
              <ContactRequestsViewer />
            </div>
          )}
  
          {/* Onglet Archives */}
          {activeTab === "archives" && (
            <div>
              {showArchiveForm && (
                <div className="card shadow-sm mb-4">
                  <div className="card-header">
                    <h5>
                      {currentArchive
                        ? "Modifier l'archive"
                        : "Ajouter une archive"}
                    </h5>
                  </div>
                  <div className="card-body">
                    <form onSubmit={handleAddArchive}>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label htmlFor="patientId" className="form-label">
                            Patient
                          </label>
                          <select
                            id="patientId"
                            name="patientId"
                            className="form-select"
                            value={archiveForm.patientId}
                            onChange={handleArchiveChange}
                            required
                          >
                            <option value="">Sélectionner un patient</option>
                            {patients.map((patient) => (
                              <option key={patient.id} value={patient.id}>
                                 {patient.nom}
                              </option>
                            ))}
                          </select>
                        </div>
  
                        <div className="col-md-6 mb-3">
                          <label htmlFor="titre" className="form-label">
                            Titre
                          </label>
                          <input
                            type="text"
                            id="titre"
                            name="titre"
                            className="form-control"
                            value={archiveForm.titre}
                            onChange={handleArchiveChange}
                            required
                          />
                        </div>
                      </div>
  
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label htmlFor="description" className="form-label">
                            Description
                          </label>
                          <textarea
                            id="description"
                            name="description"
                            className="form-control"
                            value={archiveForm.description}
                            onChange={handleArchiveChange}
                            rows="3"
                          />
                        </div>
  
                        <div className="col-md-6 mb-3">
                          <label htmlFor="notes" className="form-label">
                            Notes
                          </label>
                          <textarea
                            id="notes"
                            name="notes"
                            className="form-control"
                            value={archiveForm.notes}
                            onChange={handleArchiveChange}
                            rows="3"
                          />
                        </div>
                      </div>
  
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label htmlFor="date" className="form-label">
                            Date
                          </label>
                          <input
                            type="date"
                            id="date"
                            name="date"
                            className="form-control"
                            value={archiveForm.date}
                            onChange={handleArchiveChange}
                            required
                          />
                        </div>
  
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Tags</label>
                          <div className="d-flex flex-wrap">
                            {tagsList.map((tag) => (
                              <div className="form-check me-3 mb-2" key={tag}>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`tag-${tag}`}
                                  name="tags"
                                  value={tag}
                                  checked={archiveForm.tags.includes(tag)}
                                  onChange={handleArchiveChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`tag-${tag}`}
                                >
                                  {tag}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
  
                      <div className="mb-3">
                        <label htmlFor="files" className="form-label">
                          Fichiers
                        </label>
                        <input
                          type="file"
                          id="files"
                          className="form-control"
                          onChange={handleFileChange}
                          multiple
                        />
                        <div className="form-text">
                          Vous pouvez sélectionner plusieurs fichiers.
                        </div>
                      </div>
  
                      {selectedFiles.length > 0 && (
                        <div className="mb-3">
                          <h6>Fichiers sélectionnés :</h6>
                          <ul className="list-group">
                            {selectedFiles.map((file, index) => (
                              <li
                                key={index}
                                className="list-group-item d-flex justify-content-between align-items-center"
                              >
                                {file.name}
                                <span className="badge bg-primary rounded-pill">
                                  {(file.size / 1024).toFixed(2)} KB
                                </span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
  
                      {currentArchive &&
                        archiveForm.files &&
                        archiveForm.files.length > 0 && (
                          <div className="mb-3">
                            <label className="form-label">
                              Fichiers existants
                            </label>
                            <div className="row g-2">
                              {archiveForm.files.map((file, index) => (
                                <div key={index} className="col-md-4 col-6">
                                  <div className="card h-100">
                                    <div
                                      className="card-img-top file-preview-thumbnail"
                                      onClick={() => {
                                        setSelectedFile(file);
                                        setShowFilePreview(true);
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        height: "120px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background: "#f8f9fa",
                                        overflow: "hidden",
                                      }}
                                    >
                                      {getFileType(file) === "image" ? (
                                        <img
                                          src={file.url}
                                          alt={file.name}
                                          className="img-fluid"
                                          style={{
                                            maxHeight: "100%",
                                            maxWidth: "100%",
                                          }}
                                        />
                                      ) : (
                                        <div className="text-center">
                                          <FontAwesomeIcon
                                            icon={
                                              getFileType(file) === "pdf"
                                                ? faFilePdf
                                                : getFileType(file) === "word"
                                                ? faFileWord
                                                : getFileType(file) === "excel"
                                                ? faFileExcel
                                                : getFileType(file) === "video"
                                                ? faVideo
                                                : getFileType(file) === "audio"
                                                ? faMusic
                                                : faFile
                                            }
                                            size="3x"
                                            className="text-secondary mb-2"
                                          />
                                        </div>
                                      )}
                                    </div>
                                    <div className="card-body p-2">
                                      <p className="card-text small text-truncate mb-1">
                                        {file.name}
                                      </p>
                                      <div className="d-flex justify-content-between">
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-primary"
                                          onClick={() => {
                                            setSelectedFile(file);
                                            setShowFilePreview(true);
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faEye} />
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-danger"
                                          onClick={() =>
                                            handleDeleteFile(
                                              currentArchive.id,
                                              file,
                                              index
                                            )
                                          }
                                        >
                                          <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
  
                      <div className="text-end mt-3">
                        <button
                          type="button"
                          className="btn btn-secondary me-2"
                          onClick={() => {
                            resetArchiveForm();
                            setShowArchiveForm(false);
                          }}
                        >
                          <FontAwesomeIcon icon={faTimes} className="me-2" />
                          Annuler
                        </button>
                        <button type="submit" className="btn btn-primary">
                          <FontAwesomeIcon icon={faCheck} className="me-2" />
                          {currentArchive ? "Mettre à jour" : "Ajouter"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
  
              <div className="card shadow-sm">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h5>Archives des patients</h5>
                  <div className="d-flex">
                    <input
                      type="text"
                      className="form-control form-control-sm me-2"
                      placeholder="Rechercher un patient"
                      value={filtreArchivePatient}
                      onChange={(e) => setFiltreArchivePatient(e.target.value)}
                    />
                    <button className="btn btn-sm btn-outline-secondary">
                      <FontAwesomeIcon icon={faSearch} />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  {archives.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Patient</th>
                            <th>Titre</th>
                            <th>Date</th>
                            <th>Tags</th>
                            <th>Fichiers</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {archives
                            .filter((archive) => {
                              if (!filtreArchivePatient) return true;
                              const patientNom = archive.patientNom || "";
                              return patientNom
                                .toLowerCase()
                                .includes(filtreArchivePatient.toLowerCase());
                            })
                            .map((archive) => (
                              <tr key={archive.id}>
                                <td>{archive.patientNom}</td>
                                <td>{archive.titre}</td>
                                <td>
                                  {new Date(archive.date).toLocaleDateString()}
                                </td>
                                <td>
                                  {archive.tags &&
                                    archive.tags.map((tag, index) => (
                                      <span
                                        key={index}
                                        className="badge bg-info me-1"
                                      >
                                        {tag}
                                      </span>
                                    ))}
                                </td>
                                <td>
                                  {archive.files && (
                                    <span className="badge bg-secondary">
                                      {archive.files.length}
                                    </span>
                                  )}
                                </td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-outline-primary me-1"
                                    onClick={() => handleEditArchive(archive)}
                                  >
                                    <FontAwesomeIcon icon={faEdit} />
                                  </button>
                                  <button
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() =>
                                      handleDeleteArchive(archive.id)
                                    }
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <p className="text-muted">
                        Aucune archive n'a été ajoutée
                      </p>
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          resetArchiveForm();
                          setShowArchiveForm(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                        Ajouter une archive
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
  
          {/* Onglet Mot de passe */}
          {activeTab === "password" && (
            <div className="card shadow-sm">
              <div className="card-body">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handlePasswordChange();
                  }}
                >
                  <div className="mb-3">
                    <label className="form-label">Nouveau mot de passe</label>
                    <input
                      type="password"
                      className="form-control"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="text-end">
                    <button type="submit" className="btn btn-primary">
                      <FontAwesomeIcon icon={faCheck} className="me-2" />
                      Mettre à jour le mot de passe
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
  
      {/* Modales pour la gestion des rendez-vous */}
      {/* Modal pour afficher les médecins d'une date */}
      <Modal
        show={showDateModal}
        onHide={() => setShowDateModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Rendez-vous du{" "}
            {selectedDate && selectedDate.date.toLocaleDateString()}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="list-group">
            {selectedDate &&
              getMedecinsByDate(selectedDate).map((item, index) => (
                <button
                  key={index}
                  className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                  onClick={() => handleMedecinClick(item.medecin.id)}
                >
                  <div>
                    <h6>
                      Dr.  {item.medecin.nom}
                    </h6>
                    <p className="mb-0 small text-muted">
                      {item.medecin.specialite}
                    </p>
                  </div>
                  <span className="badge bg-primary rounded-pill">
                    {item.rdvCount}
                  </span>
                </button>
              ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            size="sm"
            onClick={() => setShowDateModal(false)}
          >
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>
  
     {/* Modal pour afficher les rendez-vous d'un médecin à une date donnée */}
  <Modal
  show={showMedecinRdvModal}
  onHide={() => setShowMedecinRdvModal(false)}
  size="lg"
  >
  <Modal.Header closeButton>
    <Modal.Title>
      {selectedMedecinId && selectedDate && (
        <>
          Rendez-vous de Dr.{" "}
          {medecins.find((m) => m.id === selectedMedecinId)?.nom}
          <p className="mb-0 fs-6 text-muted">
            {selectedDate.date.toLocaleDateString()}
          </p>
        </>
      )}
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div className="rdv-list">
      {selectedMedecinId &&
        selectedDate &&
        getMedecinRdvs(selectedMedecinId, selectedDate).map(
          (rdv, index) => (
            <div
              key={rdv.id}
              className={`rdv-item ${
                draggedRdv?.id === rdv.id ? "dragging" : ""
              } status-${rdv.statut}`}
              draggable
              onDragStart={() => handleDragStart(rdv)}
              onDragOver={(e) => e.preventDefault()}
              onDrop={() => handleDrop(rdv)}
              onClick={() => handleRdvClick(rdv)}
            >
              <div className="rdv-order">
                #{index + 1}
              </div>
              <div className="rdv-time">
                <FontAwesomeIcon icon={faClock} className="me-2" />
                {rdv.heure}
                {/* ({rdv.duree} min) */}
              </div>
              <div className="rdv-patient">
                <FontAwesomeIcon icon={faUser} className="me-2" />
                {patients.find((p) => p.id === rdv.patientId)?.nom ||
                  rdv.patientNom}
              </div>
              <div className="rdv-status">
                <span className={`badge status-badge-${rdv.statut}`}>
                  {rdv.statut.charAt(0).toUpperCase() +
                    rdv.statut.slice(1)}
                </span>
                {/* Affichage de la structure */}
                {(rdv.lieuStructureId || rdv.structureId) && (
                  <div className="structure-info mt-1">
                    <FontAwesomeIcon icon={faClinicMedical} className="icon" />
                    <span className="structure-name">
                      {rdv.lieuStructureNom || 
                       (rdv.lieuStructureId && allStructures.find(s => s.id === rdv.lieuStructureId)?.nom) || 
                       (rdv.structureId && allStructures.find(s => s.id === rdv.structureId)?.nom) || 
                       "Structure principale"}
                    </span>
                  </div>
                )}
              </div>
              <div className="rdv-actions">
                <button
                  className="btn btn-sm btn-outline-primary me-1"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEditRendezvous(rdv);
                    setShowMedecinRdvs(false);
                    setShowMedecinRdvModal(false);
                  }}
                  title="Modifier"
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (
                      window.confirm(
                        "Êtes-vous sûr de vouloir supprimer ce rendez-vous ?"
                      )
                    ) {
                      handleDeleteRendezvous(rdv.id);
                      setShowMedecinRdvs(false);
                    }
                  }}
                  title="Supprimer"
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </div>
            </div>
          )
        )}
      <div className="text-center mt-3">
        <button
          className="btn btn-primary"
          onClick={() => {
            resetRdvForm();
            setRdvForm((prev) => ({
              ...prev,
              medecinId: selectedMedecinId,
              date: selectedDate.date.toISOString().split("T")[0],
            }));
            setShowAddForm(true);
            setShowMedecinRdvs(false);
          }}
        >
          <FontAwesomeIcon icon={faPlus} className="me-2" />
          Ajouter un rendez-vous
        </button>
      </div>
    </div>
  </Modal.Body>
  <Modal.Footer>
    <div className="w-100 d-flex justify-content-between align-items-center">
      <div>
        <small className="text-muted">
          <FontAwesomeIcon icon={faExchangeAlt} className="me-1" />
          Glisser-déposer pour échanger des rendez-vous
        </small>
      </div>
      <Button
        variant="secondary"
        onClick={() => setShowMedecinRdvModal(false)}
      >
        Fermer
      </Button>
    </div>
  </Modal.Footer>
  </Modal>
  
  
      {/* Modal pour voir toutes les demandes rapides */}
      <Modal
        show={showQuickRequestsModal}
        onHide={() => setShowQuickRequestsModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FontAwesomeIcon icon={faCalendarPlus} className="me-2" />
            Demandes de rendez-vous rapides
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {quickRequests.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Patient</th>
                    <th>Contact</th>
                    <th>Date souhaitée</th>
                    <th>Heure</th>
                    <th>Motif</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {quickRequests.map((request) => (
                    <tr key={request.id}>
                      <td>
                         {request.nom}
                      </td>
                      <td>
                        <div>{request.telephone}</div>
                        <div>
                          <small>{request.email}</small>
                        </div>
                      </td>
                      <td>{request.dateFormatted}</td>
                      <td>{request.heureRdv}</td>
                      <td>{request.motif || "-"}</td>
                      <td>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          className="me-1"
                          onClick={() => handleRejectQuickRequest(request.id)}
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </Button>
                        <Button
                          variant="outline-success"
                          size="sm"
                          onClick={() => {
                            setSelectedQuickRequest(request);
                            setAssignMedecinModal(true);
                          }}
                        >
                          <FontAwesomeIcon icon={faCheck} />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-center py-4">
              Aucune demande de rendez-vous rapide en attente
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowQuickRequestsModal(false)}
          >
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>
  
      {/* Modal pour assigner un médecin à une demande */}
      <Modal
        show={assignMedecinModal}
        onHide={() => setAssignMedecinModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Assigner un médecin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedQuickRequest && (
            <div>
              <div className="mb-3">
                <h6>Détails de la demande:</h6>
                <p>
                  <strong>Patient:</strong>
                  {selectedQuickRequest.nom}
                </p>
                <p>
                  <strong>Contact:</strong> {selectedQuickRequest.telephone}
                </p>
                {selectedQuickRequest.email && (
                  <p>
                    <strong>Email:</strong> {selectedQuickRequest.email}
                  </p>
                )}
                <p>
                  <strong>Date souhaitée:</strong>{" "}
                  {selectedQuickRequest.dateFormatted}
                </p>
                <p>
                  <strong>Heure souhaitée:</strong>{" "}
                  {selectedQuickRequest.heureRdv}
                </p>
                {selectedQuickRequest.motif && (
                  <p>
                    <strong>Motif:</strong> {selectedQuickRequest.motif}
                  </p>
                )}
              </div>
  
              <Form.Group className="mb-3">
                <Form.Label>Sélectionner un médecin</Form.Label>
                <Form.Select
                  value={selectedMedecinForQuick}
                  onChange={(e) => setSelectedMedecinForQuick(e.target.value)}
                  required
                >
                  <option value="">Choisir un médecin</option>
                  {medecins.map((medecin) => (
                    <option key={medecin.id} value={medecin.id}>
                      Dr. {medecin.nom} - {medecin.specialite}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>
          )}
        </Modal.Body>
  
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setAssignMedecinModal(false)}
          >
            Annuler
          </Button>
          <Button
            variant="primary"
            onClick={handleAcceptQuickRequest}
            disabled={!selectedMedecinForQuick}
          >
            Confirmer le rendez-vous
          </Button>
        </Modal.Footer>
      </Modal>
  
      {/* Modal de prévisualisation des fichiers */}
      <Modal
        show={showFilePreview}
        onHide={() => setShowFilePreview(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{selectedFile?.name || "Prévisualisation"}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          {selectedFile && renderFilePreview(selectedFile)}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowFilePreview(false)}>
            Fermer
          </Button>
          <Button
            variant="primary"
            href={selectedFile?.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faDownload} className="me-2" />
            Télécharger
          </Button>
        </Modal.Footer>
      </Modal>
  
  {/* Modal pour ajouter/modifier un auxiliaire */}
  <Modal 
  show={showAuxiliaireModal} 
  onHide={() => setShowAuxiliaireModal(false)}
  size="lg"
  >
  <Modal.Header closeButton>
    <Modal.Title>
      {currentAuxiliaire ? "Modifier l'auxiliaire" : "Ajouter un auxiliaire"}
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form onSubmit={handleAddAuxiliaire}>
      <div className="row">
        <div className="col-md-6 mb-3">
          <Form.Label>Prénom et Nom</Form.Label>
          <Form.Control
            type="text"
            name="nom"
            value={auxiliaireForm.nom}
            onChange={handleAuxiliaireChange}
            required
          />
        </div>
        <div className="col-md-6 mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            name="email"
            value={auxiliaireForm.email}
            onChange={handleAuxiliaireChange}
            required
          />
        </div>
      </div>
  
      <div className="row">
       
        <div className="col-md-6 mb-3">
          <Form.Label>Téléphone</Form.Label>
          <Form.Control
            type="tel"
            name="telephone"
            value={auxiliaireForm.telephone}
            onChange={handleAuxiliaireChange}
            required
          />
        </div>
        <div className="mb-3">
        <Form.Label>Rôle</Form.Label>
        <Form.Select
          name="role"
          value={auxiliaireForm.role}
          onChange={handleAuxiliaireChange}
          required
        >
          <option value="assistant">Assistant(e) médical(e)</option>
          <option value="secretaire">Secrétaire médical(e)</option>
          <option value="infirmier">Infirmier(ère)</option>
          <option value="autre">Autre</option>
        </Form.Select>
      </div>
      </div>
  
     
  
      <div className="mb-3">
        <Form.Label>Médecins assignés</Form.Label>
        <div className="border rounded p-3" style={{ maxHeight: '200px', overflowY: 'auto' }}>
          {medecins.map((medecin) => (
            <Form.Check
              key={medecin.id}
              type="checkbox"
              id={`medecin-${medecin.id}`}
              label={`Dr. ${medecin.nom} - ${medecin.specialite}`}
              checked={auxiliaireForm.medecinIds.includes(medecin.id)}
              onChange={(e) => {
                const { checked } = e.target;
                setAuxiliaireForm(prev => ({
                  ...prev,
                  medecinIds: checked 
                    ? [...prev.medecinIds, medecin.id]
                    : prev.medecinIds.filter(id => id !== medecin.id)
                }));
              }}
              className="mb-2"
            />
          ))}
        </div>
      </div>
  
      <div className="mb-3">
        <Form.Label>Permissions</Form.Label>
        <div className="border rounded p-3">
          <Form.Check
            type="switch"
            id="permission-patients"
            label="Ajouter des patients"
            checked={auxiliaireForm.permissions.ajouterPatients}
            onChange={(e) => {
              setAuxiliaireForm(prev => ({
                ...prev,
                permissions: {
                  ...prev.permissions,
                  ajouterPatients: e.target.checked
                }
              }));
            }}
            className="mb-2"
          />
          <Form.Check
            type="switch"
            id="permission-rdv"
            label="Ajouter des rendez-vous (jour actuel uniquement)"
            checked={auxiliaireForm.permissions.ajouterRendezVous}
            onChange
            ={(e) => {
              setAuxiliaireForm(prev => ({
                ...prev,
                permissions: {
                  ...prev.permissions,
                  ajouterRendezVous: e.target.checked
                }
              }));
            }}
            className="mb-2"
          />
          <Form.Check
            type="switch"
            id="permission-voir-rdv"
            label="Voir tous les rendez-vous"
            checked={auxiliaireForm.permissions.voirTousLesRendezVous}
            onChange={(e) => {
              setAuxiliaireForm(prev => ({
                ...prev,
                permissions: {
                  ...prev.permissions,
                  voirTousLesRendezVous: e.target.checked
                }
              }));
            }}
          />
        </div>
      </div>
  
      {/* Nouvelle section pour les horaires de travail */}
      <div className="mb-3">
        <Form.Label>
          <FontAwesomeIcon icon={faClock} className="me-2" />
          Horaires de travail
        </Form.Label>
        <div className="border rounded p-3">
          <div className="alert alert-info mb-3">
            <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
            L'auxiliaire ne pourra se connecter et utiliser l'application que pendant ces horaires.
          </div>
          <div className="table-responsive">
            <table className="table table-sm">
              <thead>
                <tr>
                  <th style={{width: "20%"}}>Jour</th>
                  <th style={{width: "20%"}}>Travaille</th>
                  <th style={{width: "30%"}}>Heure de début</th>
                  <th style={{width: "30%"}}>Heure de fin</th>
                </tr>
              </thead>
              <tbody>
                {['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'].map((jour) => (
                  <tr key={jour}>
                    <td className="align-middle">
                      {jour.charAt(0).toUpperCase() + jour.slice(1)}
                    </td>
                    <td className="align-middle">
                      <Form.Check
                        type="switch"
                        id={`horaire-${jour}`}
                        checked={auxiliaireForm.horaires[jour].actif}
                        onChange={() => handleHoraireChange(jour, "actif")}
                        label={auxiliaireForm.horaires[jour].actif ? "Oui" : "Non"}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="time"
                        size="sm"
                        value={auxiliaireForm.horaires[jour].debut}
                        onChange={(e) => handleHoraireChange(jour, "debut", e.target.value)}
                        disabled={!auxiliaireForm.horaires[jour].actif}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="time"
                        size="sm"
                        value={auxiliaireForm.horaires[jour].fin}
                        onChange={(e) => handleHoraireChange(jour, "fin", e.target.value)}
                        disabled={!auxiliaireForm.horaires[jour].actif}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
  
      {!currentAuxiliaire && (
        <div className="alert alert-info">
          <FontAwesomeIcon icon={faKey} className="me-2" />
          Un mot de passe temporaire sera généré automatiquement et envoyé à l'auxiliaire.
        </div>
      )}
  
      <div className="text-end mt-3">
        <Button
          variant="secondary"
          className="me-2"
          onClick={() => {
            resetAuxiliaireForm();
            setShowAuxiliaireModal(false);
          }}
        >
          Annuler
        </Button>
        <Button variant="primary" type="submit">
          {currentAuxiliaire ? "Mettre à jour" : "Ajouter"}
        </Button>
      </div>
    </Form>
  </Modal.Body>
  </Modal>
  
  {/* Modal de vue détaillée pour les médecins */}
<Modal 
  show={currentView?.type === 'medecin'} 
  onHide={() => setCurrentView(null)}
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title>
      Détails du médecin - {currentView?.data?.titre || "Dr"} {currentView?.data?.nom}
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {currentView?.data && (
      <div>
        {/* Informations de base */}
        <div className="mb-4">
          <h5 className="border-bottom pb-2 mb-3">Informations générales</h5>
          <div className="row">
            <div className="col-md-6">
              <p><strong>Titre:</strong> {currentView.data.titre || "Dr"}</p>
              <p><strong>Nom:</strong> {currentView.data.nom}</p>
              <p><strong>Spécialité:</strong> {currentView.data.specialite}</p>
            </div>
            <div className="col-md-6">
              <p><strong>Téléphone:</strong> 
                <a href={`tel:${currentView.data.telephone}`} className="ms-2">
                  {currentView.data.telephone}
                </a>
              </p>
              <p><strong>Email:</strong> 
                <a href={`mailto:${currentView.data.email}`} className="ms-2">
                  {currentView.data.email}
                </a>
              </p>
              <p><strong>Consultations à domicile:</strong> {currentView.data.consultationDomicile ? "Oui" : "Non"}</p>
            </div>
          </div>
        </div>

        {/* Disponibilités */}
        <div className="mb-4">
          <h5 className="border-bottom pb-2 mb-3">Disponibilités</h5>
          <div className="disponibilites-container">
            {Array.isArray(currentView.data.disponibilites)
              ? currentView.data.disponibilites.map((dispo, index) => {
                  const structure = allStructures.find(s => s.id === dispo.structureId);
                  return (
                    <div key={index} className="mb-2 p-2 border rounded">
                      <div className="fw-bold">{dispo.jour}</div>
                      <div>{dispo.heureDebut} - {dispo.heureFin}</div>
                      {structure && (
                        <div className="small text-primary">
                          <FontAwesomeIcon icon={faClinicMedical} className="me-1" />
                          {structure.nom}
                        </div>
                      )}
                    </div>
                  );
                })
              : Object.entries(currentView.data.disponibilites || {}).map(
                  ([jour, dispo]) =>
                    dispo.actif && dispo.creneaux && dispo.creneaux.map((creneau, idx) => {
                      const structure = allStructures.find(s => s.id === creneau.structureId);
                      return (
                        <div key={`${jour}-${idx}`} className="mb-2 p-2 border rounded">
                          <div className="fw-bold">
                            {jour.charAt(0).toUpperCase() + jour.slice(1)}
                          </div>
                          <div>{creneau.debut} - {creneau.fin}</div>
                          {structure && (
                            <div className="small text-primary">
                              <FontAwesomeIcon icon={faClinicMedical} className="me-1" />
                              {structure.nom}
                            </div>
                          )}
                        </div>
                      );
                    })
                )}
          </div>
        </div>

        {/* Assurances */}
        {currentView.data.assurances && currentView.data.assurances.length > 0 && (
          <div className="mb-4">
            <h5 className="border-bottom pb-2 mb-3">Assurances acceptées</h5>
            <div className="d-flex flex-wrap">
              {currentView.data.assurances.map((assurance, index) => (
                <Badge 
                  bg="success" 
                  className="me-1 mb-1" 
                  key={index}
                >
                  {assurance}
                </Badge>
              ))}
            </div>
          </div>
        )}
      </div>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button 
      variant="outline-primary"
      onClick={() => {
        handleEditMedecin(currentView.data);
        setCurrentView(null);
      }}
    >
      <FontAwesomeIcon icon={faEdit} className="me-2" />
      Modifier
    </Button>
    <Button 
      variant="outline-danger"
      onClick={() => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer ce médecin ?")) {
          handleDeleteMedecin(currentView.data.id);
          setCurrentView(null);
        }
      }}
    >
      <FontAwesomeIcon icon={faTrash} className="me-2" />
      Supprimer
    </Button>
    <Button variant="secondary" onClick={() => setCurrentView(null)}>
      Fermer
    </Button>
  </Modal.Footer>
</Modal>

{/* Modal de vue détaillée pour les patients */}
<Modal 
  show={currentView?.type === 'patient'} 
  onHide={() => setCurrentView(null)}
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title>
      Détails du patient - {currentView?.data?.nom}
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {currentView?.data && (
      <div>
        {/* Informations de base */}
        <div className="mb-4">
          <h5 className="border-bottom pb-2 mb-3">Informations générales</h5>
          <div className="row">
            <div className="col-md-6">
              <p><strong>Nom:</strong> {currentView.data.nom}</p>
              <p><strong>Date de naissance:</strong> {new Date(currentView.data.dateNaissance).toLocaleDateString()}</p>
              <p><strong>Âge:</strong> {formatAge(currentView.data.dateNaissance)}</p>
              </div>
            <div className="col-md-6">
              <p><strong>Téléphone:</strong> 
                <a href={`tel:${currentView.data.telephone}`} className="ms-2">
                  {currentView.data.telephone}
                </a>
              </p>
              <p><strong>Email:</strong> 
                <a href={`mailto:${currentView.data.email}`} className="ms-2">
                  {currentView.data.email}
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Assurances */}
        {currentView.data.assurances && currentView.data.assurances.length > 0 && (
          <div className="mb-4">
            <h5 className="border-bottom pb-2 mb-3">Assurances</h5>
            <div className="d-flex flex-wrap">
              {currentView.data.assurances.map((assurance, index) => (
                <Badge 
                  bg="success" 
                  className="me-1 mb-1" 
                  key={index}
                >
                  {assurance}
                </Badge>
              ))}
            </div>
          </div>
        )}

        {/* Diagnostics */}
        {currentView.data.diagnostics && (
          <div className="mb-4">
            <h5 className="border-bottom pb-2 mb-3">Diagnostics</h5>
            <div className="p-3 bg-light rounded">
              {currentView.data.diagnostics}
            </div>
          </div>
        )}

        {/* Rendez-vous récents */}
        <div className="mb-4">
          <h5 className="border-bottom pb-2 mb-3">Rendez-vous récents</h5>
          {rendezvous.filter(rdv => rdv.patientId === currentView.data.id).length > 0 ? (
            <div className="list-group">
              {rendezvous
                .filter(rdv => rdv.patientId === currentView.data.id)
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .slice(0, 5)
                .map(rdv => (
                  <div 
                    key={rdv.id} 
                    className="list-group-item list-group-item-action"
                  >
                    <div className="d-flex w-100 justify-content-between">
                      <h6 className="mb-1">
                        {new Date(rdv.date).toLocaleDateString()} à {rdv.heure}
                      </h6>
                      <Badge 
                        bg={
                          rdv.statut === 'confirmé' ? 'success' :
                          rdv.statut === 'terminé' ? 'info' :
                          rdv.statut === 'annulé' ? 'danger' : 'warning'
                        }
                      >
                        {rdv.statut}
                      </Badge>
                    </div>
                    <p className="mb-1">
                      <small>
                        <FontAwesomeIcon icon={faUserMd} className="me-1" />
                        {rdv.medecinNom}
                      </small>
                    </p>
                    {rdv.motif && (
                      <small className="text-muted">
                        Motif: {rdv.motif.substring(0, 50)}
                        {rdv.motif.length > 50 ? '...' : ''}
                      </small>
                    )}
                  </div>
                ))
              }
            </div>
          ) : (
            <p className="text-muted">
              Aucun rendez-vous pour ce patient
            </p>
          )}
        </div>
      </div>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button 
      variant="outline-primary"
      onClick={() => {
        handleEditPatient(currentView.data);
        setCurrentView(null);
      }}
    >
      <FontAwesomeIcon icon={faEdit} className="me-2" />
      Modifier
    </Button>
    <Button 
      variant="outline-danger"
      onClick={() => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer ce patient ?")) {
          handleDeletePatient(currentView.data.id);
          setCurrentView(null);
        }
      }}
    >
      <FontAwesomeIcon icon={faTrash} className="me-2" />
      Supprimer
    </Button>
    <Button variant="secondary" onClick={() => setCurrentView(null)}>
      Fermer
    </Button>
  </Modal.Footer>
</Modal>

{/* Modal de vue détaillée pour les auxiliaires */}
<Modal 
  show={currentView?.type === 'auxiliaire'} 
  onHide={() => setCurrentView(null)}
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title>
      Détails de l'auxiliaire - {currentView?.data?.nom}
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {currentView?.data && (
      <div>
        {/* Informations de base */}
        <div className="mb-4">
          <h5 className="border-bottom pb-2 mb-3">Informations générales</h5>
          <div className="row">
            <div className="col-md-6">
              <p><strong>Nom:</strong> {currentView.data.nom}</p>
              <p><strong>Rôle:</strong> {currentView.data.role}</p>
            </div>
            <div className="col-md-6">
              <p><strong>Téléphone:</strong> 
                <a href={`tel:${currentView.data.telephone}`} className="ms-2">
                  {currentView.data.telephone}
                </a>
              </p>
              <p><strong>Email:</strong> 
                <a href={`mailto:${currentView.data.email}`} className="ms-2">
                  {currentView.data.email}
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Permissions */}
        <div className="mb-4">
          <h5 className="border-bottom pb-2 mb-3">Permissions</h5>
          <div className="d-flex flex-wrap">
            {currentView.data.permissions?.ajouterPatients && (
              <Badge bg="success" className="me-1 mb-1">Ajouter des patients</Badge>
            )}
            {currentView.data.permissions?.ajouterRendezVous && (
              <Badge bg="success" className="me-1 mb-1">Ajouter des rendez-vous</Badge>
            )}
            {currentView.data.permissions?.voirTousLesRendezVous && (
              <Badge bg="success" className="me-1 mb-1">Voir tous les rendez-vous</Badge>
            )}
            {!currentView.data.permissions?.ajouterPatients && 
             !currentView.data.permissions?.ajouterRendezVous && 
             !currentView.data.permissions?.voirTousLesRendezVous && (
              <p className="text-muted">Aucune permission spécifique</p>
            )}
          </div>
        </div>

        {/* Médecins assignés */}
        <div className="mb-4">
          <h5 className="border-bottom pb-2 mb-3">Médecins assignés</h5>
          {currentView.data.medecinIds && currentView.data.medecinIds.length > 0 ? (
            <div className="list-group">
              {currentView.data.medecinIds.map((medecinId) => {
                const medecin = medecins.find(m => m.id === medecinId);
                return medecin ? (
                  <div key={medecinId} className="list-group-item">
                    <FontAwesomeIcon icon={faUserMd} className="me-2" />
                    {medecin.titre || "Dr"} {medecin.nom}
                    <span className="text-muted ms-2">({medecin.specialite})</span>
                  </div>
                ) : null;
              })}
            </div>
          ) : (
            <p className="text-muted">Aucun médecin assigné</p>
          )}
        </div>

        {/* Horaires de travail */}
        <div className="mb-4">
          <h5 className="border-bottom pb-2 mb-3">Horaires de travail</h5>
          {currentView.data.horaires && Array.isArray(currentView.data.horaires) && currentView.data.horaires.length > 0 ? (
            <div className="row">
              {currentView.data.horaires.map((horaire, index) => (
                <div key={index} className="col-md-6 mb-2">
                  <div className="p-2 border rounded">
                    <div className="fw-bold">{horaire.jour}</div>
                    <div className="text-muted">{horaire.heureDebut} - {horaire.heureFin}</div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-muted">Aucun horaire défini</p>
          )}
        </div>
      </div>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button 
      variant="outline-primary"
      onClick={() => {
        handleEditAuxiliaire(currentView.data);
        setCurrentView(null);
      }}
    >
      <FontAwesomeIcon icon={faEdit} className="me-2" />
      Modifier
    </Button>
    <Button 
      variant="outline-danger"
      onClick={() => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer cet auxiliaire ?")) {
          handleDeleteAuxiliaire(currentView.data.id);
          setCurrentView(null);
        }
      }}
    >
      <FontAwesomeIcon icon={faTrash} className="me-2" />
      Supprimer
    </Button>
    <Button variant="secondary" onClick={() => setCurrentView(null)}>
      Fermer
    </Button>
  </Modal.Footer>
</Modal>

  
    <style jsx >
      {`
       /* Styles pour la barre de recherche mobile */
  .search-bar-mobile {
  background-color: white;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  }
  
  .search-bar-mobile .input-group {
  position: relative;
  }
  
  .search-bar-mobile .input-group-text {
  background-color: transparent;
  border-right: none;
  }
  
  .search-bar-mobile .form-control {
  border-left: none;
  }
  
  .search-bar-mobile .btn-clear {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  border: none;
  background: transparent;
  padding: 0 10px;
  color: #6c757d;
  z-index: 10;
  }
  
  /* Style pour l'état sans résultats */
  .no-results {
  width: 100%;
  padding: 20px;
  text-align: center;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin: 10px 0;
  }

  /* Styles pour l'en-tête avec indicateur temps réel */
  .content-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
    padding: 1rem 1.5rem;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    border: 1px solid #e9ecef;
  }

  .header-left h2 {
    margin: 0;
    color: #2c3e50;
    font-weight: 600;
  }

  /* Indicateur de statut temps réel */
  .realtime-status {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.5rem;
  }

  .status-indicator {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border-radius: 25px;
    font-size: 0.85rem;
    font-weight: 500;
    transition: all 0.3s ease;
  }

  .status-indicator.connected {
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    color: white;
    box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
  }

  .status-indicator.disconnected {
    background: linear-gradient(135deg, #ffc107 0%, #fd7e14 100%);
    color: white;
    box-shadow: 0 2px 8px rgba(255, 193, 7, 0.3);
  }

  .status-icon {
    font-size: 1rem;
  }

  .status-icon.spinning {
    animation: spin 2s linear infinite;
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  .status-text {
    font-weight: 600;
  }

  .last-update {
    display: block;
    font-size: 0.7rem;
    opacity: 0.8;
    margin-top: 0.2rem;
  }

  .listeners-count {
    display: flex;
    align-items: center;
    gap: 0.3rem;
    font-size: 0.75rem;
    color: #6c757d;
    background: rgba(255,255,255,0.9);
    padding: 0.25rem 0.75rem;
    border-radius: 15px;
    border: 1px solid rgba(0,0,0,0.1);
  }

  /* Responsive pour mobile */
  @media (max-width: 768px) {
    .content-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
    }

    .realtime-status {
      width: 100%;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }

    .status-indicator {
      font-size: 0.8rem;
      padding: 0.4rem 0.8rem;
    }

    .listeners-count {
      font-size: 0.7rem;
      padding: 0.2rem 0.6rem;
         }
   }
   
   .no-results p {
  color: #6c757d;
  margin-bottom: 10px;
  }
  
  
      `}
    </style>
    </div>
  );
  
};

export default StructureDashboard;